var StampedFn = StampedFn || (function (window, document) {
    var _objStampedOptions =
        {
            SERVICE_HOST: {
                svc_loyalty_widget: 'https://stamped.io/api/widgets/loyalty',
                svc_loyalty_engine: 'https://stamped.io/api/v3/loyalty',
                svc_identity: 'https://stamped.io/api/v3/identity',
            },
            DEFAULT_ENDPOINT: window.stamped_ajax_url || '//stamped.io/api',
            SECURE_ENDPOINT: window.stamped_ajax_secure_url || 'https://stamped.io/api',
            metafields: window.mainWidgetMetafields || '',
            exclude_main_css: window.stamped_exclude_main_css || false,
            exclude_font: window.stamped_disable_font || false,
            disable_single_review: window.stamped_disable_review_single || false,
            modal_ugc_image_viewer: window.stamped_modal_ugc_viewer_type || 'image',
            is_preview: window.isStampedLauncherPreview || false,
            is_init_rewards: true,
            is_force_jquery: window.stamped_force_jquery || false,
            is_disable_cache_badge: window.stamped_disable_cache_badge || false,
            is_disable_cache: window.stamped_disable_cache || false,
            referral_code: null,
            is_rewards_code_copy: false,
            is_ignore_submit_error: false,
            rewards_apply_discount_url_format: window.stamped_rewards_apply_discount_url_format || '',
            slick_options: window.stamped_slick_options || {
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                slide: '.stamped-review',
                initialSlide: 0,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            includes_options: {
                rewards_button_js: true,
                rewards_window_js: true
            }
        };

    var hasLoyalty2023 = false;
    var testLoyalty2023 = false;
    var testLoyaltyAccount = "";

    let query = window.location.href.split("?")[1];
    if (query) {
        query = query.split("#")[0];
    }

    if (query) {
        let searchQuery = new URLSearchParams(query);
        if (searchQuery.get("test") === "loyalty2023") {
            console.log('test loyalty 2023 preview');
            testLoyalty2023 = true;
        }
        if (searchQuery.has("testLoyaltyAccount")) {
            console.log('test loyalty 2023 account');
            testLoyaltyAccount = searchQuery.get("testLoyaltyAccount");
        }
    }

    var script;
    var jQueryStamped;
    var isLoading = false;
    var isStarted = false;
    var globalStoreUrl = "";

    window.StampedGlobalOptions = {};
    window.isInitializedStamped = false;

    // UGC variables
    var eleStampedMainWidget, eleStampedBadges = [];
    var arrPhotosUpload = [];
    var arrPhotosLoadedData = [];


    var objFilterMainWidget = {};
    var ID_MAIN_WIDGET = 'div#stamped-main-widget';

    // Rewards variables
    var GLOBAL_REWARDS_DATA = {};

    var $eleWidgetRewards, $baseLauncher, $winLauncher, $btnLauncher, $btnLauncherButton, $btnLauncherClose, $btnLauncherOpen;
    var $frameLauncher, $frameLauncherDoc, $frameWindow, $frameWindowDoc;

    var launcherWidth;
    var cssReset = "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video { margin: 0; padding: 0; border: 0; font-size: 100%; font: inherit; vertical-align: baseline; }";

    function mobileCheck() {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    window.newFormatStringStamped = (_text, args) => {
        let newText = _text;
        if (!newText) {
            return "";
        }
        args.forEach((_val, _index) => {
            newText = newText.replaceAll(`{${_index}}`, _val);
        });
        return newText;
    };

    String.prototype.formatStringStamped = function () {
        var formatted = this;
        for (var i = 0; i < arguments.length; i++) {
            var regexp = new RegExp('\\{' + i + '\\}', 'gi');
            formatted = formatted.replace(regexp, arguments[i]);
        }
        return formatted;
    };

    function checkAccessibilityClick(event) {
        if (event.type === 'click') {
            return true;
        }
        else if (event.type === 'keypress') {
            var code = event.charCode || event.keyCode;
            if ((code === 32) || (code === 13)) {
                return true;
            }
        }
        else {
            return false;
        }
    }

    function copyText(text) {
        var copyElement = document.createElement("span");
        copyElement.appendChild(document.createTextNode(text));
        copyElement.id = 'tempCopyToClipboard';
        document.body.append(copyElement);

        // select the text
        var range = document.createRange();
        range.selectNode(copyElement);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);

        // copy & cleanup
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        copyElement.remove();
    }

    // lazyload
    // CustomEvent micro-polyfill for Internet Explorer
    (function () {
        if (typeof window.CustomEvent === "function") {
            return false;
        }

        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    })();

    // Set the options to make LazyLoad self-initialize
    window.lazyLoadOptionsStamped = {
        elements_selector: ".stamped-lazyload"
    };
    // Listen to the initialization event and get the instance of LazyLoad
    window.addEventListener('LazyLoad::Initialized', function (event) {
        window.LazyLoadStamped = event.detail.instance;
    }, false);
    function _extends() { return (_extends = Object.assign || function (t) { for (var e = 1; e < arguments.length; e++) { var n = arguments[e]; for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]) } return t }).apply(this, arguments) } var LazyLoad = function () {
        "use strict"; var t = "undefined" != typeof window, e = t && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), n = t && "IntersectionObserver" in window, a = t && "classList" in document.createElement("p"), r = { elements_selector: "img", container: e || t ? document : null, threshold: 300, thresholds: null, data_src: "src", data_srcset: "srcset", data_sizes: "sizes", data_bg: "bg", class_loading: "stamped-lazyload-loading", class_loaded: "stamped-lazyload-loaded", class_error: "stamped-lazyload-error", load_delay: 0, auto_unobserve: !0, callback_enter: null, callback_exit: null, callback_reveal: null, callback_loaded: null, callback_error: null, callback_finish: null, use_native: !1 }, o = function (t, e) { var n, a = new t(e); try { n = new CustomEvent("LazyLoad::Initialized", { detail: { instance: a } }) } catch (t) { (n = document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized", !1, !1, { instance: a }) } try { window.dispatchEvent(n) } catch (e) { } }; var s = function (t, e) { return t.getAttribute("data-" + e) }, i = function (t, e, n) { var a = "data-" + e; null !== n ? t.setAttribute(a, n) : t.removeAttribute(a) }, c = function (t) { return "true" === s(t, "was-processed") }, l = function (t, e) { return i(t, "ll-timeout", e) }, u = function (t) { return s(t, "ll-timeout") }, d = function (t, e) { t && t(e) }, f = function (t, e) { t._loadingCount += e, 0 === t._elements.length && 0 === t._loadingCount && d(t._settings.callback_finish) }, _ = function (t) { for (var e, n = [], a = 0; e = t.children[a]; a += 1)"SOURCE" === e.tagName && n.push(e); return n }, v = function (t, e, n) { n && t.setAttribute(e, n) }, g = function (t, e) { v(t, "sizes", s(t, e.data_sizes)), v(t, "srcset", s(t, e.data_srcset)), v(t, "src", s(t, e.data_src)) }, h = { IMG: function (t, e) { var n = t.parentNode; n && "PICTURE" === n.tagName && _(n).forEach(function (t) { g(t, e) }); g(t, e) }, IFRAME: function (t, e) { v(t, "src", s(t, e.data_src)) }, VIDEO: function (t, e) { _(t).forEach(function (t) { v(t, "src", s(t, e.data_src)) }), v(t, "src", s(t, e.data_src)), t.load() } }, m = function (t, e) { var n, a, r = e._settings, o = t.tagName, i = h[o]; if (i) return i(t, r), f(e, 1), void (e._elements = (n = e._elements, a = t, n.filter(function (t) { return t !== a }))); !function (t, e) { var n = s(t, e.data_src), a = s(t, e.data_bg); n && (t.style.backgroundImage = 'url("'.concat(n, '")')), a && (t.style.backgroundImage = a) }(t, r) }, b = function (t, e) { a ? t.classList.add(e) : t.className += (t.className ? " " : "") + e }, p = function (t, e, n) { t.addEventListener(e, n) }, E = function (t, e, n) { t.removeEventListener(e, n) }, y = function (t, e, n) { E(t, "load", e), E(t, "loadeddata", e), E(t, "error", n) }, w = function (t, e, n) { var r = n._settings, o = e ? r.class_loaded : r.class_error, s = e ? r.callback_loaded : r.callback_error, i = t.target; !function (t, e) { a ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\s+)" + e + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "") }(i, r.class_loading), b(i, o), d(s, i), f(n, -1) }, I = function (t, e) { var n = function n(r) { w(r, !0, e), y(t, n, a) }, a = function a(r) { w(r, !1, e), y(t, n, a) }; !function (t, e, n) { p(t, "load", e), p(t, "loadeddata", e), p(t, "error", n) }(t, n, a) }, k = ["IMG", "IFRAME", "VIDEO"], A = function (t, e) { var n = e._observer; O(t, e), n && e._settings.auto_unobserve && n.unobserve(t) }, L = function (t) { var e = u(t); e && (clearTimeout(e), l(t, null)) }, z = function (t, e) { var n = e._settings.load_delay, a = u(t); a || (a = setTimeout(function () { A(t, e), L(t) }, n), l(t, a)) }, O = function (t, e, n) { var a = e._settings; !n && c(t) || (k.indexOf(t.tagName) > -1 && (I(t, e), b(t, a.class_loading)), m(t, e), function (t) { i(t, "was-processed", "true") }(t), d(a.callback_reveal, t), d(a.callback_set, t)) }, N = function (t) { return !!n && (t._observer = new IntersectionObserver(function (e) { e.forEach(function (e) { return function (t) { return t.isIntersecting || t.intersectionRatio > 0 }(e) ? function (t, e) { var n = e._settings; d(n.callback_enter, t), n.load_delay ? z(t, e) : A(t, e) }(e.target, t) : function (t, e) { var n = e._settings; d(n.callback_exit, t), n.load_delay && L(t) }(e.target, t) }) }, { root: (e = t._settings).container === document ? null : e.container, rootMargin: e.thresholds || e.threshold + "px" }), !0); var e }, x = ["IMG", "IFRAME"], C = function (t, e) { return function (t) { return t.filter(function (t) { return !c(t) }) }((n = t || function (t) { return t.container.querySelectorAll(t.elements_selector) }(e), Array.prototype.slice.call(n))); var n }, M = function (t, e) { this._settings = function (t) { return _extends({}, r, t) }(t), this._loadingCount = 0, N(this), this.update(e) }; return M.prototype = { update: function (t) { var n, a = this, r = this._settings; (this._elements = C(t, r), !e && this._observer) ? (function (t) { return t.use_native && "loading" in HTMLImageElement.prototype }(r) && ((n = this)._elements.forEach(function (t) { -1 !== x.indexOf(t.tagName) && (t.setAttribute("loading", "lazy"), O(t, n)) }), this._elements = C(t, r)), this._elements.forEach(function (t) { a._observer.observe(t) })) : this.loadAll() }, destroy: function () { var t = this; this._observer && (this._elements.forEach(function (e) { t._observer.unobserve(e) }), this._observer = null), this._elements = null, this._settings = null }, load: function (t, e) { O(t, this, e) }, loadAll: function () { var t = this; this._elements.forEach(function (e) { A(e, t) }) } }, t && function (t, e) { if (e) if (e.length) for (var n, a = 0; n = e[a]; a += 1)o(t, n); else o(t, e) }(M, window.lazyLoadOptionsStamped), M
    }();

    // timeago
    !function (t, e) { "object" === typeof module && module.exports ? (module.exports = e(), module.exports.default = module.exports) : t.timeagoStamped = e() }("undefined" != typeof window ? window : this, function () { function t(t) { return t instanceof Date ? t : isNaN(t) ? /^\d+$/.test(t) ? new Date(e(t)) : (t = (t || "").trim().replace(/\.\d+/, "").replace(/-/, "/").replace(/-/, "/").replace(/(\d)T(\d)/, "$1 $2").replace(/Z/, " UTC").replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"), new Date(t)) : new Date(e(t)) } function e(t) { return parseInt(t) } function n(t, n, r) { n = p[n] ? n : p[r] ? r : "en"; for (var o = 0, i = t < 0 ? 1 : 0, a = t = Math.abs(t); t >= h[o] && o < m; o++)t /= h[o]; return t = e(t), o *= 2, t > (0 === o ? 9 : 1) && (o += 1), p[n](t, o, a)[i].replace("%s", t) } function r(e, n) { return ((n = n ? t(n) : new Date) - t(e)) / 1e3 } function o(t) { for (var e = 1, n = 0, r = Math.abs(t); t >= h[n] && n < m; n++)t /= h[n], e *= h[n]; return r %= e, r = r ? e - r : e, Math.ceil(r) } function i(t) { return t.dataset.timeagoStamped ? t.dataset.timeagoStamped : a(t, w) } function a(t, e) { return t.getAttribute ? t.getAttribute(e) : t.attr ? t.attr(e) : void 0 } function u(t, e) { return t.setAttribute ? t.setAttribute(_, e) : t.attr ? t.attr(_, e) : void 0 } function c(t) { return a(t, _) } function d(t, e) { this.nowDate = t, this.defaultLocale = e || "en" } function f(t, e) { return new d(t, e) } var s = "second_minute_hour_day_week_month_month".split("_"), l = "".split("_"), p = { en: function (t, e) { if (0 === e) return ["just now", "right now"]; var n = s[parseInt(e / 2)]; return t > 1 && (n += "s"), [t + " " + n + " ago", "in " + t + " " + n] }, zh_CN: function (t, e) { if (0 === e) return ["", ""]; var n = l[parseInt(e / 2)]; return [t + n + "", t + n + ""] } }, h = [60, 60, 24, 7, 365 / 7 / 12, 1], m = 6, w = "datetime", _ = "data-tid", v = {}; return d.prototype.doRender = function (t, e, i) { var a, c = r(e, this.nowDate), d = this; t.innerHTML = n(c, i, this.defaultLocale), v[a = setTimeout(function () { d.doRender(t, e, i), delete v[a] }, Math.min(1e3 * o(c), 2147483647))] = 0, u(t, a) }, d.prototype.formatDateString = function (t, e) { return n(r(t, this.nowDate), e, this.defaultLocale) }, d.prototype.render = function (t, e) { void 0 === t.length && (t = [t]); for (var n = 0, r = t.length; n < r; n++)this.doRender(t[n], i(t[n]), e) }, d.prototype.setLocale = function (t) { this.defaultLocale = t }, f.register = function (t, e) { p[t] = e }, f.cancel = function (t) { var e; if (t) (e = c(t)) && (clearTimeout(e), delete v[e]); else { for (e in v) clearTimeout(e); v = {} } }, f });

    function _init(e, jQ) {
        if (jQ) {
            stampedLog('Using included jQ');
            jQueryStamped = jQ;
            window.jQueryStamped = jQueryStamped;

            stampedLog(jQueryStamped);
        } else {
            stampedLog('Loaded jQ');
            window.jQueryStamped = jQueryStamped;
        }

        if (/msie/.test(window.navigator.userAgent.toLowerCase())) {
            jQueryStamped.support.cors = true;
        }

        if (StampedGlobalOptions.exclude_font != true) {
            jQueryStamped('head')
                .append(jQueryStamped("<link/>", {
                    rel: "stylesheet",
                    href: '//fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap',
                    type: "text/css"
                }));
        }

        // handle all querystring add to localstorage
        var _qsReferralCode = getParameterByName('stamped_referral_code') || getParameterByName('stamped_ref');

        if (_qsReferralCode) {
            _localStorageAdd('stamped_referral_code', { code: _qsReferralCode });
            _objStampedOptions.referral_code = _qsReferralCode;
        }

        // handle all get localstorage assign
        var _localStorageReferral = _localStorageGet('stamped_referral_code');

        if (_localStorageReferral && _localStorageReferral.code) {
            _objStampedOptions.referral_code = _localStorageReferral.code;
        }

        // START
        stampedLog('Library Starting...');

        jQueryStamped.isReady ? _start() : jQueryStamped(document).ready(function () { _start() });

        setTimeout(function () {
            if (!isStarted) {
                stampedLog('Library not started, fallback');
                _start();
            }
        }, 3000);
    };

    function _start() {
        if (!isStarted) {
            stampedLog('Started library');

            triggerEventStamped('stamped:init:starting');

            _startUGC();
            _startRewards();
        }

        isStarted = true;
    }

    function _startUGC() {
        stampedLog('Starting UGC...');

        // create all widget
        // check if div exists, if yes proceed to create the form
        eleStampedMainWidget = jQueryStamped(ID_MAIN_WIDGET);

        // check if main widget already contains html, if not, create the widget by calling api
        if (eleStampedMainWidget.length) {
            _createWidgetForm();
            _createQuestionForm();
            _initPhotoUpload();
            _initKeywordsFilter();
            _initTrimWords();
            _initWidgetType();
            _initReadMoreHandler();

            try {
                if (window.LazyLoadStamped && LazyLoadStamped.update) {
                    LazyLoadStamped.update();
                }
            } catch (e) {

            }

            _initSummaryRatingHandler();
            _initRatingHandler();
            _initTabsHander();
            _initVoteHandler();
            _initShareHandler();
            _initKeywordsHandler();

            jQueryStamped(document).one('stamped:reviews:loaded', function () {
                stampedLog('Main Widget event triggered reload once');

                _createQuestionForm();
                _initPhotoUpload();
                _initKeywordsFilter();
                _initReadMoreHandler();

                // if query string contains "write_review=true"

                var _qsWriteReview = getParameterByName('write_review');

                if (_qsWriteReview) {
                    toggleForm('review');
                }

                // if query string contains "write_question=true"

                var _qsWriteReview = getParameterByName('write_question');

                if (_qsWriteReview) {
                    toggleForm('question');
                }
            });

            jQueryStamped(document).on("stamped:reviews:loaded", function (event) {
                stampedLog('Main Widget event triggered reload');

                // reset the array of loaded photos
                arrPhotosLoadedData = [];

                _initTrimWords();
                _initWidgetType();

                try {
                    if (window.LazyLoadStamped && LazyLoadStamped.update) {
                        LazyLoadStamped.update();
                    }
                } catch (e) {
                }

                triggerAccessibilityMain();
            });
        }

        jQueryStamped(document).one("stamped:launcher:loaded", function (event) {
            var _qsRewardsLauncher = getParameterByName('rewards-launcher');

            jQueryStamped(window).on('hashchange', function () {
                var hash = location.hash;

                if (hash.indexOf('stamped-rewards') >= 0) {
                    _toggleRewardsModal();
                }
            });

            if (_qsRewardsLauncher) {
                if (_qsRewardsLauncher == 'open') {
                    _toggleRewardsModal();
                }

                if (_qsRewardsLauncher.indexOf('view-') > -1) {
                    _toggleRewardsModal(true);
                    _launcherViewLoad(_qsRewardsLauncher);
                }
            }
        });

        _createBadges();

        _createDisplayWidgetsUGC();

        // check querystring unique ID and render in modal

        var stampedReviewId = getParameterByName("stamped_r_id");

        if (stampedReviewId) {
            if (_objStampedOptions.disable_single_review != true) {
                _renderReviewId(stampedReviewId);
            }
        }
    }

    function _startRewards(data) {
        stampedLog('Starting Rewards...');

        var $eleWidgetRewards = jQueryStamped('#stamped-rewards-init');

        if (data && data.customer) {
            stampedLog('Started Rewards with direct data');

            GLOBAL_REWARDS_DATA = data;

            _createRewardsMain();

            return;
        }
        else if (data) {
            stampedLog('Started Rewards with JS data');

            GLOBAL_REWARDS_DATA.customer = data;

            _loadRewardsApi();
        }
        else if ($eleWidgetRewards.length > 0) {
            stampedLog('Started Rewards with div data');

            GLOBAL_REWARDS_DATA.customer = {
                "customerId": $eleWidgetRewards.data('customer-id'),
                "customerEmail": $eleWidgetRewards.data('customer-email'),
                "customerFirstName": $eleWidgetRewards.data('customer-first-name'),
                "customerLastName": $eleWidgetRewards.data('customer-last-name'),
                "customerTags": $eleWidgetRewards.data('customer-tags'),
                "customerLocale": $eleWidgetRewards.data('customer-locale'),
                "totalOrders": 0,
                "totalSpent": $eleWidgetRewards.data('customer-total-spent'),
                "isAcceptMarketing": $eleWidgetRewards.data('customer-accepts-marketing'),
                "authToken": $eleWidgetRewards.data('key-auth')
            }

            _loadRewardsApi();
        }
        else {
            stampedLog('Started Rewards no init customer data');
        }

        if (GLOBAL_REWARDS_DATA && Object.keys(GLOBAL_REWARDS_DATA.customer || {}).length === 0) {
            GLOBAL_REWARDS_DATA.customer = {
                customerId: $eleWidgetRewards.data('customer-id') || (window.__st && window.__st.cid) || (window.meta && window.page && window.meta.page.customerId)
            }
        }
    }

    function _loadRewardsApi() {
        stampedLog('Loading Rewards API init...');

        var _jsonMetafields = _objStampedOptions.metafields || '';
        if (GLOBAL_REWARDS_DATA && GLOBAL_REWARDS_DATA.customer && _jsonMetafields) {
            GLOBAL_REWARDS_DATA.customer.metafields = _jsonMetafields;
        }

        var _dataCustomer = JSON.stringify(GLOBAL_REWARDS_DATA.customer);
        var isTest = _objStampedOptions.is_test;

        // Check to init from Loyalty 1.0 or 2.0
        let loyaltyEndpoint = _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/init?';
        let search = window.StampedGlobalOptions.storeUrl ? encodeURIComponent(window.StampedGlobalOptions.storeUrl) : window.StampedGlobalOptions.sId;
        jQueryStamped.ajax({
            type: 'GET',
            dataType: 'json',
            url: `${_objStampedOptions.SERVICE_HOST.svc_identity}/shop/${search}/check-feature/loyalty2023`,
            success: function (data, status, xhr) {
                if (data.hasFeature || testLoyalty2023) {
                    console.log('Enabling Loyalty 2.0...');
                    hasLoyalty2023 = true;
                    loyaltyEndpoint = `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/launcher?`
                }
                else {
                    hasLoyalty2023 = false;
                    console.log('Enabling Loyalty 1.0...');
                }
            },
            error: function () {
                hasLoyalty2023 = false;
                console.log("Error, default to Loyalty 1.0...");
            }
        }).then(() => {
            const queryParams = {
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                debug: null,
                isTest: isTest,
                isPreview: _objStampedOptions.is_preview,
                referralCode: _objStampedOptions.referral_code
            };

            if (testLoyalty2023) {
                queryParams.testLoyalty2023 = testLoyalty2023;
                if (testLoyaltyAccount) {
                    queryParams.testLoyaltyAccount = testLoyaltyAccount;
                }
            }

            console.log('Loading', loyaltyEndpoint);
            jQueryStamped.ajax({
                type: 'POST',
                url: loyaltyEndpoint + jQueryStamped.param(queryParams),
                xhrFields: {
                    withCredentials: true
                },
                data: _dataCustomer,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                success: function (data, status, xhr) {
                    triggerEventStamped('stamped:rewards:init');
                    GLOBAL_REWARDS_DATA = data;
                    _createRewardsMain();
                }
            });
        });
    }

    function _createRewardsInit() {
        var $eleWidgetRewards = jQueryStamped('#stamped-rewards-init');

        // if element not found, create and append to body

        if (!$eleWidgetRewards.length) {
            var elem = document.createElement('div');
            elem.setAttribute('id', 'stamped-rewards-init');
            document.body.appendChild(elem);
        }

        // Check if shop is Loyalty 2023 and set flag
        let search = window.StampedGlobalOptions.storeUrl ? encodeURIComponent(window.StampedGlobalOptions.storeUrl) : window.StampedGlobalOptions.sId;
        jQueryStamped.ajax({
            type: 'GET',
            dataType: 'json',
            url: `${_objStampedOptions.SERVICE_HOST.svc_identity}/shop/${search}/check-feature/loyalty2023`,
            success: function (data, status, xhr) {
                if (data.hasFeature || testLoyalty2023) {
                    hasLoyalty2023 = true;
                }
                else {
                    hasLoyalty2023 = false;
                }
            },
            error: function () {
                hasLoyalty2023 = false;
                console.log("Error, default to Loyalty 1.0...");
            }
        });
    }

    function _createRewardsMain() {
        _createRewardsInit();

        if (GLOBAL_REWARDS_DATA && GLOBAL_REWARDS_DATA.html) {

            $eleWidgetRewards = jQueryStamped('#stamped-rewards-init');

            $eleWidgetRewards.html(GLOBAL_REWARDS_DATA.html.main);

            // $eleWidgetRewards.fadeIn();
            // add launcher html to iframe
            _buildIframeLauncher();
            _buildIframeWindow();

            _createDisplayWidgetsRewards();
        }
    }

    function _getLoggedInCustomer() {
        return GLOBAL_REWARDS_DATA.customer;
    }

    function _getDataRewards() {
        return GLOBAL_REWARDS_DATA;
    }

    function _toggleRewardsModal(isSkipClose) {
        var isOpen = $baseLauncher.hasClass('opened');
        jQueryStamped('body', $frameWindowDoc).addClass('opened');

        if (!isOpen) {
            setTimeout(function () {
                $baseLauncher.addClass('opened');
            }, 100);
            $btnLauncher.addClass('opened');
            $baseLauncher.fadeIn();
            $btnLauncherClose.addClass('rotateIn');
            $btnLauncherClose.removeClass('rotateOut');
            $btnLauncherOpen.addClass('fadeOut');
            $btnLauncherOpen.removeClass('fadeIn');
            $btnLauncherButton.animate({ width: '40px' }, 0);

            jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc).scrollTop(0);
            jQueryStamped('.stamped-rewards-header', $frameWindowDoc).css('height', 'auto');

            triggerEventStamped('stamped:launcher:opened');

            _apiTrackInteraction('open');
        }
        else {
            if (isSkipClose != true) {
                stampedLog('Func _toggleRewardsModal: var launcherWidth:' + launcherWidth, 1);

                $baseLauncher.removeClass('opened');
                $baseLauncher.fadeOut();
                $btnLauncher.removeClass('opened');
                $btnLauncherClose.removeClass('rotateIn');
                //$btnLauncherClose.addClass('rotateOut');
                $btnLauncherOpen.removeClass('fadeOut');
                $btnLauncherOpen.addClass('fadeIn');
                $btnLauncherButton.animate({ width: launcherWidth + 'px' }, 0);

                setTimeout(function () {
                    _launcherViewLoad('main');
                }, 1000);

                triggerEventStamped('stamped:launcher:closed');
            }
        }
    }

    function _apiTrackInteraction() {
        if (readCookie('stamped-launcher-opened') != 'true') {
            jQueryStamped.ajax({
                type: 'POST',
                url: _objStampedOptions.SECURE_ENDPOINT + '/tracking/event' + '?' + jQueryStamped.param({
                    apiKey: window.StampedGlobalOptions.apiKey,
                    sId: window.StampedGlobalOptions.sId,
                    storeUrl: window.StampedGlobalOptions.storeUrl,
                    source: 'launcher',
                    event: 'open'
                }),
                dataType: 'json',
                success: function (data, status, xhr) {
                    //console.log(data);
                }
            });

            createCookie('stamped-launcher-opened', true, 1);
        }
    }

    function _apiTrackSearch(opts, productId, results) {
        var search = opts.search; // 1
        var customOptions = opts.customOptionTitle ? opts.customOptionTitle + '||' + opts.customOptionValue : ''; // 2
        var topic = opts.topic; // 3

        var text = search || topic || customOptions;

        var type = 1;

        if (customOptions) {
            type = 2
        }

        if (topic) {
            type = 3
        }

        jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/tracking/event' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                event: 'search',
                source: 'm', // main widget
            }),
            data: JSON.stringify({
                source: 'm', // main widget
                sourceId: productId,
                type: type, // 1 = search, 2 = custom form, 3 = topic
                text: text,
                results: results
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data, status, xhr) {
                //console.log(data);
            }
        });
    }

    // Exact replica of _apiRewardRefreshPoints, but using Loyalty 2023 endpoint
    function refreshLoyaltyCustomerPoints(_callbackFn) {
        const queryParams = {
            apiKey: window.StampedGlobalOptions.apiKey,
            sId: window.StampedGlobalOptions.sId,
            storeUrl: window.StampedGlobalOptions.storeUrl
        };

        if (testLoyalty2023) {
            queryParams.testLoyalty2023 = testLoyalty2023;
            if (testLoyaltyAccount) {
                queryParams.testLoyaltyAccount = testLoyaltyAccount;
            }
        }

        jQueryStamped.ajax({
            type: 'POST',
            url: `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/launcher/points?` + jQueryStamped.param(queryParams),
            data: GLOBAL_REWARDS_DATA.customer,
            dataType: 'json',
            success: function (data, status, xhr) {
                setTimeout(function () {
                    jQueryStamped('.stamped-rewards-header-main-points, .stamped-rewards-header-small-points', $frameWindowDoc).html(data.points_current_with_name);
                    jQueryStamped('#label-balance-points', $frameWindowDoc).html(data.points_current_with_name);
                    let $stampedRewardsWidget = jQueryStamped('#stamped-rewards-widget');
                    jQueryStamped('.stamped-rewards-widget-points', $stampedRewardsWidget).html(data.points_current_with_name);
                }, 100);
                if (_callbackFn) {
                    _callbackFn(data);
                }
            }
        });
    }

    function _apiRewardRefreshPoints(callback) {
        jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/points' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl
            }),
            data: GLOBAL_REWARDS_DATA.customer,
            dataType: 'json',
            success: function (data, status, xhr) {
                setTimeout(function () {
                    jQueryStamped('.stamped-rewards-header-main-points, .stamped-rewards-header-small-points', $frameWindowDoc).html(data.points_current_with_name);
                }, 5000);

                if (callback) {
                    callback(data);
                }
            }
        });
    }

    function _apiRewardEarn(opt) {
        opt = opt || {};

        if (!GLOBAL_REWARDS_DATA && !GLOBAL_REWARDS_DATA.customer) {
            console.log('Customer not logged in to create reward activity');
        }

        return jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/add' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                campaignId: opt.campaignId
            }),
            data: GLOBAL_REWARDS_DATA.customer,
            dataType: 'json',
            success: function (data, status, xhr) {
                if (opt.callback) {
                    opt.callback(data, status, xhr);
                }

                // refresh points
                _apiRewardRefreshPoints();

                triggerEventStamped('stamped:rewards:earned', { detail: data });
            }
        });
    }

    function _apiRewardRedeem(opt) {
        opt = opt || {};

        jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/redeem' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                campaignId: opt.campaignId,
                points: opt.points
            }),
            data: GLOBAL_REWARDS_DATA.customer,
            dataType: 'json',
            success: function (result, status, xhr) {
                if (opt.callback) {
                    opt.callback(result);
                }

                // refresh points
                _apiRewardRefreshPoints();

                triggerEventStamped('stamped:rewards:redeemed', { detail: result });
            }
        });
    }

    function _apiRewardRedeemOld(objBtn, data, callback) {
        _setButtonLoadingState(objBtn, 'loading', true);

        data = data || {};

        jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/redeem' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                campaignId: data.campaignId,
                points: data.points
            }),
            data: GLOBAL_REWARDS_DATA.customer,
            dataType: 'json',
            success: function (result, status, xhr) {
                if (data.campaignId) {
                    _setButtonLoadingState(objBtn, 'active', true, 1);
                }

                // refresh points
                _apiRewardRefreshPoints();

                if (callback) {
                    callback(result);
                }
            }
        });
    }

    function _apiRewardBirthdayAdd(opt) {
        opt = opt || {};

        jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/addBirthday?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                dateBirthday: opt.birthday
            }),
            data: GLOBAL_REWARDS_DATA.customer,
            success: function (data, status, xhr) {
                if (opt.callback) {
                    opt.callback();
                }
            }
        });
    }

    function checkLoyalty2023() {
        // Check if shop is Loyalty 2023
        let search = window.StampedGlobalOptions.storeUrl ? encodeURIComponent(window.StampedGlobalOptions.storeUrl) : window.StampedGlobalOptions.sId;
        jQueryStamped.ajax({
            type: 'GET',
            dataType: 'json',
            url: `${_objStampedOptions.SERVICE_HOST.svc_identity}/shop/${search}/check-feature/loyalty2023`,
            success: function (data, status, xhr) {
                if (data.hasFeature || testLoyalty2023) {
                    hasLoyalty2023 = true;
                }
                else {
                    hasLoyalty2023 = false;
                }
            },
            error: function () {
                hasLoyalty2023 = false;
                console.log("Error, default to Loyalty 1.0...");
            }
        });
        return hasLoyalty2023;
    }

    function _buildRewardsCards(type) {
        // compile data
        $wrapperCards.html('');
        jQueryStamped('body', $frameWindowDoc).attr('data-view', type);

        for (var i = 0; i < GLOBAL_REWARDS_DATA.html.cards.length; i++) {
            var _card = GLOBAL_REWARDS_DATA.html.cards[i];
            if (_card && _card.html && type == _card.type) {
                var _eleCard = jQueryStamped(_card.html);
                _eleCard.attr('data-key', _card.key);
                //jQueryStamped('#stamped-rewards-cards', $eleWidgetRewards).append(jQueryStamped(_cardHtml));
                $wrapperCards.append(_eleCard);

                if (type === 'reviews' && checkLoyalty2023()) {
                    // in this case get livw data
                    // and append to the wrapper
                    getReviewRequests();

                }
            }
        }
    }

    function _buildIframeLauncher() {
        $btnLauncher = jQueryStamped('.stamped-rewards-launcher', $eleWidgetRewards);
        $btnLauncherButton = jQueryStamped('.stamped-launcher-button', $eleWidgetRewards);
        $frameLauncher = jQueryStamped('<iframe>');
        var _htmlLauncher = $btnLauncherButton.html();

        stampedLog('Func _buildIframeLauncher: width:' + $btnLauncherButton.width(), 1);
        stampedLog('Func _buildIframeLauncher: outerWidth:' + $btnLauncherButton.outerWidth(), 1);

        launcherWidth = $btnLauncherButton.width() + 40;

        stampedLog('Func _buildIframeLauncher: var launcherWidth:' + launcherWidth, 1);

        $btnLauncherButton.width(launcherWidth);

        $btnLauncherButton.html($frameLauncher);
        $btnLauncher.hide();

        setTimeout(function () {
            $frameLauncherDoc = $frameLauncher[0].contentWindow.document;
            $frameLauncher[0].contentWindow.StampedFn = StampedFn;
            $frameLauncher[0].contentWindow.jQuery = jQuery;
            var $frameBody = jQueryStamped('body', $frameLauncherDoc);
            var $frameHead = jQueryStamped('head', $frameLauncherDoc);
            $frameBody.html(_htmlLauncher);
            $frameBody.append(jQueryStamped('#stamped-rewards-main-css', $eleWidgetRewards).clone());
            $frameHead
                .append(jQueryStamped("<link/>", {
                    rel: "stylesheet",
                    href: '//cdn1.stamped.io/files/rewards-launcher.min.css',
                    type: "text/css"
                }));
            //                 .append(jQueryStamped("<link/>", {
            //                     rel: "stylesheet",
            //                     href: '//s3-us-west-2.amazonaws.com/stamped.io/cdn/fontawesome/css/all.min.css',
            //                     type: "text/css"
            //                 }));

            if (_objStampedOptions.includes_options.rewards_button_js != false) {
                var script = $frameLauncherDoc.createElement("script");
                script.type = "text/javascript";
                script.src = "https://kit.fontawesome.com/c66d4e7704.js";
                script.setAttribute('data-observe-mutations', 'true');
                $frameLauncherDoc.body.appendChild(script);
            }

            $frameHead.append('<style>' + cssReset + ' body { overflow:hidden; } .stamped-launcher-icon-opened { font-family:"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; display:inline-block; width: 100%; margin-top: -2px; text-align:center;}</style>');

            if (mobileCheck()) {
                $frameBody.attr('data-mobile', true);
            }

            $btnLauncherClose = jQueryStamped('.stamped-launcher-icon-closed', $frameBody);
            $btnLauncherOpen = jQueryStamped('.stamped-launcher-icon-opened', $frameBody);
            $btnLauncher.fadeIn();
        }, 0);
    }

    function _buildIframeWindow() {
        $baseLauncher = jQueryStamped('.stamped-rewards-base', $eleWidgetRewards);
        $launcherCss = jQueryStamped('#stamped-rewards-main-css', $eleWidgetRewards).clone();
        $frameWindow = jQueryStamped('<iframe>');
        var _htmlWindow = $baseLauncher.html();
        $baseLauncher.html($frameWindow);
        setTimeout(function () {
            $frameWindowDoc = $frameWindow[0].contentWindow.document;
            $frameWindow[0].contentWindow.StampedFn = StampedFn;
            $frameWindow[0].contentWindow.jQuery = jQuery;
            var $frameBody = jQueryStamped('body', $frameWindowDoc);
            var $frameHead = jQueryStamped('head', $frameWindowDoc);
            $frameBody.html(_htmlWindow);
            $frameBody.append(jQueryStamped('#stamped-rewards-main-css', $eleWidgetRewards).clone());
            $frameHead
                .append(jQueryStamped("<link/>", {
                    rel: "stylesheet",
                    href: '//cdn1.stamped.io/files/rewards-main.min.css',
                    type: "text/css"
                }));

            if (StampedGlobalOptions.exclude_font != true) {
                $frameHead.append(jQueryStamped("<link/>", {
                    rel: "stylesheet",
                    href: '//fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap',
                    type: "text/css"
                }));
            }

            //                 .append(jQueryStamped("<link/>", {
            //                     rel: "stylesheet",
            //                     href: '//s3-us-west-2.amazonaws.com/stamped.io/cdn/fontawesome/css/all.min.css',
            //                     type: "text/css"
            //                 }));

            if (hasLoyalty2023) {
                console.log('Loading new FA css...');
                var _url = "//s3-us-west-2.amazonaws.com/stamped.io/cdn/fontawesome/css/all-6.4.min.css";
                var link = $frameWindowDoc.createElement("link");
                link.rel = "stylesheet";
                link.href = _url;
                $frameWindowDoc.getElementsByTagName("head")[0].appendChild(link);
            } else {
                $frameHead.append('<script>window.FontAwesomeConfig = { searchPseudoElements: true };</script>');
                var script = $frameWindowDoc.createElement("script");
                script.type = "text/javascript";
                script.src = "https://kit.fontawesome.com/c66d4e7704.js";
                script.setAttribute('data-observe-mutations', 'true');
                script.setAttribute('data-search-pseudo-elements', 'true');
                $frameWindowDoc.body.appendChild(script);
            }

            $frameBody.append('<style>' + cssReset + ' .stamped-rewards-window { font-family:"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; }</style>');

            if (mobileCheck()) {
                $frameBody.attr('data-mobile', true);
            }

            if (GLOBAL_REWARDS_DATA.customer && GLOBAL_REWARDS_DATA.customer.customerEmail) {
                $frameBody.attr('data-logged-in', true);
            } else {
                $frameBody.attr('data-logged-in', false);
            }

            if (GLOBAL_REWARDS_DATA.branding == true) {
                $frameBody.attr('data-branding', true);
            }

            $wrapperCards = jQueryStamped('#stamped-rewards-cards', $frameWindowDoc);
            $wrapperViews = jQueryStamped('#stamped-rewards-views', $frameWindowDoc);
            _initEventHandlersRewards();
            // if customer loggedIn, add attribute
            _buildRewardsCards('rewards');

            triggerEventStamped('stamped:launcher:loaded');
        }, 1000);
    }

    function _initEventHandlersRewards() {
        //add event listeners
        //Main close button
        jQueryStamped($frameWindowDoc).on('click', '.stamped-rewards-header-close', function () {
            _toggleRewardsModal();
        });

        jQueryStamped($frameWindowDoc).on('click', '#launcherSendAffiliateInvite', function () {
            let submitButton = jQueryStamped('#launcherSendAffiliateInvite', $frameWindowDoc);
            if (submitButton[0].innerHTML == 'Send more') {
                resetSendAffiliateInvite();
            }
            else {
                sendAffiliateInvite();
            }
        });

        var documentClick;
        jQueryStamped(document).on('touchstart', function () {
            documentClick = true;
        });
        jQueryStamped(document).on('touchmove', function () {
            documentClick = false;
        });
        jQueryStamped(document).on('click touchend', function (e) {
            if (e.type === "click") documentClick = true;
            if (documentClick) {
                if (
                    (
                        e.target.id === "stamped-rewards-init"
                        ||
                        jQueryStamped(e.target).parents("#stamped-rewards-init").length
                        ||
                        jQueryStamped(e.target).parents(".stamped-rewards-base").length
                        ||
                        jQueryStamped(e.target).parents(".stamped-rewards-launcher").length
                        ||
                        jQueryStamped(e.target).parents("#stamped-rewards-widget").length
                    )
                ) {
                }
                else {
                    var $d = jQueryStamped(".stamped-rewards-base", $eleWidgetRewards);
                    var state = $d.hasClass('opened');
                    setTimeout(function () {
                        if (state) {
                            StampedFn.toggleLauncher();
                        }
                    }, 300);
                }
            }
        });

        //Earnings
        jQueryStamped($frameWindowDoc).on('click', '[data-campaign-completed="false"] .stamped-reward-card-button-earn', function () {
            var $campaign = jQueryStamped(this).parent('.stamped-rewards-card-earn');
            var $btn = jQueryStamped(this);

            let campaignId = $campaign.data('campaign-id');
            let campaignEventType = $campaign.data('event-type');

            // Loyalty 2023 behavior only
            if (checkLoyalty2023()) {

                if (campaignEventType === 'celebrateBirthday') {
                    let $birthdayInput = jQueryStamped('.stamped-rewards-birthday-input-holder', $frameWindowDoc);
                    $birthdayInput.show();
                    // check if input has value, if yes save it
                    let _valBirthdayDay = jQueryStamped('.stamped-rewards-birthday-input-holder select.DOBDay option:checked', $frameWindowDoc).val();
                    let _valBirthdayMonth = jQueryStamped('.stamped-rewards-birthday-input-holder select.DOBMonth option:checked', $frameWindowDoc).val();
                    let _valBirthdayYear = jQueryStamped('.stamped-rewards-birthday-input-holder select.DOBYear option:checked', $frameWindowDoc).val();
                    if (_valBirthdayDay && _valBirthdayMonth && _valBirthdayYear) {
                        let dateOfBirth = _valBirthdayYear + '-' + _valBirthdayMonth + '-' + _valBirthdayDay;
                        $btn.addClass('btn-loading');
                        $btn.html('<span class="stamped-button-icon stamped-button-loading"></span>');

                        let storeUrl = window.StampedGlobalOptions.storeUrl;
                        let storeId = window.StampedGlobalOptions.sId;
                        let apiKey = window.StampedGlobalOptions.apiKey;

                        jQueryStamped.ajax({
                            type: 'POST',
                            url: `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/customer/update/date-of-birth?storeUrl=${storeUrl}&sId=${storeId}&apiKey=${apiKey}`,
                            data: {
                                email: GLOBAL_REWARDS_DATA.customer.customerEmail,
                                authToken: GLOBAL_REWARDS_DATA.customer.authToken,
                                dateOfBirth: dateOfBirth
                            },
                            dataType: 'json',
                            success: function (result, status, xhr) {
                                $btn.html('<span class="stamped-button-icon stamped-button-completed"><i class="fa-solid fa-check"></i></span>');
                                $btn.attr('disabled', true);
                                $birthdayInput.hide();
                                $campaign.attr('data-campaign-completed', 'true');
                                $campaign.attr('data-birthday', 'true');
                                GLOBAL_REWARDS_DATA.customer.dateBirthday = true;
                                triggerEarnActivity(campaignId, campaignEventType);
                                triggerEventStamped('stamped:rewards:redeemed', { detail: result });
                            },
                            error: function (result) {
                                // TODO: Actually handle this as an error
                                console.log('Birthday update failed');
                                console.log(result);
                            }
                        });

                    }
                    return;
                }

                $btn.addClass('btn-loading');
                $btn.html('<span class="stamped-button-icon stamped-button-loading"></span>');
                const earnCallbackFn = function () {
                    setTimeout(function () {
                        $btn.removeClass('btn-loading');
                        $btn.addClass('stamped-button-disabled');
                        $btn.hide();
                    }, 200);
                };
                const errorCallbackFn = function () {
                    $btn.removeClass('btn-loading');
                    $btn.addClass('stamped-button-disabled');
                    $btn.hide();
                }
                triggerEarnActivity(campaignId, campaignEventType, earnCallbackFn, errorCallbackFn);
                return;
            }

            // Birthday
            if (campaignEventType == 'AccountBirthday') {
                // show input
                var $birthdayInput = jQueryStamped('.stamped-rewards-birthday-input-holder', $frameWindowDoc);
                $birthdayInput.show();

                // check if input has value, if yes save it
                var _valBirthdayDay = jQueryStamped('.stamped-rewards-birthday-input-holder select.DOBDay option:checked', $frameWindowDoc).val();
                var _valBirthdayMonth = jQueryStamped('.stamped-rewards-birthday-input-holder select.DOBMonth option:checked', $frameWindowDoc).val();
                var _valBirthdayYear = jQueryStamped('.stamped-rewards-birthday-input-holder select.DOBYear option:checked', $frameWindowDoc).val();

                if (_valBirthdayDay && _valBirthdayMonth && _valBirthdayYear) {
                    _setButtonLoadingState($btn, 'loading', true);

                    var dob = _valBirthdayYear + '-' + _valBirthdayMonth + '-' + _valBirthdayDay;

                    _rewardsTriggerEarn({
                        campaignId: campaignId,
                        campaignEventType: campaignEventType,
                        birthday: dob,
                        callback: function () {
                            _setButtonLoadingState($btn, 'active', true, null, function () {
                                $campaign.attr('data-campaign-completed', 'true');
                                $campaign.attr('data-birthday', 'true');

                                _loadRewardsApi();

                            });

                            $birthdayInput.hide();
                        }
                    });
                }
            } else if (campaignEventType == 'Review' || campaignEventType == 'ReviewPhoto' || campaignEventType == 'ReviewVideo') {
                _launcherToggleTab('reviews');
                _launcherViewLoad('main');
            } else {
                _setButtonLoadingState($btn, 'loading', true);

                _rewardsTriggerEarn({
                    campaignId: campaignId,
                    campaignEventType: campaignEventType,
                    callback: function () {
                        _setButtonLoadingState($btn, 'active', true, null, function () {
                            $campaign.attr('data-campaign-completed', 'true');
                        });
                    }
                });
            }
        });

        //Spendings
        jQueryStamped($frameWindowDoc).on('click', '[data-campaign-redeemable="true"] .stamped-reward-card-button-spend', function () {
            var $btn = jQueryStamped(this);
            var $parent = $btn.parent('.stamped-rewards-card-spend');
            var campaignId = $parent.data('campaign-id');
            var campaignCouponType = $parent.data('coupon-type');
            if (checkLoyalty2023()) {
                _setButtonLoadingState($btn, 'loading', true);
                let callBackFn = function (data) {
                    let mapped = {};
                    mapped.couponCode = data.code;
                    mapped.title = data.title;
                    _launcherViewLoad('view-coupon', null, mapped);
                    _setButtonLoadingState($btn, 'active', true, 1);
                };

                triggerRedeemActivity(campaignId, campaignCouponType, callBackFn);
                return;
            }

            // open view based on campaignEvent
            if (campaignCouponType == 'Variable') {
                _launcherViewLoad('view-redeem-variable', null, { entityId: campaignId });
            }
            else {
                _setButtonLoadingState($btn, 'loading', true);
                _rewardsTriggerSpend({
                    campaignId: campaignId,
                    callback: function (data) {
                        _launcherViewLoad('view-coupon', null, data.rewardCampaignCoupon);
                        _setButtonLoadingState($btn, 'active', true, 1);
                    }
                });
            }
        });

        //Referral
        jQueryStamped($frameWindowDoc).on('click', '.stamped-reward-referral-platforms button', function () {
            var _href = jQueryStamped(this).attr('href');
            if (_href) {
                _rewardsReferralOpenWindow(_href);
            }
        });

        //Menu

        jQueryStamped($frameWindowDoc).on('click', '.stamped-rewards-header-menu span', function () {
            var _target = jQueryStamped(this).attr('data-target');
            var _current = $wrapperCards.attr('data-target');
            if (_target != _current) {
                $wrapperCards.attr('data-target', _target);
                _buildRewardsCards(_target);

                jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc).scrollTop(0);
                jQueryStamped('.stamped-rewards-header-menu .active', $frameWindowDoc).removeClass('active');
                jQueryStamped(this, $frameWindowDoc).addClass('active');
            }
        });

        jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc).on('scroll', function () {
            var scrollTop = jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc).scrollTop();

            if (scrollTop <= 1) {
                jQueryStamped('.stamped-rewards-background', $frameWindowDoc).height('200px');
                jQueryStamped('.stamped-rewards-header', $frameWindowDoc).height('auto');

                return;
            }

            var _height = jQueryStamped('.stamped-rewards-header-content', $frameWindowDoc).outerHeight() + 15;

            jQueryStamped('.stamped-rewards-header', $frameWindowDoc).css('min-height', '70px');

            var _scroll = 200;
            _scroll = _scroll - scrollTop;
            jQueryStamped('.stamped-rewards-background', $frameWindowDoc).height(_scroll);


            var _scroll2 = _height;
            _scroll2 = _scroll2 - scrollTop;
            jQueryStamped('.stamped-rewards-header', $frameWindowDoc).height(_scroll2);
        });
    }

    function _launcherScrollToView(ele) {
        StampedFn.toggleLauncher(true);
        setTimeout(function () {
            var offset = jQueryStamped(ele, $frameWindowDoc).offset();
            jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc).scrollTop(offset.top - 155);

            stampedLog(jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc));
            stampedLog(offset);
            stampedLog(ele);

        }, 500);
    }

    function _launcherToggleTab(type) {
        if (type == 'reviews') {
            jQueryStamped('.stamped-rewards-header-menu span[data-target="reviews"]', $frameWindowDoc).trigger('click');
        }
    }

    function _launcherViewLoad(viewKey, obj, param, _closeModalCallback = null) {
        //console.log('Switch to ' + viewKey);
        $winLauncher = jQueryStamped('.stamped-rewards-window', $frameWindowDoc);
        jQueryStamped('.stamped-rewards-content-container', $frameWindowDoc).scrollTop(0);
        jQueryStamped('.stamped-rewards-header-nav', $frameWindowDoc).attr('onclick', "StampedFn.loadLauncherView('main');");
        jQueryStamped('body', $frameWindowDoc).attr('data-view', viewKey);

        var viewTitle = jQueryStamped(obj).attr('data-title');

        if ($winLauncher) {
            // animation
            if (viewKey == 'main') {
                $winLauncher.removeClass('stamped-rewards-nav-small');
                $winLauncher.addClass('stamped-rewards-nav-big');
                jQueryStamped('.stamped-rewards-header-main, .stamped-rewards-header-menu', $frameWindowDoc).fadeIn();
                jQueryStamped('.stamped-rewards-header-small', $frameWindowDoc).hide();

                var _height = jQueryStamped('.stamped-rewards-header-content', $frameWindowDoc).outerHeight() + 15;

                jQueryStamped('.stamped-rewards-header', $frameWindowDoc).height(_height);

                jQueryStamped('.stamped-rewards-background', $frameWindowDoc).height('200');

                $wrapperViews.hide();
                $wrapperCards.fadeIn();
            } else {
                var isFoundView = false;
                // loop through all views and get html

                if (param && param.reload == true) {
                    isFoundView = false;
                } else if (viewKey == 'view-redeem-variable') {
                    isFoundView = false;
                } else {
                    for (var i = 0; i < GLOBAL_REWARDS_DATA.html.views.length; i++) {
                        var _view = GLOBAL_REWARDS_DATA.html.views[i];
                        if (_view.key == viewKey) {
                            if (_view.title) {
                                viewTitle = _view.title;
                            }

                            isFoundView = true;
                            _launcherViewChange(_view.html);
                            _launcherViewSetData(viewKey, viewTitle, param);
                        }
                    }
                }

                // if view not found, load from API
                if (!isFoundView) {
                    _launcherViewChange();
                    _launcherViewSetData(viewKey, viewTitle, param);

                    var entityId = null;

                    if (param && param.entityId) {
                        entityId = param.entityId;
                    }

                    var isTest = _objStampedOptions.is_test;

                    // Check if shop is Loyalty 2023
                    let search = window.StampedGlobalOptions.storeUrl ? encodeURIComponent(window.StampedGlobalOptions.storeUrl) : window.StampedGlobalOptions.sId;
                    jQueryStamped.ajax({
                        type: 'GET',
                        dataType: 'json',
                        url: `${_objStampedOptions.SERVICE_HOST.svc_identity}/shop/${search}/check-feature/loyalty2023`,
                        success: function (data, status, xhr) {
                            if (data.hasFeature || testLoyalty2023) {
                                hasLoyalty2023 = true;
                            }
                            else {
                                hasLoyalty2023 = false;
                            }
                        },
                        error: function () {
                            hasLoyalty2023 = false;
                            console.log("Error, default to Loyalty 1.0...");
                        }
                    });

                    var cardViewEndpoint = _objStampedOptions.SECURE_ENDPOINT + '/v2/rewards/cardview';
                    if (hasLoyalty2023) {
                        cardViewEndpoint = `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/templates/cardview`;
                    }

                    let queryParams = {
                        apiKey: window.StampedGlobalOptions.apiKey,
                        sId: window.StampedGlobalOptions.sId,
                        storeUrl: window.StampedGlobalOptions.storeUrl,
                        viewKey: viewKey,
                        entityId: entityId,
                        referralCode: _objStampedOptions.referral_code,
                        isTest: isTest
                    };

                    if (param.query) {
                        // Extend the query with additional parameters
                        queryParams = Object.assign(queryParams, param.query);
                    }

                    if (testLoyalty2023) {
                        queryParams.testLoyalty2023 = testLoyalty2023;
                        if (testLoyaltyAccount) {
                            queryParams.testLoyaltyAccount = testLoyaltyAccount;
                        }
                    }

                    jQueryStamped.ajax({
                        type: 'POST',
                        url: cardViewEndpoint + '?' + jQueryStamped.param(queryParams),
                        data: GLOBAL_REWARDS_DATA.customer,
                        dataType: 'json',
                        success: function (data, status, xhr) {
                            if (data && data.html) {
                                GLOBAL_REWARDS_DATA.html.views.push(data);
                                setTimeout(function () {
                                    var toggleLauncher = false;
                                    if (data.key === 'view-redeem-variable') {
                                        toggleLauncher = true;
                                        if (_closeModalCallback) {
                                            _closeModalCallback();
                                        }
                                    }

                                    _launcherViewChange(data.html, false, toggleLauncher);
                                    _launcherViewSetData(viewKey, data.title || viewTitle, param);
                                }, 1000);
                            } else {
                                // return to main
                                _launcherViewLoad('main');
                            }
                        },
                        error: function () {
                            // return to main
                            _launcherViewLoad('main');
                        }
                    });
                }
            }
        }
    }

    function _launcherViewChange(html, animate, _toggleLauncher) {
        if (!html) {
            $wrapperViews.html('');
            if (!jQueryStamped('.stamped-view-loader', $wrapperViews).length) {
                $wrapperViews.append(jQueryStamped('<div class="stamped-view-loader"></div>'));
            }
            $wrapperViews.addClass('loading');
        } else {
            var _eleView = jQueryStamped(html);
            $wrapperViews.html(_eleView);
            $wrapperViews.removeClass('loading');
        }

        if (animate != false) {
            $winLauncher.addClass('stamped-rewards-nav-small');
            $winLauncher.removeClass('stamped-rewards-nav-big');
            jQueryStamped('.stamped-rewards-header-main, .stamped-rewards-header-menu', $frameWindowDoc).hide();
            jQueryStamped('.stamped-rewards-header-small', $frameWindowDoc).fadeIn();
            $wrapperCards.hide();
            $wrapperViews.fadeIn();
        }

        if (_toggleLauncher) {
            StampedFn.toggleLauncher(true);
        }
    }

    function _launcherMainNavSetTitle(title) {
        jQueryStamped('.stamped-rewards-header-small-title', $frameWindowDoc).text(title);
    }

    function _launcherMainNavSetBack(viewKey, reload) {
        jQueryStamped('.stamped-rewards-header-nav', $frameWindowDoc).attr('onclick', "StampedFn.loadLauncherView('" + viewKey + "', null, { reload: " + (reload || false) + "});");
    }

    function _launcherViewSetData(viewKey, cardTitle, data) {
        var _title = (data ? data.viewTitle : cardTitle) || cardTitle;

        if (viewKey == 'view-coupon') {
            jQueryStamped('.stamped-reward-coupon-code', $wrapperViews).text(data.couponCode);
            jQueryStamped('.stamped-reward-card-title', $wrapperViews).html(data.title);
            _launcherMainNavSetBack('view-your-rewards', true);
        }

        // custom process codes
        if (viewKey == 'view-earnings') {
            if (GLOBAL_REWARDS_DATA && GLOBAL_REWARDS_DATA.customer) {
                // loop and check birthday element exists

                var _sectionBirthday = jQueryStamped('[data-event-type="AccountBirthday"]', $frameWindowDoc);

                if (hasLoyalty2023) {
                    _sectionBirthday = jQueryStamped('[data-event-type="celebrateBirthday"]', $frameWindowDoc);
                }

                if (_sectionBirthday.length) {

                    // check customer object and if birthday already set
                    var _birthday = GLOBAL_REWARDS_DATA.customer.dateBirthday;

                    if (!_birthday) {
                        _sectionBirthday.attr('data-birthday', 'false');

                        _sectionBirthday.prepend(jQueryStamped('.stamped-rewards-birthday-input-holder', $frameWindowDoc));
                    } else {
                        _sectionBirthday.attr('data-birthday', 'true');
                    }
                }
            }
        }

        if (viewKey == 'view-referrals-claim') {
        }

        if (viewKey == 'view-redeem-variable') {
            var selectorRangeInput = '.range-slider__range';
            $selectorInput = jQueryStamped(selectorRangeInput, $wrapperViews);

            if ($selectorInput.length) {
                var formatPoints = $selectorInput.data('format-points');
                var formatPointsName = $selectorInput.data('format-points-name');

                var formatCurrency = $selectorInput.data('currency');
                var campaignPointsMultiplier = $selectorInput.attr('step');
                var campaignDiscountValue = $selectorInput.data('discount-value');

                $selectorInput.on('input', function () {
                    _updateUI();
                });

                jQueryStamped('.stamped-rewards-content-action-button ', $wrapperViews).on('click', function () {
                    _redeem(this);
                });

                function _updateUI() {
                    var valPoints = $selectorInput.val();
                    var totalAmount = (valPoints / campaignPointsMultiplier) * campaignDiscountValue;

                    var formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: formatCurrency,
                    });

                    jQueryStamped('#redeem-points', $wrapperViews).text(formatPoints.formatStringStamped(valPoints, formatPointsName));
                    jQueryStamped('#redeem-amount', $wrapperViews).text(formatter.format(totalAmount));
                }

                function _redeem(objBtn) {
                    var $btn = jQueryStamped(objBtn);

                    var valPoints = $selectorInput.val();
                    var opts = { campaignId: data.entityId, points: valPoints };

                    if (hasLoyalty2023) {
                        _setButtonLoadingState($btn, 'loading', true);
                        triggerRedeemActivity(data.entityId, 'variableDiscount', function (data) {
                            let couponCode = data.code;
                            let couponTitle = data.title;
                            _setButtonLoadingState($btn, 'active', true, 1);
                            _launcherViewLoad('view-coupon', null, { couponCode: couponCode, title: couponTitle, viewTitle: couponTitle });
                        }, null, valPoints);
                        return;
                    }

                    StampedFn.rewardsRedeem(jQueryStamped(objBtn), opts, function (data) {
                        var couponCode = data.rewardCampaignCoupon.couponCode;
                        var couponTitle = data.rewardCampaignCoupon.title;

                        _launcherViewLoad('view-coupon', null, { couponCode: couponCode, title: couponTitle, viewTitle: couponTitle });
                    });
                }

                _updateUI();
            }
        }

        if (_title) {
            _launcherMainNavSetTitle(_title);
        }
    }

    // Loyalty 2023 - Trigger Earn Rule Activity
    function triggerEarnActivity(_activityId, _activityType, _callbackFn = null, _errorCallbackFn = null) {

        const shopId = GLOBAL_REWARDS_DATA.shopId;
        const stampedLoyaltyCustomerId = GLOBAL_REWARDS_DATA.customer.customerId;
        var shopLinks = GLOBAL_REWARDS_DATA.links;

        // If there isn't a customer, redirect to sign up page for now
        if (!stampedLoyaltyCustomerId) {
            window.location.href = shopLinks.signup;
            return;
        }

        window.StampedGlobalOptions.sId = GLOBAL_REWARDS_DATA.shopId; // because why not

        let earnActivity = GLOBAL_REWARDS_DATA.campaigns.earnings.filter(obj => {
            return obj.id === _activityId;
        })[0] || GLOBAL_REWARDS_DATA.campaigns.tierEarnings.filter(obj => {
            return obj.id === _activityId;
        })[0];

        let eventType = '';

        switch (_activityType) {
            case 'facebookLike':
                eventType = 'socials/facebook_like';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'facebookShare':
                eventType = 'socials/facebook_share';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'instagramFollow':
                eventType = 'socials/instagram_follow';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'twitterFollow':
                eventType = 'socials/twitter_follow';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'twitterShare':
                eventType = 'socials/twitter_share';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'youTubeSubscribe':
                eventType = 'socials/youtube_subscribe';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'tikTokFollow':
                eventType = 'socials/tiktok_follow';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'pinterestFollow':
                eventType = 'socials/pinterest_follow';
                window.open(earnActivity.socialLink, '_blank');
                break;
            case 'celebrateBirthday':
                eventType = 'milestones/birthday';
                break;
            case 'subscribeNewsletter':
                eventType = 'subscriptions/newsletter';
                break;
            case 'writeReview':
            case 'uploadVideo':
            case 'uploadPhoto':
                _launcherToggleTab('reviews');
                _launcherViewLoad('main');
                return;
        }

        // TODO: Actually handle this as an error...
        if (!eventType) {
            console.log(`Error: Earn Activity event ${eventType} not matched.`);
            return;
        }

        jQueryStamped.ajax({
            type: 'POST',
            url: `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/customer/transactions`,
            data: {
                event: eventType,
                ruleCorrelationId: _activityId,
                customerId: stampedLoyaltyCustomerId,
                authToken: GLOBAL_REWARDS_DATA.customer.authToken,
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: GLOBAL_REWARDS_DATA.shopId || window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl
            },
            dataType: 'json',
            success: function (result, status, xhr) {
                if (_callbackFn) {
                    _callbackFn(result);
                }

                refreshLoyaltyCustomerPoints();

                triggerEventStamped('stamped:rewards:redeemed', { detail: result });
            },
            error: function (result) {
                // TODO: Actually handle this as an error
                console.log('Error submitting earn event transaction.')
                if (_errorCallbackFn) {
                    _errorCallbackFn();
                }
            }
        });

    }

    function _rewardsTriggerEarn(opt) {
        opt = opt || {};

        var campaignEventType = opt.campaignEventType;

        if (campaignEventType == "AccountBirthday") {
            _apiRewardBirthdayAdd(opt);

        } else if (campaignEventType == 'SocialFollowInstagram'
            || campaignEventType == 'SocialFollowFacebook'
            || campaignEventType == 'SocialShareFacebook'
            || campaignEventType == 'SocialFollowTwitter'
            || campaignEventType == 'SocialShareTwitter'
            || campaignEventType == 'SocialYouTube'
            || campaignEventType == 'SocialFollowTiktok'
            || campaignEventType == 'SocialShareTiktok'
            || campaignEventType == 'SocialFollowPinterest') {

            _apiRewardEarn({
                campaignId: opt.campaignId,
                callback: opt.callback
            });

            var links = GLOBAL_REWARDS_DATA.links;
            if (campaignEventType == 'SocialFollowInstagram') {
                var win = window.open(links.instagram, '_blank');
                win.focus();
            } else if (campaignEventType == 'SocialFollowFacebook') {
                window.open('https://www.facebook.com/plugins/page.php?href=' + links.facebook, '_blank', 'location=yes,height=250,width=340,top=50,left=50,scrollbars=yes,status=yes');
            } else if (campaignEventType == 'SocialShareFacebook') {
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + links.shop, '_blank', 'location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes');
            } else if (campaignEventType == 'SocialFollowTwitter') {
                var win = window.open(links.twitter, '_blank');
                win.focus();
            } else if (campaignEventType == 'SocialShareTwitter') {
                window.open('https://twitter.com/intent/tweet?url=' + links.shop, '_blank', 'location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes');
            } else if (campaignEventType == 'SocialYouTube') {
                window.open(links.youtube, '_blank');
            } else if (campaignEventType == 'SocialFollowTiktok' || campaignEventType == 'SocialShareTiktok') {
                window.open(links.tiktok, '_blank');
            } else if (campaignEventType == 'SocialFollowPinterest') {
                window.open(links.pinterest, '_blank');
            }
        }
    }

    function _rewardsTriggerSpend(opt) {
        opt = opt || {};

        _apiRewardRedeem({
            campaignId: opt.campaignId,
            callback: opt.callback
        });
    }

    // Loyalty 2023 review requests
    function getReviewRequests() {
        let qreCards;
        const storeId = GLOBAL_REWARDS_DATA.shopId || window.StampedGlobalOptions.sId;
        const apiKey = window.StampedGlobalOptions.apiKey;
        const url = `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/customer/product-reviews?sId=${storeId}&apiKey=${apiKey}&customerEmail=${GLOBAL_REWARDS_DATA.customer.customerEmail}`
        const stampedLoyaltyCustomerId = GLOBAL_REWARDS_DATA.customer.customerId;

        $wrapperCards.addClass('btn-loading');
        $wrapperCards.append('<span class="stamped-button-icon stamped-button-loading" style="width: 20em; height: 20em;"></span>');

        // If there isn't a customer, redirect to sign up page for now
        if (!stampedLoyaltyCustomerId) {
            window.location.href = shopLinks.signup;
            return;
        }

        jQueryStamped.ajax({
            type: 'GET',
            url: url,
            dataType: 'json',
            success: function (result, status, xhr) {

                $wrapperCards.removeClass('btn-loading');
                $wrapperCards.find(".stamped-button-icon").remove();

                for (i = 0; i < result.length; i++) {
                    const qreCard = jQueryStamped(result[i]);
                    qreCard.attr('data-key', 'card-orders');
                    $wrapperCards.append(qreCard);
                }
            },
            error: function (result) {
                console.log('Error retrieving review requests.')
            }
        });
    }

    function showCardError(message) {
        jQueryStamped('.stamped-reward-card-error', $frameWindowDoc).text(message);
    }

    // Loyalty 2023
    function triggerRedeemActivity(_activityId, _activityType, _callbackFn = null, _errorCallbackFn = null, _points = null, _closeModalCallback = null) {
        const shopId = GLOBAL_REWARDS_DATA.shopId;
        const stampedLoyaltyCustomerId = GLOBAL_REWARDS_DATA.customer.customerId;

        // If there isn't a customer, redirect to sign up page for now
        if (!stampedLoyaltyCustomerId) {
            window.location.href = shopLinks.signup;
            return;
        }
        window.StampedGlobalOptions.sId = GLOBAL_REWARDS_DATA.shopId; // because why not
        let spendActivity = GLOBAL_REWARDS_DATA.campaigns.spendings.filter(obj => {
            return obj.id === _activityId;
        })[0] || GLOBAL_REWARDS_DATA.campaigns.tierSpendings.filter(obj => {
            return obj.id === _activityId;
        })[0];

        let eventType = '';
        switch (_activityType) {
            case 'freeShipping':
            case 'rechargeFreeShipping':
                eventType = 'redeem/shipping';
                break;
            case 'giftCard':
                eventType = 'redeem/gift_card';
                break;
            case 'posPercentageOff':
                eventType = 'redeem/percentage_pos';
                break;
            case 'percentageOffDiscount':
            case 'rechargePercentageOffDiscount':
                eventType = 'redeem/percentage';
                break;
            case 'posFixedAmountDiscount':
                eventType = 'redeem/fixed_pos';
                break;
            case 'fixedAmountDiscount':
            case 'rechargeFixedAmountDiscount':
                eventType = 'redeem/fixed';
                break;
            case 'variableDiscount':
            case 'rechargeVariableDiscount':
                eventType = 'redeem/variable';
                break;
            case 'freeProduct':
                eventType = 'redeem/product';
                break;
            case 'storeCredit':
                eventType = 'redeem/store_credit';
                break
        }

        // TODO: Actually handle this as an error...
        if (!eventType) {
            console.log(`Error: Spend Activity event ${eventType} not matched.`);
            return;
        }

        if(eventType === 'redeem/variable' && !_points) {
            _launcherViewLoad('view-redeem-variable', null, { entityId: _activityId }, _closeModalCallback);
            return;
        }

        jQueryStamped.ajax({
            type: 'POST',
            url: `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/customer/transactions`,
            data: {
                event: eventType,
                ruleCorrelationId: spendActivity.ruleCorrelationId,
                points: _points,
                customerId: stampedLoyaltyCustomerId,
                authToken: GLOBAL_REWARDS_DATA.customer.authToken,
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: GLOBAL_REWARDS_DATA.shopId || window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl
            },
            dataType: 'json',
            success: function (result, status, xhr) {
                refreshLoyaltyCustomerPoints(function(newPoints) {
                    if (_callbackFn) {
                        _callbackFn(result, newPoints);
                    }
                });

                triggerEventStamped('stamped:rewards:redeemed', {
                    detail: {
                        customerId: result.customerId,
                        event: result.event,
                        code: result.code,
                        title: result.title,
                        rewardCampaignCoupon: {
                            couponCode: result.code
                        }
                    }
                });
            },
            error: function (result) {
                // TODO: Actually handle this as an error
                console.log('Error submitting spend event transaction.')

                if (_errorCallbackFn) {
                    _errorCallbackFn();
                }
            }
        });
    }

    function applyCouponToSubscription(_addressId, _rewardId, _callbackFn = null, _errorCallbackFn = null) {
        const shopId = GLOBAL_REWARDS_DATA.shopId;
        const stampedLoyaltyCustomerId = GLOBAL_REWARDS_DATA.customer.customerId;
        var shopLinks = GLOBAL_REWARDS_DATA.links;
        
        // If there isn't a customer, redirect to sign up page for now
        if (!stampedLoyaltyCustomerId) {
            window.location.href = shopLinks.signup;
            return;
        }
        window.StampedGlobalOptions.sId = GLOBAL_REWARDS_DATA.shopId; // because why not

        jQueryStamped.ajax({
            type: 'POST',
            url: `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/subscription/discount`,
            data: {
                addressId: _addressId,
                rewardId: _rewardId,
                customerId: stampedLoyaltyCustomerId,
                authToken: GLOBAL_REWARDS_DATA.customer.authToken,
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: GLOBAL_REWARDS_DATA.shopId || window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl
            },
            dataType: 'json',
            success: function (result, status, xhr) {
                if (_callbackFn) {
                    _callbackFn();
                }
            },
            error: function (result) {
                if (_errorCallbackFn) {
                    _errorCallbackFn();
                }
            }
        });
    }
    
    function _rewardsReferralOpenWindow(href) {
        window.open(href, '_blank', 'location=yes,height=500,width=500,top=50,left=50,scrollbars=yes,status=yes');
    }

    function _rewardsApplyCode_setState(state) {
        var $btn = jQueryStamped('#stamped-rewards-apply-code', $frameWindowDoc);

        if (state == 'active') {
            jQueryStamped('.stamped-rewards-coupons-view', $frameWindowDoc).attr('data-applied', 'true');
        }

        _setButtonLoadingState($btn, state); // loading, active
    }

    function _showCardError(message) {
        jQueryStamped('.stamped-reward-card-error', this.document).text(message);
        jQueryStamped('.stamped-reward-card-error', $frameWindowDoc).text(message);
    }

    function _rewardsCopyReferralCode() {
        var $btn = jQueryStamped('.stamped-reward-referral-wrapper .stamped-reward-copy-icon', $frameWindowDoc);

        var code = GLOBAL_REWARDS_DATA.customer.urlReferral;

        copyText(code);

        var original = $btn.html();

        $btn.html('<div style="padding: 16px"><i class="far fa-check"></i></div>');

        setTimeout(function () {
            $btn.html(original);
        }, 3000);
    }

    function _rewardsApplyCode(opts) {
        $btn = jQueryStamped('#stamped-rewards-apply-code', $frameWindowDoc);

        var couponCode = (opts && opts.code) || jQueryStamped('.stamped-reward-coupon-code', $frameWindowDoc).text();
        var btnText = $btn.text();
        var btnType = $btn.data('type');

        var links = GLOBAL_REWARDS_DATA.links;
        _rewardsApplyCode_setState('loading');

        var isCopyCode = _objStampedOptions.is_rewards_code_copy || btnText.indexOf('Copy') > -1 || btnType == 'copy';

        // This is terrible... For certain shops, do not allow "Apply to Checkout", and default to copying to clipboard
        if (
            GLOBAL_REWARDS_DATA.shopId === 337965 ||
            GLOBAL_REWARDS_DATA.shopId === 331099 ||
            GLOBAL_REWARDS_DATA.shopId === 331100
        ) {
            isCopyCode = true;
        }

        triggerEventStamped('stamped:rewards:coupon:applied', { detail: couponCode });

        if (isCopyCode == true) {
            var text = couponCode;

            copyText(text);

            _rewardsApplyCode_setState('active');

        } else {
            couponCode = encodeURIComponent(couponCode); // Shopify needs coupon encoded

            let _url;

            if (GLOBAL_REWARDS_DATA.shopId === 291456) {
                jQueryStamped.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    //dataType: 'json',
                    //async: false,
                    data: {
                        cart_level_discount_applications: [couponCode],
                    },
                    success: function (res) {
                        console.log("Discount code applied. ", res);
                        _rewardsApplyCode_setState('active');
                    },
                    error: function (res) {
                        console.log("Error while applying discount code. ", res);
                        _rewardsApplyCode_setState('active');
                    }
                });

                return {
                    code: couponCode,
                    setState: _rewardsApplyCode_setState
                }

            } else if (GLOBAL_REWARDS_DATA.shopId === 67527 || GLOBAL_REWARDS_DATA.shopId === 291474 || GLOBAL_REWARDS_DATA.shopId === 9628) {
                // redirect / checkout vs old way of doing things
                _url = `${links.shop}/discount/${couponCode}?redirect=/checkout`;
            } else {
                // keep the old way for other stores for now
                _url = links.shop + '/checkout?discount=' + couponCode;
            }

            var _method = 'GET';
            var _data = {};

            if (_objStampedOptions.rewards_apply_discount_url_format) {
                _url = rewards_apply_discount_url_format.replace('{0}', couponCode);
            }

            if (!opts || !opts.skip) {
                jQueryStamped.ajax({
                    type: _method,
                    url: _url,
                    data: _data,
                    success: function (data, status, xhr) {
                        _rewardsApplyCode_setState('active');
                    },
                    error: function (data, status, xhr) {
                        _rewardsApplyCode_setState('active');
                    }
                });
            }
        }

        return {
            code: couponCode,
            setState: _rewardsApplyCode_setState,
            showError: _showCardError
        }
    }

    // Loyalty 2023
    function sendAffiliateInvite() {
        let inputTo = jQueryStamped('#email-to', $frameWindowDoc);
        let inputMessage = jQueryStamped('#email-message', $frameWindowDoc);
        let submitButton = jQueryStamped('#launcherSendAffiliateInvite', $frameWindowDoc);

        let emails = inputTo.val();
        let inviteMessage = inputMessage.val();
        let options = StampedFn.getOptions();

        if(!emails) {
            return;
        }
        _setButtonLoadingState(submitButton, 'loading', true);

        // Check if there are multiple emails, and separate them
        let emailArray = emails.split(",").map(function (value) {
            return value.trim();
        });
        let storeId = GLOBAL_REWARDS_DATA.shopId || window.StampedGlobalOptions.sId;
        let apiKey = window.StampedGlobalOptions.apiKey;
        let sendInviteUrl = `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/customer/affiliate/send-invite?sId=${storeId}&apiKey=${apiKey}`;

        let requests = emailArray.map((email) => {
            return new Promise((resolve, reject) => {
                jQueryStamped.ajax({
                    type: 'POST',
                    url: sendInviteUrl,
                    data: {
                        to: email,
                        from: GLOBAL_REWARDS_DATA.customer.customerEmail,
                        customMessage: inviteMessage
                    },
                    success: function (data) {
                        resolve(data)
                    },
                    error: function (data) {
                        var error = data.responseJSON ? data.responseJSON.message : data.responseText ? JSON.parse(data.responseText).message : 'Error: Cannot send email.';
                        reject(error);
                    }
                });
            });
        });

        Promise.all(requests)
            .then((response) => {
                jQueryStamped('.stamped-reward-card-success', $frameWindowDoc).show();
            })
            .catch((error) => {
                jQueryStamped('#email-to', $frameWindowDoc).css('border-color','#FF5656');
                jQueryStamped('.stamped-reward-card-error', $frameWindowDoc).text(error);
            });

        setTimeout(function () {
            submitButton.css('width','fit-content');
            submitButton.html('Send more');
            submitButton.removeClass('stamped-button-disabled');
        }, 1000);
    }

    function resetSendAffiliateInvite() {
        let inputTo = jQueryStamped('#email-to', $frameWindowDoc);
        let errorMessage = jQueryStamped('.stamped-reward-card-error', $frameWindowDoc);
        let inputMessage = jQueryStamped('#email-message', $frameWindowDoc);
        let successMessage = jQueryStamped('.stamped-reward-card-success', $frameWindowDoc);
        let submitButton = jQueryStamped('#launcherSendAffiliateInvite', $frameWindowDoc);
        let txtOriginal = submitButton.attr('data-original-text');

        inputTo.val('');
        inputTo.css('border-color','#E8E8EB');
        errorMessage.text('');
        inputMessage.val('');
        successMessage.hide();
        submitButton.html(txtOriginal);
    }

    function _rewardsReferralSendEmail(_btn) {
        var $inputTo = jQueryStamped('#email-to', $frameWindowDoc);
        var $inputMessage = jQueryStamped('#email-message', $frameWindowDoc);
        var $btn = jQueryStamped(_btn);

        var _email = $inputTo.val();
        var _message = $inputMessage.val();
        var _options = StampedFn.getOptions();

        if (!_email) { return; }

        _setButtonLoadingState($btn, 'loading', true);

        jQueryStamped.ajax({
            type: 'POST',
            url: _options.SECURE_ENDPOINT + '/v2/rewards/referral/send' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                fromEmail: GLOBAL_REWARDS_DATA.customer.customerEmail,
                toEmail: _email,
                message: _message,
                debug: null
            }),
            data: {},
            success: function (data, status, xhr) {

            },
            error: function (data) {

            },
            complete: function () {
                _setButtonLoadingState($btn, 'active', false, 30000);
            }
        });
    }

    function claimAffiliateProgramReward() {
        let emailInput = jQueryStamped('#referral_claim_email', $frameWindowDoc);
        let claimButton = jQueryStamped('#stamped-rewards-claim-code', $frameWindowDoc);

        let email = emailInput.val();
        // Get code from query
        let params = {};
        window.location.search
            .replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str,key,value) {
                    params[key] = value;
                }
            );

        const referralCode = params.stamped_referral_code;

        if(!email || !referralCode) return;
        _setButtonLoadingState(claimButton, 'loading', true);
        let storeId = GLOBAL_REWARDS_DATA.shopId || window.StampedGlobalOptions.sId;
        let apiKey = window.StampedGlobalOptions.apiKey;

        let claimUrl = `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/customer/affiliate/claim-reward?sId=${storeId}&apiKey=${apiKey}`

        jQueryStamped.ajax({
            type: 'POST',
            url: claimUrl,
            data: {
                claimedBy: email,
                referralCode: referralCode
            },
            dataType: 'json',
            success: function (data, status, xhr) {
                _launcherViewLoad('view-coupon', null, { couponCode: data.couponCode, title: 'Your Rewards', viewTitle: 'Your Reward' });
            },
            error: function (data) {
                let error = data.responseJSON ? data.responseJSON.message : data.responseText ? JSON.parse(data.responseText).message : 'You are not eligible for the reward.';
                jQueryStamped('.stamped-reward-card-error', $frameWindowDoc).text(error);
            },
            complete: function () {
                _setButtonLoadingState(claimButton, 'active', true, 1000);
            }
        });

    }

    function _rewardsReferralClaimCode() {
        var _input = jQueryStamped('#referral_claim_email', $frameWindowDoc);
        var _btn = jQueryStamped('#stamped-rewards-claim-code', $frameWindowDoc);
        var _email = _input.val();

        var _options = StampedFn.getOptions();

        if (!_email) { return; }

        _setButtonLoadingState(_btn, 'loading', true);

        jQueryStamped.ajax({
            type: 'POST',
            url: _options.SECURE_ENDPOINT + '/v2/rewards/referral/claim' + '?' + jQueryStamped.param({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                email: _email,
                referralCode: _options.referral_code,
                debug: null
            }),
            dataType: 'json',
            success: function (data, status, xhr) {
                _launcherViewLoad('view-coupon', null, { couponCode: data.couponCode, title: data.title, viewTitle: data.title });
            },
            error: function (data) {
                var error = data.responseJSON ? data.responseJSON.message : data.responseText ? JSON.parse(data.responseText).message : 'You are not eligible for the reward.';
                jQueryStamped('.stamped-reward-card-error', $frameWindowDoc).text(error);
            },
            complete: function () {
                _setButtonLoadingState(_btn, 'active', true, 1000);
            }
        });
    }

    function _rewardsLink(type) {
        var links = GLOBAL_REWARDS_DATA.links;

        if (type == 'login') {
            top.location.href = links.login;
        } else if (type == 'signup') {
            top.location.href = links.signup;
        }
    }

    function _setButtonLoadingState($btn, state, isHideCompleted, delay, callback) {
        if (state == 'loading') {
            var _width = ($btn.width());
            $btn.attr('data-original-text', $btn.text());
            $btn.addClass('stamped-button-disabled');
            if (_width >= 10) {
                $btn.width(_width);
            }
            $btn.html('<span class="stamped-button-icon stamped-button-loading"></span>');
        } else {
            if (!isHideCompleted) {
                $btn.html('<span class="stamped-button-icon stamped-button-completed"><i class="far fa-check"></i></span>');
            } else {

            }

            setTimeout(function () {
                var txtOriginal = $btn.attr('data-original-text');
                $btn.html(txtOriginal);
                $btn.removeClass('stamped-button-disabled');
                $btn.width('auto');

                if (callback) {
                    callback();
                }
            }, delay || 7878);
        }
    }

    var $slide;
    function _initWidgetType() {
        stampedLog('Func initWidgetType');

        var widgetStyle = jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-style');

        if (widgetStyle == 'slider') {
            $slide = jQueryStamped('.stamped-reviews', eleStampedMainWidget);
            stampedLog($slide, 1);

            var initialized = $slide && $slide.hasClass('slick-initialized');
            stampedLog('Func initWidgetType: var initialized:' + initialized, 1);

            if (initialized) {
                // get all stamped-review without slick-slide
                $slide.slick('slickAdd', jQueryStamped('.stamped-reviews > .stamped-review'));

                var countSlide = jQueryStamped('.stamped-reviews [class*="stamped-review"]', eleStampedMainWidget).length;

                if (countSlide <= 0) {
                    jQueryStamped('button.slick-arrow').hide();
                } else {
                    jQueryStamped('button.slick-arrow').show();
                }

            } else {
                loadJS('//cdn.stamped.io/cdn/js/slick.min.js', function () {
                    $slide.slick(_objStampedOptions.slick_options);

                    $slide.on('afterChange', function (e, slick, cur) {
                        // check button disabled, if yes, load more
                        var isDisabled = jQueryStamped('.slick-next.slick-arrow').hasClass('slick-disabled');

                        if (isDisabled) {
                            _lastSlide = cur;

                            var $next = jQueryStamped('.stamped-pagination .next a');

                            if ($next.length) {
                                $next.click();
                            }
                        }
                    });
                })
            }
        } else if (widgetStyle == 'masonry') {
            var _breakAt = {
                1500: 4,
                1200: 3,
                700: 2,
                500: 2
            };

            var _macy = {
                container: ".stamped-reviews",
                margin: {
                    x: 15,
                    y: 15
                },
                breakAt: _breakAt,
                columns: 4
            };

            if (window.macyInstanceConfig) {
                if (window.macyInstanceConfig.breakAt) {
                    _macy.breakAt = window.macyInstanceConfig.breakAt;
                }

                if (window.macyInstanceConfig.columns) {
                    _macy.columns = window.macyInstanceConfig.columns;
                }
            }

            loadJS('//cdn.stamped.io/cdn/js/macy2.js', function () {
                window.macyInstanceStamped = Macy(_macy);

                triggerEventStamped('stamped:macy:loaded');
            });
        }

        if (jQueryStamped('.stamped-sort-select').length) {
            var sort = eleStampedMainWidget.attr('data-sort') || jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-sort');

            if (sort) {
                var $eleSort = jQueryStamped('.stamped-sort-select option[value="' + sort + '"]');

                if ($eleSort.css('display') && $eleSort.css('display') !== 'none') {
                    jQueryStamped('.stamped-sort-select').val(sort);
                }
            }
        }
    }

    function _createWidgetForm(reload) {
        if (!eleStampedMainWidget || !eleStampedMainWidget.length || reload) {
            eleStampedMainWidget = jQueryStamped(ID_MAIN_WIDGET);
        }

        _loadWidget();
    }

    function _createQuestionForm() {
        stampedLog('Creating Q&A');

        _loadQuestionsAndAnswers();
    }

    function _createBadges() {
        _loadBadges();
    }

    function _createDisplayWidgetsUGC() {
        var _totalElements = jQueryStamped('#stamped-reviews-widget').length;
        stampedLog('Creating display widgets ' + _totalElements + ' found');

        triggerEventStamped('stamped:widget:reloading');

        if (_totalElements > 0) {
            var arrParams = [];
            var numWidget = 1;
            jQueryStamped("[id=stamped-reviews-widget]").each(function (index) {
                //_show_widget(review_url, jQueryStamped(this));
                var objDisplayWidget = jQueryStamped(this);

                objDisplayWidget.attr('data-element-id', numWidget);
                var param = getParamDisplayWidget(objDisplayWidget);
                arrParams.push(param);

                numWidget++;
            });

            loadDataBatchDisplayWidget('ugc', arrParams);
        }
    }

    function _createDisplayWidgetsRewards() {
        var data = GLOBAL_REWARDS_DATA;

        if (data.points) {
            var _points = data.points.points;

            jQueryStamped('[id=stamped-rewards-points-placeholder]').attr('onclick', 'StampedFn.toggleRewardsModal();');

            jQueryStamped('[id=stamped-rewards-points-placeholder]').html(data.points.points_current_with_name);
            jQueryStamped('[id=stamped-rewards-points-placeholder][data-type="points-only"]').html(_points);

            if (data.customer) {
                jQueryStamped('[id=stamped-rewards-viptier-placeholder]').html(data.customer.vipTierTitle);
            }

            var $elePointPrice = jQueryStamped('[id=stamped-rewards-points-placeholder][data-type="points-price"]');

            if ($elePointPrice.length && _points >= 0) {
                var _ratio = $elePointPrice.attr('data-ratio');
                var _symbol = $elePointPrice.attr('data-symbol');

                if (_ratio) {
                    var _num = parseInt(_ratio);

                    if (_num) {
                        var _amount;
                        if (_points > 0) {
                            _amount = (_points / _ratio).toFixed(2);
                        } else {
                            _amount = 0;
                        }

                        $elePointPrice.html(_symbol + _amount);
                    }
                }
            }
        }

        if (data.customer) {
            jQueryStamped('[id=stamped-rewards-referral-placeholder]').html(data.customer.urlReferral);
        }

        if (jQueryStamped('#stamped-rewards-widget').length > 0) {
            var arrParams = [];
            var numWidget = 1;
            jQueryStamped("[id=stamped-rewards-widget]").each(function (index) {
                //_show_widget(review_url, jQueryStamped(this));
                var objDisplayWidget = jQueryStamped(this);

                objDisplayWidget.attr('data-element-id', numWidget);
                var param = getParamDisplayWidget(objDisplayWidget);
                arrParams.push(param);

                numWidget++;
            });

            // Check if shop is Loyalty 2023, and fetch display widgets accordingly
            let search = window.StampedGlobalOptions.storeUrl ? encodeURIComponent(window.StampedGlobalOptions.storeUrl) : window.StampedGlobalOptions.sId;

            jQueryStamped.ajax({
                type: 'GET',
                dataType: 'json',
                url: `${_objStampedOptions.SERVICE_HOST.svc_identity}/shop/${search}/check-feature/loyalty2023`,
                success: function (data, status, xhr) {
                    if(data.hasFeature || testLoyalty2023) {
                        hasLoyalty2023 = true;
                        loadLoyaltyDisplayWidgets(arrParams);
                    }
                    else {
                        loadDataBatchDisplayWidget('rewards', arrParams);
                    }
                },
                error: function() {
                    console.log("Error, default to Loyalty 1.0...");
                    loadDataBatchDisplayWidget('rewards', arrParams);
                }
            });
        }
    }

    function _initTrimWords() {
        var numWords = jQueryStamped(eleStampedMainWidget).attr('data-limit-words') || jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-limit-words');
        var keyword = jQueryStamped(eleStampedMainWidget).attr('data-keyword');
        var search = jQueryStamped(eleStampedMainWidget).attr('data-search');

        if ((numWords && numWords > 0) || keyword || search) {
            jQueryStamped('.stamped-review', eleStampedMainWidget).each(function (index) {
                var _obj = jQueryStamped('.stamped-review-content-body:first', this);
                if (_obj.length) {
                    var txtOriginal = jQueryStamped(_obj).html();

                    if (txtOriginal.indexOf('stamped-review-read-more') <= -1) {
                        if (keyword || search) {
                            var _html;

                            if (keyword) {
                                _html = highlightKeywords(txtOriginal, keyword);
                            }

                            if (search) {
                                _html = highlightKeywords(txtOriginal, search);
                            }

                            jQueryStamped(_obj).html(_html);
                        } else {
                            var contentSpillage = txtOriginal.split(" ");
                            if (contentSpillage.length > numWords) {
                                txtTrimmed = contentSpillage.slice(0, numWords).join(" ") + "...";

                                jQueryStamped(_obj).html(txtTrimmed);
                                jQueryStamped(_obj).append('<a class="stamped-review-read-more" style="margin-left:10px; cursor:pointer;">read more</span>');
                                jQueryStamped(_obj).append('<span class="original-review" style="display:none !important;">' + txtOriginal + '</span>');
                            }
                        }
                    }
                }
            });
        }

        // linkify
        jQueryStamped('.stamped-review-reply .stamped-review-reply-body, .stamped-review-reply .stamped-review-content-body').each(function () {
            if (!jQueryStamped(this).attr("data-link-processed")) {
                jQueryStamped(this).attr('data-link-processed', true);
                var currentHtml = jQueryStamped(this).html();
                jQueryStamped(this).html(currentHtml.linkify());
            }
        });
    }

    function _initKeywordsFilter() {
        // get keywords
        var keywords = jQueryStamped(eleStampedMainWidget).attr('data-keywords');

        if (keywords) {
            // clear keywords list
            jQueryStamped('.stamped-reviews-filter-label').show();
            jQueryStamped('.stamped-summary-keywords').show();
            jQueryStamped(eleStampedMainWidget).removeAttr('data-keywords');
            jQueryStamped('.stamped-summary-keywords-list', eleStampedMainWidget).html('');

            var listKeywords = "";
            var arrKeywords = keywords.split(',');

            for (i = 0; i < arrKeywords.length; i++) {
                listKeywords += "<li>" + arrKeywords[i] + "</li>";
            }

            jQueryStamped(listKeywords).appendTo(jQueryStamped('.stamped-summary-keywords-list', eleStampedMainWidget));
        }
    }

    function _initKeywordsHandler() {
        jQueryStamped(document).on('click keypress', '.stamped-summary-actions-mobile-filter', function (event) {
            if (checkAccessibilityClick(event) === true) {
                var _wrapperFilters = jQueryStamped('.stamped-filters-wrapper');

                if (_wrapperFilters.hasClass("stamped-mobile-visible")) {
                    _wrapperFilters.slideUp();
                    _wrapperFilters.removeClass("stamped-mobile-visible");
                } else {
                    _wrapperFilters.slideDown();
                    _wrapperFilters.addClass("stamped-mobile-visible");
                }
            }
        });

        jQueryStamped(document).on('click keypress', '.stamped-summary-keywords-list li', function (event) {
            if (checkAccessibilityClick(event) === true) {
                var $objSelectedKeyword = jQueryStamped(this);

                if ($objSelectedKeyword.hasClass("selected")) {
                    jQueryStamped('.stamped-summary-keywords-list li').removeClass("selected");
                    jQueryStamped(eleStampedMainWidget).removeAttr('data-keyword');
                } else {
                    jQueryStamped('.stamped-summary-keywords-list li').removeClass("selected");
                    $objSelectedKeyword.addClass("selected");
                    jQueryStamped(eleStampedMainWidget).attr('data-keyword', $objSelectedKeyword.text().trim());
                }

                jQueryStamped('.stamped-summary-actions-clear').show();

                pageReviews(1);
            }
        });

        jQueryStamped(document).on('change keyup', '.stamped-reviews-search-input', function (e) {
            var _inputVal = jQueryStamped(this).val();
            if (!_inputVal) {
                jQueryStamped('.stamped-reviews-search-clear').hide();
                jQueryStamped('.stamped-reviews', eleStampedMainWidget).removeAttr('data-filtered');
            } else {
                jQueryStamped('.stamped-reviews-search-clear').show();
                jQueryStamped('.stamped-reviews', eleStampedMainWidget).attr('data-filtered', 'true');
            }
            if (e.keyCode == 13) {
                var _inputVal = jQueryStamped(this).val();
                if (_inputVal) {
                    jQueryStamped(eleStampedMainWidget).attr('data-search', _inputVal.trim());
                    jQueryStamped('.stamped-summary-actions-clear').show();
                    _clearRatingFilter();
                    pageReviews(1);
                }
            }
        });

        jQueryStamped(document).on('click keypress', '.stamped-reviews-search-button', function (e) {
            if (checkAccessibilityClick(event) === true) {
                var _inputVal = jQueryStamped('.stamped-reviews-search-input').val();
                if (_inputVal) {
                    jQueryStamped(eleStampedMainWidget).attr('data-search', _inputVal.trim());
                    jQueryStamped('.stamped-summary-actions-clear').show();
                    _clearRatingFilter();
                    pageReviews(1);
                }
            }
        });

        jQueryStamped(document).on('click keypress', '.stamped-reviews-search-clear', function (event) {
            if (checkAccessibilityClick(event) === true) {
                jQueryStamped('.stamped-reviews-search-clear').hide();
                jQueryStamped('.stamped-reviews-search-input').val('');
                jQueryStamped(eleStampedMainWidget).removeAttr('data-search');

                pageReviews(1);
            }
        });

        jQueryStamped(document).on('click keypress', '.stamped-summary-actions-clear', function (event) {
            if (checkAccessibilityClick(event) === true) {

                var type = jQueryStamped(this).data('type');

                filterClear(type);
            }
        });

        jQueryStamped(document).on('change keyup', '.stamped-questions-search-input', function (e) {
            var _inputVal = jQueryStamped(this).val();
            if (!_inputVal) {
                jQueryStamped('.stamped-questions-search-clear').hide();
                jQueryStamped('.stamped-questions', eleStampedMainWidget).removeAttr('data-filtered');
            } else {
                jQueryStamped('.stamped-questions-search-clear').show();
                jQueryStamped('.stamped-questions', eleStampedMainWidget).attr('data-filtered', 'true');
            }
            if (e.keyCode == 13) {
                var _inputVal = jQueryStamped(this).val();
                if (_inputVal) {
                    jQueryStamped(eleStampedMainWidget).attr('data-search-qna', _inputVal.trim());
                    jQueryStamped('.stamped-summary-actions-clear').show();
                    pageQuestions();
                }
            }
        });

        jQueryStamped(document).on('click keypress', '.stamped-questions-search-button', function (e) {
            if (checkAccessibilityClick(event) === true) {
                var _inputVal = jQueryStamped('.stamped-questions-questions-input').val();
                if (_inputVal) {
                    jQueryStamped(eleStampedMainWidget).attr('data-search-qna', _inputVal.trim());
                    jQueryStamped('.stamped-summary-actions-clear').show();
                    pageQuestions();
                }
            }
        });

        jQueryStamped(document).on('click keypress', '.stamped-questions-search-clear', function (event) {
            if (checkAccessibilityClick(event) === true) {
                jQueryStamped('.stamped-questions-search-clear').hide();
                jQueryStamped('.stamped-questions-search-input').val('');
                jQueryStamped(eleStampedMainWidget).removeAttr('data-search-qna');

                pageQuestions();
            }
        });

    }

    function _initReadMoreHandler() {
        jQueryStamped(document).on('click keypress', '.stamped-review-read-more', function (event) {
            if (checkAccessibilityClick(event) === true) {
                jQueryStamped(this).closest('.stamped-review-content-body').find('.stamped-review-read-more').hide();
                var txtOriginal = jQueryStamped(this).closest('.stamped-review-content-body').find('.original-review').html();
                jQueryStamped(this).closest('.stamped-review-content-body').html(txtOriginal);
                if (window.macyInstanceStamped) {
                    window.macyInstanceStamped.reInit();
                }
            }
        });
    }

    function _initShareHandler() {
        var _ele = '.stamped-share-button, .stamped-share-icon';

        jQueryStamped(document).off('click keypress', _ele).on('click keypress', _ele, function (event) {
            if (checkAccessibilityClick(event) === true) {
                var links = jQueryStamped(this).parent().find('.stamped-share-links');
                links.fadeToggle();
            }
        });
    }

    function _initSummaryRatingHandler() {
        jQueryStamped(document).on('click keypress', '.stamped-summary-ratings .summary-rating', function (event) {
            if (checkAccessibilityClick(event) === true) {
                var $bar = jQueryStamped(this).find('.summary-rating-bar');
                var rating = $bar.attr('data-rating');
                var selected = $bar.hasClass('selected');

                jQueryStamped('.stamped-summary-ratings .summary-rating').each(function () {
                    jQueryStamped(this).removeClass('selected');
                });

                jQueryStamped('.summary-rating-bar').each(function () {
                    jQueryStamped(this).removeClass('selected');
                });

                if (rating) {
                    if (selected) {
                        pageReviews(1);
                        jQueryStamped('.stamped-summary-ratings').removeClass('selected');
                    } else {
                        $bar.addClass('selected');
                        jQueryStamped(this).addClass('selected');
                        jQueryStamped('.stamped-summary-ratings').addClass('selected');
                        pageReviews(1, rating);
                    }
                }
            }
        });
    }

    function _clearRatingFilter() {
        jQueryStamped('.stamped-summary-ratings').removeClass('selected');

        jQueryStamped('.stamped-summary-ratings .summary-rating').each(function () {
            jQueryStamped(this).removeClass('selected');
        });

        jQueryStamped('.summary-rating-bar').each(function () {
            jQueryStamped(this).removeClass('selected');
        });
    }

    function _initRatingHandler() {
        jQueryStamped(document).on("mouseover mouseout", ".stamped-form-review-rating a.fa", function (e) {
            var n, i, r;
            n = e.currentTarget,
                r = jQueryStamped(n).attr("data-value"),
                i = jQueryStamped(n).parent(),
                "mouseover" === e.type ?
                    (i.find("a.fa:lt(" + r + ")").removeClass("fa-star-o").addClass("fa-star"),
                        i.find("a.fa:gt(" + (r - 1) + ")").removeClass("spr-icon-star-hover").addClass("fa-star-o")) : i.find("a.fa").removeClass("fa-star").addClass("fa-star-o")
        });
    }

    function _renderReviewId(stampedReviewId) {
        jQueryStamped.ajax({
            type: 'GET',
            url: _objStampedOptions.SECURE_ENDPOINT + '/widget/reviews',
            data: {
                reviewId: stampedReviewId,
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                type: 'single',
                showAvatar: 'True',
                minRating: 1
            },
            success: function (data) {
                if (data.data) {
                    StampedFn.openUGCModal([data.data], 0, document, 1, false, 0);
                }
            },
            error: function (data) { }
        });
    }

    var _totalUploaded = 0;
    function _initPhotoUpload() {
        if (window.File && window.FileReader && window.FormData) {
            var $inputField = jQueryStamped('#stamped-file-uploader-input');
            $inputField.on('change', function (e) {
                var files = e.target.files;

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];

                    var fileReader = new FileReader();

                    triggerEventStamped('stamped:photo:selected');

                    // check file count
                    if (_totalUploaded >= 5) {
                        triggerEventStamped('stamped:photo:maxed');

                        return;
                    }

                    _totalUploaded++;

                    if (file.type.match('image')) {
                        readFile(file, _totalUploaded);
                    }
                    else {
                        var fileSize = (file.size / 1024 / 1024);

                        if (fileSize > 50) {
                            triggerEventStamped('stamped:photo:sizeError');

                            alert('Sorry, you cannot add this video to your review. Up to 50mb is allowed.');

                            return;
                        }

                        fileReader.onload = function () {
                            var blob = new Blob([fileReader.result], { type: file.type });
                            var url = URL.createObjectURL(blob);
                            var video = document.createElement('video');
                            var iconVideo = '<div class="stamped-file-photo" data-index="' + _totalUploaded + '"><img src="https://s3-us-west-2.amazonaws.com/stamped.io/cdn/images/icons/icon-video-placeholder.png" width="70" /><span style="display:none;">' + file.name + '</span><div class="stamped-file-photo-remove" data-index="' + _totalUploaded + '">x</div></div>'
                            var timeupdate = function () {
                                if (snapImage()) {
                                    video.removeEventListener('timeupdate', timeupdate);
                                    video.pause();
                                } else {
                                    //jQueryStamped('.stamped-file-holder').append(iconVideo);
                                }
                            };

                            video.addEventListener('loadeddata', function () {
                                if (snapImage()) {
                                    video.removeEventListener('timeupdate', timeupdate);
                                } else {
                                    jQueryStamped('.stamped-file-holder').append(iconVideo);
                                }

                                arrPhotosUpload.push(file);
                            });

                            var snapImage = function () {
                                var canvas = document.createElement('canvas');
                                canvas.width = video.videoWidth;
                                canvas.height = video.videoHeight;
                                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                                var image = canvas.toDataURL();
                                var success = image.length > 100000;

                                if (success) {
                                    jQueryStamped('.stamped-file-holder').append('<div class="stamped-file-photo" data-index="' + _totalUploaded + '"><img src="' + image + '" width="70" /><span style="display:none;">' + file.name + '</span><div class="stamped-file-photo-remove" data-index="' + _totalUploaded + '">x</div></div>');

                                    URL.revokeObjectURL(url);
                                }
                                return success;
                            };

                            video.addEventListener('timeupdate', timeupdate);
                            video.preload = 'metadata';
                            video.src = url;
                            // Load video in Safari / IE11
                            video.muted = true;
                            video.playsInline = true;
                            video.play();
                        };

                        fileReader.readAsArrayBuffer(file);
                    }


                    if (file) {
                        if (/^image\//i.test(file.type) || /^video\//i.test(file.type)) {
                            console.log('is image, begin upload');
                        } else {
                            triggerEventStamped('stamped:photo:invalid');

                            console.log('Not a valid image!');
                        }
                    }
                }

                $inputField.val('');
            });

            jQueryStamped(document).on('click', '.stamped-file-photo-remove', function () {
                var $photo = jQueryStamped(this).parent('.stamped-file-photo');

                var _idx = $photo.index();

                arrPhotosUpload.splice(_idx, 1);

                _totalUploaded = arrPhotosUpload.length;

                $photo.remove();
            });
        } else {
            console.log("File upload is not supported!");
        }

        function getOrientation(file, callback) {
            var reader = new FileReader();

            reader.onload = function (event) {
                var view = new DataView(event.target.result);

                if (view.getUint16(0, false) != 0xFFD8) return callback(-2);

                var length = view.byteLength,
                    offset = 2;

                while (offset < length) {
                    var marker = view.getUint16(offset, false);
                    offset += 2;

                    if (marker == 0xFFE1) {
                        if (view.getUint32(offset += 2, false) != 0x45786966) {
                            return callback(-1);
                        }
                        var little = view.getUint16(offset += 6, false) == 0x4949;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;

                        for (var i = 0; i < tags; i++)
                            if (view.getUint16(offset + (i * 12), little) == 0x0112)
                                return callback(view.getUint16(offset + (i * 12) + 8, little));
                    }
                    else if ((marker & 0xFF00) != 0xFF00) break;
                    else offset += view.getUint16(offset, false);
                }
                return callback(-1);
            };

            reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
        };

        function resetOrientation(srcBase64, srcOrientation, callback) {
            var img = new Image();

            img.onload = function () {
                var width = img.width,
                    height = img.height,
                    canvas = document.createElement('canvas'),
                    ctx = canvas.getContext("2d");

                // set proper canvas dimensions before transform & export
                if (4 < srcOrientation && srcOrientation < 9) {
                    canvas.width = height;
                    canvas.height = width;
                } else {
                    canvas.width = width;
                    canvas.height = height;
                }

                // transform context before drawing image
                switch (srcOrientation) {
                    case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
                    case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
                    case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
                    case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
                    case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
                    case 7: ctx.transform(0, -1, -1, 0, height, width); break;
                    case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
                    default: break;
                }

                // draw image
                ctx.drawImage(img, 0, 0);

                // export base64
                callback(canvas.toDataURL());
            };

            img.src = srcBase64;
        };

        var imageOrientation;
        function readFile(file, idx) {
            getOrientation(file, function (orientation) {
                imageOrientation = orientation;
            });

            var reader = new FileReader();
            reader.onloadend = function () {
                //console.log('process file');
                processFile(reader.result, file.type, file.name, idx);
            }
            reader.onerror = function () {
                console.log('There was an error reading the file!');
            }
            reader.readAsDataURL(file);
        }

        function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }

        function processFile(dataURL, fileType, fileName, index) {

            var maxWidth = 1500;
            var maxHeight = 1500;
            var image = new Image();
            image.src = dataURL;

            image.onload = function (index, imageObj, fileName) {

                setTimeout(function () {
                    var width = image.width;
                    var height = image.height;

                    var shouldResize = false; //(width > maxWidth) || (height > maxHeight);

                    if (!shouldResize) {
                        // appending image to holder
                        jQueryStamped('.stamped-file-holder').append('<div class="stamped-file-photo" data-index="' + index + '"><img src="' + dataURL + '" width="70" /><span style="display:none;">' + fileName + '</span><div class="stamped-file-photo-remove" data-index="' + index + '">x</div></div>');

                        sendFile(dataURL, index, fileName);
                    } else {

                        var newWidth;
                        var newHeight;
                        if (width > height) {
                            newHeight = height * (maxWidth / width);
                            newWidth = maxWidth;
                        } else {
                            newWidth = width * (maxHeight / height);
                            newHeight = maxHeight;
                        }
                        var canvas = document.createElement('canvas');
                        canvas.width = newWidth;
                        canvas.height = newHeight;
                        var context = canvas.getContext('2d');
                        context.drawImage(imageObj, 0, 0, newWidth, newHeight);
                        dataURL = canvas.toDataURL(fileType);

                        jQueryStamped('.stamped-file-holder').append('<div class="stamped-file-photo" data-index="' + index + '"><img src="' + dataURL + '" width="70" /><span style="display:none;">' + fileName + '</span><div class="stamped-file-photo-remove" data-index="' + index + '">x</div></div>');

                        if (imageOrientation && imageOrientation != 1) {
                            resetOrientation(dataURL, imageOrientation, function (updatedDataURL) {
                                dataURL = updatedDataURL;
                                //console.log(imageOrientation);

                                sendFile(dataURL, index, fileName);
                            });
                        } else {
                            sendFile(dataURL, index, fileName);
                        }
                    }
                }, 100);

            }(index, image, fileName);

            image.onerror = function () {
                console.log('There was an error processing your file!');
            };
        }

        function sendFile(fileData, photoIndex, fileName) {
            var file = dataURLtoFile(fileData, fileName);
            arrPhotosUpload.push(file);
            return;

            //var productId = eleStampedMainWidget.attr('data-product-id');
            //var obj = {
            //    imagea: fileData.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""),
            //}

            //triggerEventStamped('stamped:photo:uploading');

            //jQueryStamped(".stamped-button-primary", eleStampedMainWidget).attr("disabled", "disabled");

            //jQueryStamped.ajax({
            //    type: 'POST',
            //    url: '//stamped.io/api/widget/upload?' + jQueryStamped.param(stripNull({
            //        productId: productId,
            //        apiKey: window.StampedGlobalOptions.apiKey,
            //        sId: window.StampedGlobalOptions.sId,
            //        storeUrl: window.StampedGlobalOptions.storeUrl,
            //    })),
            //    data: JSON.stringify(obj),
            //    contentType: 'application/json; charset=utf-8',
            //    dataType: 'json',
            //    success: function (data) {
            //        setTimeout(function () {
            //            if (data) {
            //                arrPhotosUpload.push(data);
            //                completeUpload(data, photoIndex);
            //            }
            //        }, 1000);

            //        setTimeout(function () {
            //            triggerEventStamped('stamped:photo:uploaded');
            //            jQueryStamped(".stamped-button-primary", eleStampedMainWidget).removeAttr("disabled");
            //        }, 2000);
            //    },
            //    error: function (data) {
            //        var arrayLength = arrPhotosUpload.length;
            //        if (data.responseText == '"max"') {
            //            alert('Upload up to 3 images');
            //        } else {
            //            console.log('An error occured, please try again later.');
            //        }

            //        setTimeout(function () {
            //            triggerEventStamped('stamped:photo:uploaded');
            //            jQueryStamped(".stamped-button-primary", eleStampedMainWidget).removeAttr("disabled");
            //        }, 2000);

            //    }
            //});
        }

        var completeUpload = function (imgUrl, photoIndex) {
            stampedLog('Photo upload complete idx' + photoIndex);
            jQueryStamped('.stamped-file-photo[data-index=' + photoIndex + '] .fa').remove();

            //if (imgUrl) {
            //    // remove spinner
            //    var wrapper = jQueryStamped('<div id="image-wrapper" data-url="' + imgUrl + '">');
            //    var imgDelete = jQueryStamped('<a id="btn-delete" data-url="' + imgUrl + '"><i class="fa fa-times" style="font-size: 19px;"></a>');
            //    var img = jQueryStamped('<img id="image" width="80">');
            //    img.attr('src', "//s3-us-west-2.amazonaws.com/stamped.io/uploads/photos/" + imgUrl);
            //    imgDelete.appendTo(wrapper);
            //    img.appendTo(wrapper);
            //}
            //var myStringArray = arrPhotosUpload;
            //var arrayLength = myStringArray.length;
            //if (arrayLength >= 3) {
            //    jQueryStamped('.stamped-file-uploader-input').addClass('hide');
            //}
        }
    }

    function _initVoteHandler() {
        var _ele = "#shopry-rating-wrapper a.shopry-thumbs-up, #shopry-rating-wrapper a.shopry-thumbs-down, #shopry-rating-holder a.shopry-thumbs-up, #shopry-rating-holder a.shopry-thumbs-down, #stamped-rating-holder a.stamped-thumbs-up, #stamped-rating-holder a.stamped-thumbs-down, .stamped-rating-holder a.stamped-thumbs-up, .stamped-rating-holder a.stamped-thumbs-down";

        jQueryStamped(document).off("click keypress", _ele).on("click keypress", _ele, function (event) {
            if (checkAccessibilityClick(event) === true) {

                var reviewId = jQueryStamped(this).attr('data-review-id');
                var questionId = jQueryStamped(this).attr('data-question-id');

                var rating = jQueryStamped(this).attr('data-rating');
                var productId = eleStampedMainWidget.attr('data-product-id');

                var $eleRating = jQueryStamped(this);
                var $eleParent = $eleRating.parent();

                $eleParent.fadeTo("slow", 0.3);
                $eleRating.addClass('disable-link');

                var voteType = reviewId ? 'reviews' : 'questions';

                jQueryStamped.ajax({
                    type: 'POST',
                    url: _objStampedOptions.SECURE_ENDPOINT + '/' + voteType + '/vote',
                    data: {
                        productId: productId,
                        reviewId: reviewId,
                        questionId: questionId,
                        vote: rating,
                        apiKey: window.StampedGlobalOptions.apiKey,
                        sId: window.StampedGlobalOptions.sId,
                        storeUrl: window.StampedGlobalOptions.storeUrl
                    },
                    success: function (data) {
                        jQueryStamped('.stamped-thumbs-up i', $eleParent).html('&nbsp; ' + (data.voteUp));
                        jQueryStamped('.stamped-thumbs-down i', $eleParent).html('&nbsp; ' + (data.voteDown));

                        $eleParent.fadeTo("slow", 1);
                        $eleRating.removeClass('disable-link');
                    }
                });
            }
        });
    }

    function _initTabsHander() {
        jQueryStamped(document).on('click keypress', '.stamped-tabs li', function (event) {
            if (checkAccessibilityClick(event) === true) {
                _switchTab(this);
            }
        });

        jQueryStamped(document).on('keypress', '.stamped-summary-actions-newreview', function (event) {
            if (checkAccessibilityClick(event) === true) {
                toggleForm('review');
            }
        });

        jQueryStamped(document).on('keypress', '.stamped-summary-actions-newquestion', function (event) {
            if (checkAccessibilityClick(event) === true) {
                toggleForm('question');
            }
        });

        jQueryStamped(document).on('keypress', '.stamped-form-input a', function (event) {
            if (checkAccessibilityClick(event) === true) {
                setRating(this);
            }
        });
    }

    function _initUserReview(_pid, _val, save) {
        if (readCookie('stamped-user-reviews') != null) {
            // get current cookie and append
            var currentCookie = JSON.parse(readCookie('stamped-user-reviews'));
            var foundCookie;

            var found = false;
            for (var i = 0; i < currentCookie.length; i++) {
                if (currentCookie[i].pid == _pid) {
                    found = true;
                    foundCookie = currentCookie[i];
                    break;
                }
            }

            if (!found && _pid && _val && save == true) {
                // check current cookie size, if more than 10 remove the earliest item
                if (currentCookie.length >= 10) {
                    currentCookie.splice(0, 1);
                }

                currentCookie.push({
                    pid: _pid,
                    v: _val
                });

                createCookie('stamped-user-reviews', JSON.stringify(currentCookie), 1);

            }

            if (found && !save) {
                if (foundCookie) {
                    // load API to get review to update
                }
            }
        }
        else {
            if (_pid && _val && save == true) {
                var arrUserReviews = [{
                    pid: _pid,
                    v: _val
                }];

                createCookie('stamped-user-reviews', JSON.stringify(arrUserReviews), 1);
            }
        }
    }

    var _previousAjax = null;

    function _loadWidget(page, sort, rating, skipAnimation) {
        if (eleStampedMainWidget.length && !isLoading) {
            stampedLog('Loading Main Widget...');

            var productId = eleStampedMainWidget.attr('data-product-id');
            var productIds = eleStampedMainWidget.attr('data-product-ids');
            var productName = eleStampedMainWidget.attr('data-name');
            var productType = eleStampedMainWidget.attr('data-product-type');
            var productSKU = eleStampedMainWidget.attr('data-product-sku') || eleStampedMainWidget.attr('data-product-sku2');
            var userReference = eleStampedMainWidget.attr('data-user-reference');
            var take = eleStampedMainWidget.attr('data-take-reviews');
            var keyword = eleStampedMainWidget.attr('data-keyword');
            var widgetLanguage = eleStampedMainWidget.attr('data-widget-language');
            var widgetCountryIso = eleStampedMainWidget.attr('data-widget-country-iso');

            var widgetType = eleStampedMainWidget.attr('data-widget-type');
            var loadType = eleStampedMainWidget.attr('data-load-type') || jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-load-type');
            var search = eleStampedMainWidget.attr('data-search');
            var isUseCache = eleStampedMainWidget.attr('data-cache') || _objStampedOptions.is_disable_cache || null;
            var widgetStyle = jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-style');
            var tagsExclude = eleStampedMainWidget.attr('data-tags-exclude');
            var tagsInclude = eleStampedMainWidget.attr('data-tags-include');

            var _jsonMetafield = _objStampedOptions.metafields;

            if (widgetStyle == 'slider') {
                loadType = 'continue';
            }

            if (productName) {
                productName = productName.replace('!', '');
            }

            if (!sort) {
                sort = eleStampedMainWidget.attr('data-sort') || jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-sort');
            }

            if (loadType === 'continue') {
                skipAnimation = true;
            }

            // check if placeholder exists

            if (jQueryStamped('#stamped-main-widget-placeholder').length) {
                jQueryStamped('#stamped-main-widget-placeholder').append(eleStampedMainWidget);
            }

            isLoading = true;

            // jump to the div with id

            if (page && !skipAnimation) {
                jump('.stamped-reviews');
            }

            eleStampedMainWidget.addClass('stamped-main-widget-loading');

            var loadingLabel = jQueryStamped("<span>Loading more...</span>").prependTo(jQueryStamped("#stamped-reviews-tab"));

            // load the form and insert into the div

            var _queryParam = jQueryStamped.param(stripNull({
                productId: productId,
                productIds: productIds,
                productName: productName,
                productType: productType,
                productSKU: productSKU,
                userReference: userReference,
                page: page || 1,
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl,
                take: take || 5,
                sort: sort,
                rating: rating,
                keyword: keyword,
                widgetLanguage: widgetLanguage,
                widgetCountryIso: widgetCountryIso,
                widgetType: widgetType,
                search: search,
                isUseCache: isUseCache,
                tagsExclude: tagsExclude,
                tagsInclude: tagsInclude
            }));

            if (!jQueryStamped.isEmptyObject(objFilterMainWidget)) {
                _queryParam += "&" + jQueryStamped.param(objFilterMainWidget);
            }

            var isPreview = _jsonMetafield.length;
            var ajaxOpt = {
                type: !isPreview ? 'GET' : 'POST',
                data: !isPreview ? null : JSON.stringify({
                    metafields: _jsonMetafield,
                }),
                dataType: 'json',
                url: _objStampedOptions.SECURE_ENDPOINT + '/widget' + (isPreview ? '/preview' : '') + '?' + _queryParam,
                success: function (data) {
                    stampedLog('Loaded Main Widget...');

                    isLoading = false;

                    eleStampedMainWidget.removeClass('stamped-main-widget-loading');

                    loadingLabel.remove();

                    var product = data.product;
                    var widget = data.widget;

                    // check whether product meta exists, if not, append

                    var productMetaExists = jQueryStamped('#stamped-main-widget .stamped-container').length;

                    // if qna element exists, copy and append (DO NOTE MOVE! MUST BE ABOVE THE REPLACING MAIN WIDGET CODE)
                    var qnaWrapper = jQueryStamped('.question-form-wrapper').clone();
                    var qnaWidget = jQueryStamped('.stamped-questions').clone();

                    // Make sure we are not removing the widget.min.css when reloading the widget as it will brick the layout
                    // For some shopify stores the loadStyle function is injecting css into the app block div instead of the main <head> tag
                    eleStampedMainWidget.children(':not(link[href="//cdn1.stamped.io/files/widget.min.css"])').remove();
                    eleStampedMainWidget.append(product);

                    var $loadedWidget;
                    if (typeof jQueryStamped.parseHTML == 'function') {
                        $loadedWidget = jQueryStamped.parseHTML(widget);
                    } else {
                        $loadedWidget = jQueryStamped(widget);
                    }

                    var isEmpty = jQueryStamped('.stamped-content', eleStampedMainWidget).children().length == 0;

                    if (isEmpty) {
                        jQueryStamped('.stamped-content', eleStampedMainWidget).append(jQueryStamped($loadedWidget));
                    } else {
                        // get current stamped-reviews container

                        var $currentReviews = jQueryStamped('.stamped-reviews', eleStampedMainWidget);

                        // append loaded stamped-review elements to container
                        var $loadedReviews = jQueryStamped('[class="stamped-review"]', $loadedWidget);

                        // treat null page as if it is page 1
                        if (loadType === 'continue' && (page !== null || typeof page !== 'undefined') && (page !== 1 || !page)) {
                            // do nothing
                        } else {
                            jQueryStamped('.stamped-reviews [class*="stamped-review"]', eleStampedMainWidget).remove();
                        }

                        // get pagination

                        var $loadedPagination = jQueryStamped('.stamped-pagination', $loadedWidget).attr('data-page', page);
                        var $currentPagination = jQueryStamped('.stamped-reviews .stamped-pagination', eleStampedMainWidget);

                        // append reviews

                        if (!$currentPagination.length) {
                            jQueryStamped($loadedReviews).appendTo('.stamped-reviews', eleStampedMainWidget);
                        } else {
                            jQueryStamped($loadedReviews).insertBefore($currentPagination);
                        }

                        // replace total counts
                        var $loadedTabs = jQueryStamped('.stamped-tabs', $loadedWidget);
                        jQueryStamped('.stamped-tabs', eleStampedMainWidget).replaceWith($loadedTabs);

                        // replace pagination
                        if ($loadedPagination.length) {
                            if ($currentPagination.length) {
                                $currentPagination.replaceWith($loadedPagination);
                            } else {
                                $currentReviews.append($loadedPagination);
                            }
                        } else {
                            $currentPagination.remove();
                        }
                    }

                    // check sort selection, select value
                    if (sort) {
                        if (jQueryStamped('.stamped-sort-select', eleStampedMainWidget).length) {
                            if (jQueryStamped('.stamped-sort-select option[value="' + sort + '"]', eleStampedMainWidget).css('display') !== 'none') {
                                jQueryStamped('.stamped-sort-select', eleStampedMainWidget).val(sort);
                                jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-sort', sort);
                                jQueryStamped(eleStampedMainWidget).attr('data-sort', sort);

                            }
                        }
                    }

                    // close forms

                    jQueryStamped('.new-review-form').hide();
                    jQueryStamped('.new-question-form').hide();

                    triggerEventStamped('stamped:reviews:loaded');

                    // set aria-controls value to dynamic id of the review form
                    jQueryStamped('.stamped-summary-actions-newreview').attr('aria-controls', 'new-review-form_' + (productId != null ? productId : ''));

                    triggerAccessibilityPaginationFullPage();
                },
                error: function (data) { }
            };

            if (_jsonMetafield.length) {
                ajaxOpt.contentType = 'application/json';
            }

            if (_previousAjax != null) {
                _previousAjax.abort();
            }

            _previousAjax = jQueryStamped.ajax(ajaxOpt);
        }

        if (keyword) {
            _apiTrackSearch({
                topic: keyword,
            }, productId);
        }

        if (search) {
            _apiTrackSearch({
                search: search
            }, productId);
        }
    }

    function highlightKeywords(input, text) {
        input = input.replace(
            new RegExp(text + '(?!([^<]+)?<)', 'gi'),
            '<span class="stamped-keyword-highlight">$&</span>'
        );

        return input;
    }

    function _loadQuestionsAndAnswers(page, sort) {
        eleStampedMainWidget = jQueryStamped(ID_MAIN_WIDGET);

        if (eleStampedMainWidget.length) {
            var productId = eleStampedMainWidget.attr('data-product-id');
            var productSKU = eleStampedMainWidget.attr('data-product-sku');
            var productType = eleStampedMainWidget.attr('data-product-type');
            var productTitle = eleStampedMainWidget.attr('data-name');
            var take = eleStampedMainWidget.attr('data-take-questions') || 5;
            var search = eleStampedMainWidget.attr('data-search-qna');

            if (!sort) {
                sort = eleStampedMainWidget.attr('data-sort-qna') || jQueryStamped('.stamped-container', eleStampedMainWidget).attr('data-widget-sort-qna');

            }

            var isLinkify = eleStampedMainWidget.data('linkify') || false;

            if (!productId) { return; }

            stampedLog('Loading Q&A');

            jQueryStamped.ajax({
                type: 'GET',
                url: _objStampedOptions.SECURE_ENDPOINT + '/widget/questions',
                data: {
                    productId: productId,
                    productSKU: productSKU,
                    productType: productType,
                    productTitle: productTitle,
                    page: page || 1,
                    apiKey: window.StampedGlobalOptions.apiKey,
                    sId: window.StampedGlobalOptions.sId,
                    storeUrl: window.StampedGlobalOptions.storeUrl,
                    take: take || 5,
                    search: search,
                    sort: sort
                },
                success: function (data) {
                    // check if user premium or pro
                    if (data.a == true) {
                        // check if shopry-main-widget exists
                        if (jQueryStamped('.stamped-questions').length) {
                            // Create the Question Widget
                            var questionHtml, total, form, pages, avatar;
                            questionHtml = data.result;
                            total = data.t;
                            form = data.form;
                            pages = data.p;
                            avatar = data.avatar;
                            // change tab's count
                            var qtxt = jQueryStamped('#tab-questions').text();
                            jQueryStamped('#tab-questions').attr('data-count', total);

                            //var reviewTxt = qtxt.split(' ');
                            //jQueryStamped('#tab-questions').html(reviewTxt[0] + ' (' + total + ')');

                            // those items that need to create only once
                            _createQuestionsAndAnswersWidget(form);

                            // load all the questions widget
                            var qaWrapper2 = jQueryStamped('<div id="stamped-questions-tab" class="stamped-questions" role="tabpanel" aria-labelledby="tab-questions" tabindex="-1">');
                            jQueryStamped('.stamped-questions').html('');
                            qaWrapper2.append(questionHtml);

                            // if avatar not null, find element and add
                            if (avatar) {
                                var avatarDiv = jQueryStamped('.stamped-review #stamped-review-avatar', qaWrapper2);
                                var imgAvatar = jQueryStamped('<img src="' + avatar + '" width="100">');
                                avatarDiv.html(imgAvatar);
                            }
                            // check if placeholder exists

                            var qnaPlaceholder = jQueryStamped('.stamped-questions-placeholder');

                            if (qnaPlaceholder.length) {
                                jQueryStamped('.stamped-questions', qnaPlaceholder).html('');
                                jQueryStamped('.stamped-questions', qnaPlaceholder).replaceWith(qaWrapper2);

                                if (!jQueryStamped('.stamped-questions', qnaPlaceholder).length) {
                                    jQueryStamped('.stamped-questions').appendTo(qnaPlaceholder);
                                    jQueryStamped('.stamped-questions').replaceWith(qaWrapper2);
                                }

                                jQueryStamped('.stamped-questions', qnaPlaceholder).show();
                                jQueryStamped('#tab-questions').hide();
                                jQueryStamped('.question-form-wrapper').prependTo(qnaPlaceholder);
                                jQueryStamped('.stamped-summary-actions-newquestion').prependTo(qnaPlaceholder);
                            } else {
                                jQueryStamped('.stamped-questions').replaceWith(qaWrapper2);

                                if (!page) {
                                    jQueryStamped('.stamped-questions').hide();
                                } else {
                                    jQueryStamped('.stamped-questions').show();
                                }
                            }

                            _createQuestionsAndAnswersPagination(total, page || 1, take);
                            // find the element .shopry-qna-widget
                            // copyWidgetQnAStandalone();

                            if (qnaPlaceholder.length) {
                                if (page > 1) {
                                    jump('.stamped-questions-placeholder');
                                }
                            } else {
                                if (page > 1) {
                                    jump(ID_MAIN_WIDGET);
                                }
                            }

                            if (!sort) {
                                jQueryStamped('.stamped-questions-filter .stamped-sort-select').val('recent');
                            }

                            // linkify
                            if (isLinkify) {
                                jQueryStamped('.stamped-review-reply-body', qaWrapper2).each(function () {
                                    if (!jQueryStamped(this).attr("data-link-processed")) {
                                        jQueryStamped(this).attr('data-link-processed', true);

                                        var currentHtml = jQueryStamped(this).html();
                                        jQueryStamped(this).html(currentHtml.linkify());
                                    }
                                });
                            }

                            triggerEventStamped('stamped:questions:loaded');
                        }
                    }
                }
            });
        }
    }

    function _createQuestionsAndAnswersWidget(form) {
        // create question widget only once
        if (jQueryStamped('.stamped-questions').length && !jQueryStamped('.question-form-wrapper').length) {
            // Create Q&A form
            var formElement = jQueryStamped('<div class="question-form-wrapper">').html(form);
            jQueryStamped('.new-review-form').before(formElement);
        }
    }

    function _createQuestionsAndAnswersPagination(total, currentPage, take) {
        var totalPage = total > 0 ? (total / take) < 1 ? 1 : Math.ceil(total / take) : 1;
        if (totalPage == 1) {
            return;
        }
        var paginationHtml = ('<div class="stamped-pagination" id="stamped-pagination-question"><div><span id="stamped-pagination-prev" class="previous"><a href="#" onclick="StampedFn.pageQuestions(this)" role="link" tabindex="0" data-product-id="" data-page="' + (currentPage - 1) + '"><</a></span><span id="pages"></span><span id="stamped-pagination-next" class="next"><a onclick="StampedFn.pageQuestions(this)" role="link" tabindex="0" data-product-id="" data-page="' + (currentPage + 1) + '">></a></span></div></div>');
        var divQuestionsAndAnswers = jQueryStamped('.stamped-questions');
        var qnaPlaceholder = jQueryStamped('.stamped-questions-placeholder');
        if (qnaPlaceholder.length) {
            divQuestionsAndAnswers = jQueryStamped('.stamped-questions', qnaPlaceholder);
        }
        var divPagination = jQueryStamped('.stamped-pagination', divQuestionsAndAnswers);
        if (divPagination.length) {
            divPagination.replaceWith(paginationHtml);
        } else {
            divQuestionsAndAnswers.append(paginationHtml);
        }
        divPagination = jQueryStamped('.stamped-pagination', divQuestionsAndAnswers);
        var total = totalPage;
        var currentPage = currentPage;
        var pages = [];
        pages.push(1);
        if (total <= 7) {
            for (i = 2; i < total; i++) {
                pages.push(i);
            }
            if (total == currentPage) {
                pages.push(currentPage);
            }
        }
        if (total >= 8) {
            var totalPrevPage = currentPage - 2;
            if (totalPrevPage >= 1) {
                if ((currentPage - 2) != 1)
                    pages.push(currentPage - 2);
                pages.push(currentPage - 1);
            }
            if (currentPage != 1)
                pages.push(currentPage);
            var totalNextPage = currentPage + 2;
            if (totalNextPage <= total) {
                pages.push(currentPage + 1);
                if (totalNextPage != total)
                    pages.push(currentPage + 2);
            }
        }
        if (currentPage == 1 || currentPage == 1) {
            jQueryStamped('#stamped-pagination-prev', divPagination).hide();
        } else {
            jQueryStamped('#stamped-pagination-prev', divPagination).show();
        }
        if (total == currentPage || total == 1) {
            jQueryStamped('#stamped-pagination-next', divPagination).hide();
        } else {
            jQueryStamped('#stamped-pagination-next', divPagination).show();
        }
        if (total != currentPage)
            pages.push(total);
        for (var i = 0; i < pages.length; i++) {
            var isCurrentPage = pages[i] == currentPage;
            if (isCurrentPage) {
                jQueryStamped('#pages', divPagination).append((' <span class="page active"><a style="cursor:pointer;" onclick="StampedFn.pageQuestions(this)" role="button" tabindex="0" data-product-id="" data-page="' + pages[i] + '">' + pages[i] + '</a></span> '));
            } else {
                jQueryStamped('#pages', divPagination).append((' <span class="page"><a style="cursor:pointer;" onclick="StampedFn.pageQuestions(this)" role="button" tabindex="0" data-product-id="" data-page="' + pages[i] + '">' + pages[i] + '</a></span> '));
            }
            //if (pages[i] == 1) {
            //    if (total > 7 && currentPage >= 5) {
            //        jQueryStamped('#pages', divPagination).append((' <span class="stamped-pagination-deco">&hellip;</span>'));
            //    }
            //}
            //if (i == (pages.length - 2) && (currentPage + 2) < total) {
            //    jQueryStamped('#pages', divPagination).append((' <span class="stamped-pagination-deco">&hellip;</span>'));
            //}
        }
    }

    function _switchTab(obj, type) {
        // if qna placeholder exists, don’t switch tab
        if (jQueryStamped('#stamped-questions-placeholder, .stamped-questions-placeholder').length) {
            return;
        }

        jQueryStamped('.stamped-tabs #tab-reviews').removeClass('active');
        jQueryStamped('.stamped-tabs #tab-questions').removeClass('active');

        // check if reviews or questions and open the content
        if (type == "questions") {
            jQueryStamped('.stamped-tabs #tab-questions').addClass('active');
        } else if (type == "reviews") {
            jQueryStamped('.stamped-tabs #tab-reviews').addClass('active');
        }
        if (obj) {
            jQueryStamped(obj).addClass('active');
            type = jQueryStamped(obj).data('type');
        }
        if (type == "reviews") {
            jQueryStamped('.stamped-reviews').show();
            jQueryStamped('.stamped-reviews-filter').show();
            jQueryStamped('.stamped-questions').hide();
            jQueryStamped('.stamped-questions-filter').hide();

            // update tabindexes
            jQueryStamped('.stamped-reviews').attr('tabindex', 0);
            jQueryStamped('.stamped-questions').attr('tabindex', -1);

            // show sort reviews
            jQueryStamped('#stamped-sort-select').show();
        } else if (type == "questions") {
            jQueryStamped('.stamped-reviews').hide();
            jQueryStamped('.stamped-reviews-filter').hide();
            jQueryStamped('.stamped-questions').show();
            jQueryStamped('.stamped-questions-filter').show();

            // update tabindexes
            jQueryStamped('.stamped-reviews').attr('tabindex', -1);
            jQueryStamped('.stamped-questions').attr('tabindex', 0);

            // hide sort reviews
            jQueryStamped('#stamped-sort-select').hide();
        }
        // close forms
        jQueryStamped('.new-review-form').hide();
        jQueryStamped('.new-question-form').hide();
    }

    function _loadBadges() {
        stampedLog('Loading Badges...');

        var productIds;
        // check if div exists, if yes proceed to create the form
        eleStampedBadges = jQueryStamped(".stamped-product-reviews-badge[data-id], .stamped-product-reviews-badge[data-product-id]");

        //stampedLog(eleStampedBadges);

        if (eleStampedBadges.length) {
            productIds = jQueryStamped.map(eleStampedBadges, function (t) {
                if ((jQueryStamped(t).attr('data-id') || jQueryStamped(t).attr('data-product-id') || jQueryStamped(t).attr('data-type') || jQueryStamped(t).attr('data-product-type') || jQueryStamped(t).attr('data-product-sku') || jQueryStamped(t).attr('data-product-title'))) {
                    return {
                        productId: jQueryStamped(t).attr("data-id") || jQueryStamped(t).attr("data-product-id"),
                        productType: jQueryStamped(t).attr("data-product-type"),
                        productSKU: jQueryStamped(t).attr("data-product-sku") || jQueryStamped(t).attr("data-product-sku2"),
                        productTitle: jQueryStamped(t).attr("data-product-title")
                    };
                }
            });

            if (productIds && productIds.length) {
                jQueryStamped.ajax({
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    url: _objStampedOptions.SECURE_ENDPOINT + '/widget/badges' + (_objStampedOptions.is_disable_cache_badge === true ? '?isUseCache=false' : ''),
                    data: JSON.stringify({
                        productIds: productIds,
                        apiKey: window.StampedGlobalOptions.apiKey,
                        sId: window.StampedGlobalOptions.sId,
                        storeUrl: window.StampedGlobalOptions.storeUrl
                    }),
                    success: function (data) {
                        eleStampedBadges.each(function (e) {
                            var productId = jQueryStamped(this).attr('data-id') || jQueryStamped(this).attr('data-product-id');
                            var badgeType = jQueryStamped(this).attr('data-type');
                            var index = jQueryStamped.map(data, function (obj, idx) {
                                if (obj.productId == productId) {
                                    return idx;
                                }
                            })[0];
                            if (index >= 0 && (!badgeType || badgeType == 'review')) {
                                jQueryStamped(this).html(data[index].badge);
                            } else if (index >= 0 && badgeType == 'qna') {
                                jQueryStamped(this).html(data[index].badgeqna);
                            }
                        });

                        triggerEventStamped('stamped:badges:loaded');
                    },
                    error: function (data) { }
                });
            }
        }

        if (jQueryStamped('.stamped-product-reviews-badge[data-id].stamped-main-badge, .stamped-product-reviews-badge:first').length) {
            jQueryStamped('.stamped-product-reviews-badge[data-id].stamped-main-badge, .stamped-product-reviews-badge:first').on('click', function () {
                if (jQueryStamped(this).attr('data-type') === 'qna') {
                    if (jQueryStamped('#stamped-questions-placeholder').length) {
                        jump('#stamped-questions-placeholder');
                    } else {
                        _switchTab(null, 'questions');
                        jump(ID_MAIN_WIDGET);
                    }
                    // check for badge questions count
                    if (jQueryStamped('.stamped-badge-caption[data-questions]').length) {
                        var count = jQueryStamped('.stamped-badge-caption[data-questions]').attr('data-questions');
                        if (count === "0") {
                            jQueryStamped('.new-question-form').show();
                        }
                    }
                } else {
                    _switchTab(null, 'reviews');
                    jump(ID_MAIN_WIDGET);
                }
            });
        }
    }

    function _setThankYouShareLinks(data) {
        var reviewStarsTxt = repeat('★', data.reviewRating);
        var imageUrl = eleStampedMainWidget.attr('data-image-url') || '';

        var link = 'https://stamped.io/facebookpost?caption=' + reviewStarsTxt + ' ' + encodeURIComponent(data.reviewTitle) + '&name=' + reviewStarsTxt + ' ' + encodeURIComponent(data.reviewTitle) + '&description=' + encodeURIComponent(data.reviewMessage) + '&link=' + encodeURIComponent(data.productUrl) + '&picture=' + encodeURIComponent(imageUrl.replace('%3F', '?'));

        var shareLinkFacebook = 'https://www.facebook.com/dialog/feed?app_id=941057476855139' +
            '&display=popup&link=' + encodeURIComponent(link) +
            '&name=' + encodeURIComponent(data.reviewTitle) +
            '&redirect_uri=https://stamped.io/shares?productId=' + data.productId;

        var shareLinkTwitter = 'https://twitter.com/intent/tweet?text=' + reviewStarsTxt + ' ' + data.reviewMessage.substr(0, 140) + '&url=' + encodeURIComponent(data.productUrl) + '';
        var shareLinkGoogle = 'https://plus.google.com/share?url=' + encodeURIComponent(data.productUrl);
        var messagesShareLinksDiv = jQueryStamped('.stamped-thank-you .stamped-share-links');
        jQueryStamped('.facebook', messagesShareLinksDiv).attr('href', shareLinkFacebook).attr('target', '_blank');
        jQueryStamped('.twitter', messagesShareLinksDiv).attr('href', shareLinkTwitter).attr('target', '_blank');
        jQueryStamped('.google', messagesShareLinksDiv).attr('href', shareLinkGoogle).attr('target', '_blank');
    }

    function _convertData(arrData, isWithPhotosOnly) {
        var _arrResult = [];
        var idxPhoto = 0;

        for (i = 0; i < arrData.length; i++) {
            var review = arrData[i];

            if (isWithPhotosOnly == true) {
                if (!review.reviewUserPhotos && !review.reviewUserVideos) {
                    continue;
                }
            }

            var _newObj = {
                photos: [],
                videos: [],
                name: review.author,
                via: 'Photos',
                title: review.reviewTitle,
                body: review.reviewMessage,
                date: review.reviewDate,
                reply: review.reviewReply,
                dateReplied: review.dateReplied,
                dateFull: review.dateCreated,
                verifiedType: review.reviewVerifiedType,
                rating: review.reviewRating,
                products: [{
                    url: review.productUrl,
                    title: review.productName,
                    imageUrl: review.productImageUrl,
                    imageLargeUrl: review.productImageLargeUrl,
                    productUrl: review.productDirectUrl || ''
                }],
                review_id: review.id,
                votes: {
                    up: review.reviewVotesUp,
                    down: review.reviewVotesDown
                },
                options: []
            };

            if (review.reviewUserPhotos || review.reviewUserVideos) {
                if (review.reviewUserVideos) {
                    var arrVideos = review.reviewUserVideos.split(',');

                    for (ii = 0; ii < arrVideos.length; ii++) {
                        var _fileUrl = '//s3.us-west-2.amazonaws.com/stamped.io/uploads/videos/' + arrVideos[ii];
                        var _fileThumbUrl = '//cdn.stamped.io/uploads/videos/' + arrVideos[ii] + '.jpg';

                        if (_fileUrl.indexOf('.mp4') < 0) {
                            _fileUrl = _fileUrl + '.mp4';
                        }

                        if (_fileUrl.indexOf('nothumb') >= 0) {
                            _fileThumbUrl = '';
                        }

                        _newObj.photos.push({
                            videoUrl: _fileUrl,
                            imageThumbnailUrl: _fileThumbUrl,
                        });
                    }
                }

                if (review.reviewUserPhotos) {
                    var arrPhotos = review.reviewUserPhotos.split(',');

                    var _url = '//cdn.stamped.io/uploads/photos/';

                    if (review.reviewUserPhotosWatermark) {
                        _url = '//cdn.stamped.io/' + review.reviewUserPhotosWatermark + '/uploads/photos/';
                    }

                    for (ii = 0; ii < arrPhotos.length; ii++) {
                        _newObj.photos.push({
                            imageUrl: _url + arrPhotos[ii],
                            imageThumbnailUrl: '//cdn.stamped.io/uploads/photos/thumb/' + arrPhotos[ii]
                        });
                    }
                }
            } else {
                _newObj.photos.push({
                    imageUrl: review.productImageLargeUrl,
                    imageThumbnailUrl: review.productImageUrl
                });
            }

            if (review.reviewOptionsList && review.reviewOptionsList.length) {

                for (ii = 0; ii < review.reviewOptionsList.length; ii++) {
                    _newObj.options.push({
                        message: review.reviewOptionsList[ii].message,
                        value: review.reviewOptionsList[ii].value
                    });
                }
            }

            _arrResult.push(_newObj);
        }

        return _arrResult;
    }

    var images = [], _modalLoaded = false;
    function _openUGCModal(arrDataModal, arrDataIndex, obj, type, isOnlyWithPhotos, arrPhotoIndex, lang, dataTranslations, shoppable) {
        if (type === 1 || !type) {
            arrDataModal = _convertData(arrDataModal, isOnlyWithPhotos);
        }

        if (arrDataModal == null && !arrDataModal.length) {
            openModal(arrDataIndex, arrPhotoIndex);
        }

        if (!lang) {
            lang = 'en';
        }

        var $modal;
        var templateTag;
        var loading = false;
        var loaded
        var templateModal = '<div class="stamped-ugc-modal" data-lang="' + lang + '" role="dialog" aria-modal="true" aria-label="Customer Review Photos" data-keyboard="true" tabindex="-1"> <div class="stamped-ugc-modal-wrapper" role="region" aria-roledescription="carousel" aria-label="carousel" aria-label="Shop our Instagram look"><span href="javascript:void(0)" title="Close" aria-label="Close" role="button" class="stamped-modal-close show-mobile" style="display:none;" tabindex="0">X</span> <div class="stamped-ugc-modal-nav stamped-ugc-modal-nav-previous" role="button" data-direction="left" tabindex="0" aria-label="Previous Photo"> <i class="stamped-fa stamped-fa-angle-left"></i> </div> <div class="stamped-ugc-modal-image-wrapper" role="group" aria-roledescription="slides" aria-label="slide"> <div class="stamped-ugc-modal-image"></div> <ul></ul> </div> <div class="stamped-ugc-modal-content"> <span href="javascript:void(0)" title="Close" aria-label="Close" role="button" class="stamped-modal-close" tabindex="0">X</span> <div class="stamped-ugc-modal-content-wrapper"> <div class="stamped-ugc-modal-user"> <div class="stamped-ugc-modal-user-source"></div><h1 class="stamped-ugc-modal-user-username"></h1> </div> <div class="stamped-ugc-modal-caption"></div><div class="stamped-ugc-modal-votes"></div> <div class="stamped-ugc-modal-tags"> <span class="stamped-ugc-modal-tag"><a aria-label="Link to Product" {0} target="_top"> <div class="stamped-ugc-modal-tags-product-image-wrapper"><img {1} class="stamped-ugc-modal-tags-product-image" onerror=\'this.style.display = "none"\' alt="{2}" /></div> <div class="stamped-ugc-modal-tags-product-title">{2}</div> </a><div class="stamped-ugc-modal-tags-btn" data-shoppable-url="{3}"></div> </span> </div> </div> </div> <div class="stamped-ugc-modal-nav stamped-ugc-modal-nav-next" role="button" data-direction="right" tabindex="0" aria-label="Next Photo"> <i class="stamped-fa stamped-fa-angle-right"></i> </div> <div class="stamped-ugc-modal-list-photos" role="group"><ul></ul></div> </div> </div>';
        // options attribute
        var shopText = jQueryStamped(obj).attr('data-hover-text') || ' ';
        var shopNowText = jQueryStamped(obj).attr('data-shop-button-text') || 'Shop Now';
        var urlParam = jQueryStamped(obj).attr('data-url-param') || '';
        var urlStore = jQueryStamped(obj).attr('data-url-store') || globalStoreUrl || '';
        var removeCrop = jQueryStamped(obj).attr('data-cropped') == 'false' ? true : false;
        var page = jQueryStamped(obj).attr('data-page') || 1;
        var take = jQueryStamped(obj).attr('data-take') || 30;

        if (!jQueryStamped('#stamped-ugc-modal').length) {
            $modal = jQueryStamped(templateModal);

            $modal.attr('data-modal-type', type);
            $modal.attr('data-modal-shoppable', shoppable || false);

            jQueryStamped($modal).appendTo(document.body);

            // switch focus to modal
            $modal.focus();
        }

        var stringBlocks = '';
        var totalLength = arrDataModal.length;

        if (!templateTag) {
            templateTag = jQueryStamped('.stamped-ugc-modal-tags:first', $modal).html();
        }

        var index = !arrDataModal ? 0 : arrDataModal.length;
        for (var i = 0; i < totalLength; i++) {
            var dataMedia = arrDataModal[i];
            var image = dataMedia.imageUrl;
            if (image) {
                stringBlocks += templateBlock.formatStringStamped(index, image);
                index++;
            }

            // preload images
            if (dataMedia.photos.length && dataMedia.photos[0].imageUrl) {
                images[i] = new Image();
                images[i].src = dataMedia.photos[0].imageUrl;
            }
        }

        jQueryStamped('.stamped-ugc-media-block-template', obj).append(stringBlocks);

        if (!loaded) {
            // handle arrow/escape keydowns
            jQueryStamped(document).on('keydown', handleKeyboardNavigation);

            // handle close button click
            $modal.on('click', '.stamped-modal-close', function (ev) {
                if (ev.target != this || checkAccessibilityClick(ev) !== true) {
                    // only continue if the target itself has been clicked
                    return;
                }

                removeAndCloseModal();
            });

            $modal.on('click keypress', '.stamped-ugc-modal-nav-previous, .stamped-ugc-modal-nav-next', function (event) {
                if (checkAccessibilityClick(event) === true) {
                    var direction = jQueryStamped(this).attr('data-direction');
                    pageModal(direction);
                }
            });

            if (!_modalLoaded) {
                _modalLoaded = true;
            }

            function handleKeyboardNavigation(ev) {
                ev.preventDefault();

                switch (ev.keyCode) {
                    case 37:
                        pageModal('left');
                        break;
                    case 39:
                        pageModal('right');
                        break;
                    case 27:
                        removeAndCloseModal();
                        break;
                    default:
                        break;

                }
            }

            var touchstartX = 0;
            var touchstartY = 0;
            var touchendX = 0;
            var touchendY = 0;

            document.addEventListener('touchstart', handleTouchStart, false);
            document.addEventListener('touchmove', handleTouchMove, false);

            var xDown = null;
            var yDown = null;

            function handleTouchStart(evt) {
                xDown = evt.touches[0].clientX;
                yDown = evt.touches[0].clientY;
            };

            function handleTouchMove(evt) {
                if (!xDown || !yDown) {
                    return;
                }

                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;

                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                    if (xDiff > 0) {
                        /* left swipe */
                        pageModal('right');
                    } else {
                        /* right swipe */
                        pageModal('left');
                    }
                } else {
                    if (yDiff > 0) {
                        /* up swipe */
                    } else {
                        /* down swipe */
                    }
                }
                /* reset values */
                xDown = null;
                yDown = null;
            };

            function removeAndCloseModal() {
                // clear events
                jQueryStamped(document).off('keydown', handleKeyboardNavigation);

                $modal.remove();
                $modal = null;
                jQueryStamped("body").removeClass("stamped-modal-open");
            }
        }

        loaded = true;

        var pagePhoto = function () {
            var idx = Number(jQueryStamped(this).text()) + 1;
            var imageUrl = jQueryStamped(this).data('image-url');

            jQueryStamped('.stamped-ugc-modal-image-wrapper ul li').removeClass('active');

            jQueryStamped('.stamped-ugc-modal-image-wrapper ul li:nth-child(' + idx + ')').addClass('active');

            if (_objStampedOptions.modal_ugc_image_viewer == "image") {
                jQueryStamped('.stamped-ugc-modal-image', $modal).html('<img src="' + imageUrl + '" alt="Customer Photo" />');
            } else {
                jQueryStamped('.stamped-ugc-modal-image', $modal).css('background-image', 'url(' + imageUrl + ')');
            }

            triggerEventStamped('stamped:ugcmodal:paged');
        };

        var pagePhoto2 = function () {
            var idxReview = jQueryStamped(this).data('index-review');
            var idxPhoto = jQueryStamped(this).data('index-photo');

            jQueryStamped('.stamped-ugc-modal-list-photos ul li').removeClass('active');

            jQueryStamped('.stamped-ugc-modal-list-photos ul li[data-index-review=' + idxReview + '][data-index-photo=' + idxPhoto + ']').addClass('active');

            openModal(idxReview, idxPhoto);

            triggerEventStamped('stamped:ugcmodal:paged');
        };

        var openModal = function (idx, idxPhoto) {
            var data = arrDataModal[idx];

            if (data == null || data.photos == null) {
                return;
            }

            if (idxPhoto !== null) {
                arrPhotoIndex = idxPhoto;
                if (idxPhoto > (data.photos.length - 1)) {
                    arrPhotoIndex = 0;
                }

            } else if (arrPhotoIndex) {
                if (arrPhotoIndex > (data.photos.length - 1)) {
                    arrPhotoIndex = 0;
                }
            } else {
                arrPhotoIndex = 0;
            }

            // append all photos to list
            if (!jQueryStamped('.stamped-ugc-modal-list-photos ul li', $modal).length) {
                for (var iii = 0; iii < arrDataModal.length; iii++) {
                    for (var iiii = 0; iiii < arrDataModal[iii].photos.length; iiii++) {
                        var _selected = idx == iii && (idxPhoto == iiii) ? 'active' : '';
                        var _photoImageUrl = arrDataModal[iii].photos[iiii].imageUrl;

                        var _photoAriaLabel = arrDataModal[iii].name + ' ' + arrDataModal[iii].title;
                        var _photoImageThumbnailUrl = arrDataModal[iii].photos[iiii].imageThumbnailUrl;

                        var li = document.createElement('li');

                        li.className = _selected;
                        li.innerHTML = '';

                        li.className += ' stamped-lazyload';

                        var att = document.createAttribute("data-index-review");
                        att.value = iii;
                        li.setAttributeNode(att);

                        var att2 = document.createAttribute("data-index-photo");
                        att2.value = iiii;
                        li.setAttributeNode(att2);

                        li.setAttribute('role', 'button');
                        li.setAttribute('tabindex', 0);
                        li.setAttribute('aria-label', _photoAriaLabel);

                        if (window.LazyLoadStamped && LazyLoadStamped.update) {
                            var att3 = document.createAttribute("data-bg");
                            att3.value = "url(" + _photoImageThumbnailUrl + ")";
                            li.setAttributeNode(att3);
                        }
                        else {
                            li.style.background = "url(" + _photoImageThumbnailUrl + ")";
                        }

                        jQueryStamped('.stamped-ugc-modal-list-photos ul', $modal).append(li);

                        li.onclick = pagePhoto2;
                    }
                }

                // set click event listener on the customer photo carousel thumbnails for accessibility
                jQueryStamped(document).on('click keypress', '.stamped-ugc-modal-list-photos li.stamped-lazyload', function (e) {
                    if (checkAccessibilityClick(e)) {
                        // set aria-current
                        jQueryStamped(this).attr("aria-current", "true");
                        jQueryStamped(this).siblings().attr("aria-current", "false");
                    }
                });

                try {
                    if (window.LazyLoadStamped && LazyLoadStamped.update) {

                        LazyLoadStamped.update();
                    }
                } catch (e) {
                }
            }

            // set aria-current attribute to default photo's thumbnail upon modal open
            jQueryStamped('.stamped-ugc-modal-list-photos li.stamped-lazyload.active').attr("aria-current", "true");
            jQueryStamped('.stamped-ugc-modal-list-photos li.stamped-lazyload.active').siblings().attr("aria-current", "false");

            if (data.photos[arrPhotoIndex] != null) {
                var img = data.photos[arrPhotoIndex].imageUrl;
                var video = data.photos[arrPhotoIndex].videoUrl;

                if (img) {
                    if (_objStampedOptions.modal_ugc_image_viewer == "image") {
                        //jQueryStamped('.stamped-ugc-modal-image', $modal).css('background-image', 'url(' + img + ')');

                        // remove any video object
                        jQueryStamped('video', jQueryStamped('.stamped-ugc-modal-image', $modal)).remove();

                        jQueryStamped('.stamped-ugc-modal-image', $modal).html('<img src="' + img + '" alt="' + data.via + ' photo uploaded by ' + data.name + ' on ' + data.dateFull + '" />');
                    } else {
                        // remove any video object
                        jQueryStamped('video', jQueryStamped('.stamped-ugc-modal-image', $modal)).remove();

                        jQueryStamped('.stamped-ugc-modal-image', $modal).css('background-image', 'url(' + img + ')');
                    }
                } else if (video) {
                    jQueryStamped('.stamped-ugc-modal-image', $modal).fadeOut("", function () {
                        jQueryStamped('.stamped-ugc-modal-image', $modal).css('background-image', 'url("")');
                        jQueryStamped('.stamped-ugc-modal-image', $modal).html('<video class="stamped-ugc-modal-video" src="' + video + '" width="100%" controls autoplay />');
                        jQueryStamped(this).fadeIn();
                    });
                }
            }

            // loop through photos for current review and append nodes
            jQueryStamped('.stamped-ugc-modal-image-wrapper ul', $modal).html('');

            for (ii = 0; ii < data.photos.length; ii++) {
                var _selected2 = ii === arrPhotoIndex ? 'active' : '';

                var li2 = document.createElement('li');

                li2.className = _selected2;
                li2.innerHTML = ii;

                var att2 = document.createAttribute("data-image-url");       // Create a "class" attribute
                att2.value = data.photos[ii].imageUrl;                           // Set the value of the class attribute
                li2.setAttributeNode(att2);                          // Add the class attribute to <h1>

                jQueryStamped('.stamped-ugc-modal-image-wrapper ul', $modal).append(li2);
                li2.onclick = pagePhoto;
            }

            jQueryStamped('.stamped-ugc-modal-user-source').text(data.via);

            var $modalUsername = jQueryStamped('.stamped-ugc-modal-user-username', $modal);
            // set text
            $modalUsername.text(data.name);

            // set verified buyer label
            $modalUsername.attr('data-verified-type', data.verifiedType);
            $modalUsername.attr('data-username', data.name);

            // applying translations
            var _labelVerifiedBuyer = 'Verified Buyer';
            var _labelShopNow = 'Shop Now';

            if (dataTranslations && lang != 'en') {
                _labelVerifiedBuyer = dataTranslations.label_verified_buyer || _labelVerifiedBuyer;
                _labelShopNow = dataTranslations.label_shop_now || _labelShopNow;
            }

            $modalUsername.append('<span class="stamped-verified-badge">' + _labelVerifiedBuyer + '</span>');
            jQueryStamped('.stamped-ugc-modal-tags-btn', $modal).append('<span>' + _labelShopNow + '</span>');

            var rating = '';

            if (data.rating) {
                for (var r = 0; r < data.rating; r++) {
                    rating += '<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>';
                }

                for (var r = 0; r < 5 - data.rating; r++) {
                    rating += '<i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
            }

            var options = '';

            if (data.options && data.options.length) {
                options += '<ul class="">';
                for (i = 0; i < data.options.length; i++) {
                    var _message = data.options[i].message;
                    var _value = data.options[i].value;
                    var _slugMessage = slugify(_message);

                    options += '<li data-value="' + _slugMessage + '"><span class="stamped-ugc-modal-options-message">' + _message + '</span> <span class="stamped-ugc-modal-options-value">' + _value + '</span></li>';
                }
                options += '</ul>';
            }

            if (!data.reply) {
                data.reply = '';
            }

            // set date
            var date;
            if (data.dateFull) {
                date = new Date(data.dateFull);
            } else {
                date = new Date(data.date);
            }

            var _dateString = new timeagoStamped().formatDateString(date);

            if (lang != "en") {
                _dateString = data.date;
            }

            jQueryStamped('.stamped-ugc-modal-caption', $modal).html('<div class="stamped-ugc-modal-date" data-date="' + data.date + '">' + _dateString + '</div><div class="stamped-ugc-modal-caption-rating">' + rating + '</div><div class="stamped-ugc-modal-caption-options">' + options + '</div><h2 class="stamped-ugc-modal-caption-title">' + (data.title || '') + '</h2>' + ' <div class="stamped-ugc-modal-caption-body">' + data.body + '</div>' + ' <div class="stamped-ugc-modal-caption-reply">' + data.reply + '</div>');

            jQueryStamped('.stamped-ugc-modal-votes', $modal).html('<span class="stamped-ugc-modal-vote-up" aria-pressed="false" role="button" aria-label="Rate review as helpful" tabindex="0" data-count="' + data.votes.up + '" onclick="StampedFn.voteReview(this, ' + data.review_id + ',1)"><i class="stamped-fa stamped-fa-thumbs-up"></i></span><span class="stamped-ugc-modal-vote-down" aria-pressed="false" tabindex="0" role="button" aria-label="Rate review as not helpful" data-count="' + data.votes.down + '" onclick="StampedFn.voteReview(this, ' + data.review_id + ',-1)"><i class="stamped-fa stamped-fa-thumbs-down"></i></span>');

            jQueryStamped('.stamped-ugc-modal-tags', $modal).html('');

            for (i = 0; i < data.products.length; i++) {
                var oTag = data.products[i];

                oTag.title = oTag.title ? oTag.title : "";

                if (urlStore) {
                    oTag.url = oTag.url.replace('?storeUrl=https://', ''); // remove any storeUrl set
                    oTag.url = oTag.url + "?storeUrl=" + urlStore;
                } else if (urlParam) {
                    oTag.url = oTag.url + '?param=' + urlParam;
                }

                var _imgUrl = oTag.imageUrl || oTag.imageLargeUrl;
                if (oTag.imageUrl) {
                    jQueryStamped('.stamped-ugc-modal-tags', $modal).append(templateTag.formatStringStamped('href="' + oTag.url + '" rel="nofollow"', 'src="' + _imgUrl + '"', oTag.title, oTag.productUrl));
                } else {
                    jQueryStamped('.stamped-ugc-modal-tags', $modal).append(templateTag.formatStringStamped('href="' + oTag.url + '" rel="nofollow"', '', oTag.title, oTag.productUrl));
                }
            }

            $modal.attr('data-review-index', idx);
            $modal.attr('data-photo-index', arrPhotoIndex);

            triggerAccessibilityModal();

            if (!$modal.hasClass('open')) {
                $modal.addClass('open');
                jQueryStamped("body").addClass("stamped-modal-open");

                triggerEventStamped('stamped:ugcmodal:open');
            }
        }

        var pageModal = function (direction) {
            if (!$modal.hasClass('open')) {
                return;
            }

            var _idx = $modal.attr('data-review-index');
            var _idxPhoto = $modal.attr('data-photo-index');

            jQueryStamped('[data-direction="right"]', $modal).removeClass('nav-disabled');
            jQueryStamped('[data-direction="left"]', $modal).removeClass('nav-disabled');

            if (direction == 'left') {
                var $prevPhoto = jQueryStamped('.stamped-ugc-modal-list-photos ul li.active').prev();

                $prevPhoto.click();

                // first, trigger
                if (!$prevPhoto.length) {
                    jQueryStamped('[data-direction="left"]', $modal).addClass('nav-disabled');
                }

            } else if (direction == 'right') {

                var $nextLi = jQueryStamped('.stamped-ugc-modal-list-photos ul li.active').next();

                jQueryStamped($nextLi.click());

                // last, trigger
                if (!$nextLi.length) {
                    jQueryStamped('[data-direction="right"]', $modal).addClass('nav-disabled');

                    if ($modal.attr('data-modal-type') == 'instagram') {
                        triggerEventStamped('stamped:ugcmodal:last');
                    }
                }
            } else {
                return;
            }

            /*
        if (_idx >= (arrDataModal.length - 1) || _idx < 0) {
            // reached max, load more if 'load more' button exists
            if (_idx > (arrDataModal.length - 1)) {
                if (jQueryStamped('.stamped-ugc-load-more').length) {
                    jQueryStamped('.stamped-ugc-load-more').click();

                    return;
                } else {
                    _idx = 0;
                }
            }

            if (_idx < 0) {
                _idx = 0;
            }
        }

        //openModal(_idx,_idxPhoto);
        */
        }

        if (arrDataModal != null && arrDataModal.length) {
            openModal(arrDataIndex, arrPhotoIndex);
        }
    }

    function getParamDisplayWidget(obj, page) {
        var ele = jQueryStamped(obj);
        var elementId = ele.attr('data-element-id');
        var widgetType = ele.attr('data-widget-type');

        var widgetPersistHTML = ele.attr('data-widget-persist-data') || false;
        var reviewId = ele.attr('data-review-id');
        var reviewIds = ele.attr('data-review-ids') ? ele.attr('data-review-ids').toString().split(',') : null;
        var productId = ele.attr('data-product-id');
        var productIds = ele.attr('data-product-ids') ? ele.attr('data-product-ids').toString().split(',') : null;
        var productCategory = ele.attr('data-product-category') || ele.attr('data-product-type');
        var productBrand = ele.attr('data-product-brand');
        var productSKU = ele.attr('data-product-sku');
        var productTitle = ele.attr('data-product-title');

        var limitWords = ele.attr('data-limit-words');
        var random = ele.attr('data-random');
        var showAvatar = ele.attr('data-show-avatar');
        var take = ele.attr('data-take');
        var isFillEmpty = ele.attr('data-fill-empty');
        var minRating = ele.attr('data-min-rating');
        var minLength = ele.attr('data-min-length');
        var rating = ele.attr('data-rating');
        var tags = ele.attr('data-tags');
        var tagsExclude = ele.attr('data-tags-exclude');
        var topic = ele.attr('data-topic');

        var isSyndication = ele.attr('data-syndication') || true;

        var isWithPhotos = ele.data('with-photos');
        var isWithVideos = ele.data('with-videos');

        var sortReviews = ele.data('sort-reviews');
        var widgetDataType = ele.data('widget-data');
        var widgetLanguage = ele.data('widget-language');
        var widgetCountryIso = ele.data('widget-country-iso');

        var instagramGalleryId = ele.data('instagram-gallery-id');

        var albumId = ele.data('album-id');

        var customerEmail = ele.data('customer-email');
        var customerFirstName = ele.data('customer-first-name');
        var customerExternalId = ele.data('customer-id');
        var referralCode = widgetType.indexOf('rewards') > -1 ? _objStampedOptions.referral_code : null;

        var isPreview = ele.data('is-preview');

        var currentPage = page || 1;

        var param = {
            type: widgetType,
            reviewId: reviewId,
            reviewIds: reviewIds,
            productId: productId,
            productIds: productIds,
            productCategory: productCategory,
            productBrand: productBrand,
            productSKU: productSKU,
            limitWords: limitWords,
            random: random,
            showAvatar: showAvatar,
            isFillEmpty: isFillEmpty,
            apiKey: window.StampedGlobalOptions.apiKey,
            sId: window.StampedGlobalOptions.sId,
            storeUrl: window.StampedGlobalOptions.storeUrl,
            page: page,
            skip: take,
            minRating: minRating,
            minLength: minLength,
            rating: rating,
            isWithPhotos: isWithPhotos,
            isWithVideos: isWithVideos,
            sortReviews: sortReviews,
            instagramGalleryId: instagramGalleryId,
            albumId: albumId,
            dataType: widgetDataType,
            widgetLanguage: widgetLanguage,
            widgetCountryIso: widgetCountryIso,
            tags: tags,
            tagsExclude: tagsExclude,
            topic: topic,
            isSyndication: isSyndication,
            elementId: elementId,
            customerEmail: customerEmail,
            customerFirstName: customerFirstName,
            customerExternalId: customerExternalId,
            referralCode: referralCode,
            isPreview: isPreview
        };

        return param;
    }

    function loadDataDisplayWidget(obj, page, opt) {
        var endpoint = _objStampedOptions.SECURE_ENDPOINT + '/widget/reviews';
        var param = getParamDisplayWidget(obj, page);

        opt = opt || {};

        jQueryStamped.ajax({
            type: 'GET',
            url: endpoint + '?' + jQueryStamped.param(stripNull(param)),
            dataType: 'json',
            success: function (data, status, xhr) {
                processDataDisplayWidget(obj, data, null, 0, true);

                if (opt.callback) {
                    opt.callback();
                }

            }
        });
    }

    function loadLoyaltyDisplayWidgets(widgets) {
        const queryParams = {}
        if(testLoyalty2023) {
            queryParams.testLoyalty2023 = testLoyalty2023;
            if(testLoyaltyAccount) {
                queryParams.testLoyaltyAccount = testLoyaltyAccount;
            }
        }
        const endpoint = `${_objStampedOptions.SERVICE_HOST.svc_loyalty_widget}/templates/widget?`
        widgets.forEach(widget => {
            jQueryStamped.ajax({
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(widget),
                xhrFields: {
                    withCredentials: true
                },
                url: endpoint + jQueryStamped.param(queryParams),
                success: function (data, status) {
                    let delay = 0;
                    let elementId = data.elementId;
                    let element = jQueryStamped('#stamped-rewards-widget[data-element-id="' + elementId + '"]');
                    processDataDisplayWidget(element, data, data.translations, delay);
                }
            });
        });
    }

    function loadDataBatchDisplayWidget(type, arrParams) {
        var endpoint = _objStampedOptions.SECURE_ENDPOINT + '/widget/reviews/batch';
        jQueryStamped.ajax({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                data: arrParams
            }),
            xhrFields: {
                withCredentials: true
            },
            url: endpoint,
            success: function (data, status, xhr) {
                var arrayLength = data.length;
                var delay = 100;
                for (var i = 0; i < arrayLength; i++) {
                    if (data[i]) {
                        delay += 50;

                        var eleId = data[i].elementId;

                        var ele;
                        if (type == 'rewards') {
                            ele = jQueryStamped('#stamped-rewards-widget[data-element-id="' + eleId + '"]');
                        } else {
                            ele = jQueryStamped('#stamped-reviews-widget[data-element-id="' + eleId + '"]');
                        }

                        processDataDisplayWidget(ele, data[i], data.translations, delay);
                    }
                }
            }
        });
    }

    function processDataDisplayWidget(ele, data, translations, delay, scrollToTop) {
        setTimeout(function () {
            if (data) {
                var template = data.template;
                var lang = data.lang;
                var widgetType = ele.attr('data-widget-type');
                var widgetPersistHTML = ele.data('widget-persist-data') || false;

                // set language
                jQueryStamped(ele).attr('data-lang', lang || 'en');

                if (widgetType != 'instagram-feed' && widgetType != 'instagram-feed-dev' && widgetType != 'visual-gallery' && widgetPersistHTML != true) {
                    // clear object
                    jQueryStamped(ele).html('');
                }

                if (widgetType == 'single') {
                    ele.append(template);
                    StampedWidgetSingleFn;
                    StampedWidgetSingleFn.init(data.data, ele, jQueryStamped);
                } else if (widgetType == 'full-page' || widgetType == 'full-page-nps') {
                    var isRichSnippet = ele.attr('data-rich-snippet');
                    var is_root = location.pathname == "/"; //Equals true if we're at the root
                    if (data.total > 0 && isRichSnippet == 'true' && !is_root) {
                        // create richsnippet
                        var richSnippet = {
                            "@context": "http://schema.org",
                            "@type": "Product",
                            "name": data.shop,
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": data.rating,
                                "reviewCount": data.total
                            }
                        }
                        var script = document.createElement('script');
                        script.type = 'application/ld+json';
                        script.innerHTML = JSON.stringify(richSnippet);
                        document.getElementsByTagName('head')[0].appendChild(script);
                    }

                    ele.append(template);
                    StampedWidgetFullPageFn;
                    StampedWidgetFullPageFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'full-page-multiple') {
                    ele.append(template);
                    StampedWidgetFullPageMultipleFn;
                    StampedWidgetFullPageMultipleFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'reviews-highlight') {
                    ele.append(template);
                    StampedWidgetReviewsHighlightFn;
                    StampedWidgetReviewsHighlightFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'reviews-popup') {
                    ele.append(template);
                    StampedWidgetReviewsPopupFn;
                    StampedWidgetReviewsPopupFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'people-highlight') {
                    ele.append(template);
                    StampedWidgetPeopleHighlightFn;
                    StampedWidgetPeopleHighlightFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'drawer') {
                    ele.append(template);
                    StampedWidgetDrawerFn;
                    StampedWidgetDrawerFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'carousel') {
                    ele.append(template);
                    StampedCarouselFn;
                    StampedCarouselFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'carousel-nps') {
                    ele.append(template);
                    StampedCarouselNPSFn;
                    StampedCarouselNPSFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'carousel-checkout-comments') {
                    ele.append(template);
                    StampedCarouselCheckoutCommentFn;
                    StampedCarouselCheckoutCommentFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'carousel-photos') {
                    ele.append(template);
                    StampedCarouselPhotosFn;
                    StampedCarouselPhotosFn.init(data.data, ele, jQueryStamped);
                } else if (widgetType == 'site-badge') {
                    //var isRichSnippet = ele.attr('data-rich-snippet');
                    //var is_root = location.pathname == "/"; //Equals true if we're at the root
                    //if (data.total > 0 && isRichSnippet == 'true' && !is_root) {
                    //    // create richsnippet
                    //    var richSnippet = {
                    //        "@context": "http://schema.org",
                    //        "@type": "Product",
                    //        "name": data.shop,
                    //        "aggregateRating": {
                    //            "@type": "AggregateRating",
                    //            "ratingValue": data.rating,
                    //            "reviewCount": data.total
                    //        }
                    //    }
                    //    var script = document.createElement('script');
                    //    script.type = 'application/ld+json';
                    //    script.innerHTML = JSON.stringify(richSnippet);
                    //    document.getElementsByTagName('head')[0].appendChild(script);
                    //}

                    ele.append(template);
                    StampedSiteBadgeFn;
                    StampedSiteBadgeFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'top-rated') {
                    ele.append(template);
                    StampedTopRatedFn;
                    StampedTopRatedFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'wall-photos') {
                    ele.append(template);
                    StampedWallPhotosFn;
                    StampedWallPhotosFn.init(data, ele, jQueryStamped);
                    if (scrollToTop) {
                        jump(ele);
                    }
                } else if (widgetType == 'checkout-comments') {
                    ele.append(template);
                    StampedCheckoutCommentsFn;
                    StampedCheckoutCommentsFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'instagram-feed') {
                    if (jQueryStamped(ele).is(':empty')) {
                        ele.append(template);
                    }
                    StampedInstagramFeedFn;
                    StampedInstagramFeedFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'visual-gallery') {
                    if (!window.stampedVisualGalleryDataArr) {
                        ele.append(template);
                    }
                    StampedVisualGalleryFeedFn;
                    StampedVisualGalleryFeedFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'facebook-messenger-optin') {
                    StampedFacebookMessengerOptinFn;
                    StampedFacebookMessengerOptinFn.init(data, ele, jQueryStamped);
                } else if (widgetType == 'nps-submission-form') {
                    ele.append(template);
                    StampedNPSSubmissionForm;
                    StampedNPSSubmissionForm.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-summary') {
                    ele.append(template);
                    StampedRewardsSummary;
                    StampedRewardsSummary.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-how-it-works') {
                    ele.append(template);
                    StampedRewardsHowItWorks;
                    StampedRewardsHowItWorks.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-referral-modal') {
                    ele.append(template);
                    StampedRewardsReferralModal;
                    StampedRewardsReferralModal.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-referral-claim-modal') {
                    ele.append(template);
                    StampedRewardsReferralClaimModal;
                    StampedRewardsReferralClaimModal.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-earnings' || widgetType == 'rewards-earnings-v2') {
                    ele.append(template);
                    StampedRewardsEarnings;
                    StampedRewardsEarnings.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-spendings' || widgetType == 'rewards-spendings-v2') {
                    ele.append(template);
                    StampedRewardsSpendings;
                    StampedRewardsSpendings.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-vip-tiers') {
                    ele.append(template);
                    StampedRewardsVIPTiers;
                    StampedRewardsVIPTiers.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-referral') {
                    ele.append(template);
                    StampedRewardsReferral;
                    StampedRewardsReferral.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-activities') {
                    ele.append(template);
                    StampedRewardsActivities;
                    StampedRewardsActivities.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-redeem-variable-slider') {
                    ele.append(template);
                    StampedRewardsRedeemVariableSlider;
                    StampedRewardsRedeemVariableSlider.init(data, ele, jQueryStamped);
                } else if (widgetType == 'rewards-redeem-select-options') {
                    ele.append(template);
                    StampedRewardsRedeemSelectOptions;
                    StampedRewardsRedeemSelectOptions.init(data, ele, jQueryStamped);
                }

                handleFreePlanStampedBanner();
                triggerEventStamped('stamped:reviews:widget:loaded');
            }
        }, delay);
    }

    function handleFreePlanStampedBanner() {
        var freeTierBanner = jQueryStamped(".free-tier-banner");
        if (freeTierBanner.lenght < 1) {
            jQueryStamped(".free-tier-banner").detach().appendTo('#stamped-reviews-widget');
        }
    }

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }

        else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/; SameSite=None; Secure";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    function stripNull(obj) {
        for (var i in obj) {
            if (obj[i] === null || obj[i] === "" || typeof obj[i] === 'undefined') delete obj[i];
        }
        return obj;
    }

    function serializeObject(t) {
        var o = {};

        if (!jQueryStamped(t).hasClass('new-review-form')) {
            t = jQueryStamped(t).parents(".new-review-form");
        }

        var a = jQueryStamped('input,textarea,select,radio', t).serializeArray();
        jQueryStamped.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    function repeat(s, n) {
        var a = [],
            i = 0;
        for (; i < n;) a[i++] = s;
        return a.join('');
    }

    var _isAnimating = false;
    function jump(h) {
        if (jQueryStamped(h).length) {
            var animation = jQueryStamped(ID_MAIN_WIDGET).attr('data-animation');
            stampedLog('Animation: ' + animation);

            if (animation === 'false' || animation === false) { } else {
                if (_isAnimating == true) { return; }

                _isAnimating = true;

                var curElem = jQueryStamped(h);

                var page = jQueryStamped("html, body");

                var offset = jQueryStamped(ID_MAIN_WIDGET).attr('data-offset')
                    || jQueryStamped(h).attr('data-offset')
                    || 1;

                if (mobileCheck()) {
                    offset = jQueryStamped(ID_MAIN_WIDGET).attr('data-offset-mobile')
                        || jQueryStamped(h).attr('data-offset-mobile')
                        || 1;
                }

                page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
                    page.stop();
                    _isAnimating = false;
                });

                page.animate({ scrollTop: curElem.offset().top - offset }, (animation || 1000), function () {
                    page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                    _isAnimating = false;
                });
            }
        }
    }

    function slugify(text) {
        return text.toString().toLowerCase().trim()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    }

    if (!String.linkify) {
        String.prototype.linkify = function () {
            // http://, https://, ftp://
            var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
            // www. sans http:// or https://
            var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            // Email addresses
            var emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;
            return this
                .replace(urlPattern, '<a href="$&" target="_blank">$&</a>')
                .replace(pseudoUrlPattern, '$1<a href="http://$2" target="_blank">$2</a>')
                .replace(emailAddressPattern, '<a href="mailto:$&">$&</a>');
        };
    }

    // public methods
    function toggleForm(type) {
        if (type == 'review') {
            _switchTab(null, 'reviews');
            var form = jQueryStamped('.new-review-form');
            var form2 = jQueryStamped('.new-question-form');
            form2.slideUp();
            form2.removeClass("stamped-visible");

            if (form.hasClass("stamped-visible")) {
                form.slideUp();
                form.removeClass("stamped-visible");
                form.attr('aria-expanded', 'false');
            } else {
                form.slideDown(400, function () {
                    jump('#stamped-main-widget .new-review-form');
                });
                form.addClass("stamped-visible");
                form.attr('aria-expanded', 'true');
            }

            if (jQueryStamped(form).find('input[type=text]').length > 0)
                jQueryStamped(form).find('input[type=text]').get(0).focus();

        } else if (type == 'question') {
            _switchTab(null, 'questions');

            var form = jQueryStamped('.new-question-form');
            var form2 = jQueryStamped('.new-review-form');
            form2.slideUp();
            form2.removeClass("stamped-visible");

            if (form.hasClass("stamped-visible")) {
                form.slideUp();
                form.removeClass("stamped-visible");
            } else {
                form.slideDown(400, function () {
                    jump('.new-question-form');
                });
                form.addClass("stamped-visible");

                // update review form's aria-expanded attribute when showing the question form
                form2.attr('aria-expanded', 'false');
            }

            if (jQueryStamped(form).find('input[type=text]').length > 0)
                jQueryStamped(form).find('input[type=text]').get(0).focus();
        }


    }

    function toggleFormEdit() {
        jQueryStamped('.edit-review-form', eleStampedMainWidget).toggle();
    }

    function setRating(t) {
        var e, n, i;
        e = jQueryStamped(t).parents(".new-review-form"),
            i = jQueryStamped(t).attr("data-value"),
            n = jQueryStamped(t).parent(),
            e.find("input[name='reviewRating']").val(i),
            setStarRating(i, n);

        triggerAccessibilityRating(t);
    }

    function setStarRating(t, e) {
        e.find("a:lt(" + t + ")").removeClass("fa-star-o").addClass("fa-star-checked"),
            e.find("a:gt(" + (t - 1) + ")").removeClass("fa-star-checked").addClass("fa-star-o");
    }

    function submitForm(t) {
        // check whether update or create form
        //var isEditForm = jQueryStamped(t).hasClass('edit-review-form');
        var labelSubmitting = eleStampedMainWidget.data('label-submitting');
        var labelSubmit = jQueryStamped(".new-review-form .stamped-button-primary", eleStampedMainWidget).val();

        var paramObj = null;
        //if (isEditForm) {
        //method = "PUT";
        //}

        var e;
        e = serializeObject(t);

        if (!e.reviewRating) { // && !isEditForm
            return;
        }
        if (!e.author) {
            return;
        }

        if (!(e.reviewMessage.trim())) {
            return;
        }

        var productParams = {
            productName: eleStampedMainWidget.attr('data-name'),
            productId: eleStampedMainWidget.attr('data-product-id'),
            productSKU: eleStampedMainWidget.attr('data-product-sku'),
            productType: eleStampedMainWidget.attr('data-product-type'),
            productDescription: eleStampedMainWidget.attr('data-description'),
            productImageUrl: eleStampedMainWidget.attr('data-image-url'),
            productUrl: eleStampedMainWidget.attr('data-url'),
            reviewSource: 'widget',
            userReference: eleStampedMainWidget.attr('data-user-reference')
        };
        e = jQueryStamped.extend(e, productParams);
        paramObj = e;

        //e = jQueryStamped.param(e);
        //e = e.replace(/%0D%0A/g, "%0A");

        var form_data = new FormData();

        for (var key in e) {
            var val = e[key];

            if (val.indexOf('+') > -1 && key.indexOf('customFormOption') > -1) {
                val = e[key].replace('+', '%2B');//encodeURIComponent(e[key]);
            }

            form_data.append(key, val);
        }

        var _idxPhoto = 0;
        for (var photo in arrPhotosUpload) {
            form_data.append('image' + _idxPhoto, arrPhotosUpload[_idxPhoto]);
            e['image' + _idxPhoto] = arrPhotosUpload[_idxPhoto];

            _idxPhoto++;
        }

        stampedLog(Object.prototype.toString.call(form_data));
        stampedLog(form_data);

        var _ajaxOpts = {
            url: "" + _objStampedOptions.SECURE_ENDPOINT + "/reviews3?" + jQueryStamped.param(stripNull({
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl
            })),
            cache: false,
            processData: false,
            contentType: false,
            type: 'POST',
            data: form_data._blob ? form_data._blob() : form_data,
            beforeSend: function (t) {
                jQueryStamped("#stamped-button-submit", eleStampedMainWidget).attr("disabled", "disabled");

                if (labelSubmitting) {
                    jQueryStamped("#stamped-button-submit", eleStampedMainWidget).val(labelSubmitting);
                }
            },
            error: function (t) {
                triggerEventStamped('stamped:reviews:submitError');

                if (_objStampedOptions.is_ignore_submit_error == true) {
                    submitSuccess(paramObj, t, productParams, labelSubmit);
                }
                else {
                    jQueryStamped("#stamped-button-submit", eleStampedMainWidget).removeAttr("disabled");

                    if (labelSubmit) {
                        jQueryStamped("#stamped-button-submit", eleStampedMainWidget).val(labelSubmit);
                    }
                }
            },
            success: function (t) {
                submitSuccess(paramObj, t, productParams, labelSubmit);
            }
        };

        jQueryStamped.ajax(_ajaxOpts);
    }

    function submitSuccess(paramObj, t, productParams, labelSubmit) {
        if (jQueryStamped(ID_MAIN_WIDGET).length) {
            _setThankYouShareLinks(paramObj);

            jQueryStamped('.stamped-user-review', eleStampedMainWidget).hide();
            jQueryStamped('.stamped-thank-you', eleStampedMainWidget).show();

            jQueryStamped('.stamped-thank-you p', eleStampedMainWidget).show();
            jQueryStamped('.stamped-thank-you .stamped-share-links', eleStampedMainWidget).show();

            // hide forms
            jQueryStamped('.new-review-form', eleStampedMainWidget).hide();
            jQueryStamped('.edit-review-form', eleStampedMainWidget).hide();
            // hide write a review button
            jQueryStamped('.stamped-summary-actions-newreview').hide();
            jQueryStamped("#stamped-button-submit", eleStampedMainWidget).removeAttr("disabled");

            if (labelSubmit) {
                jQueryStamped("#stamped-button-submit", eleStampedMainWidget).val(labelSubmit);
            }

            // jump to the div with id
            jump(ID_MAIN_WIDGET);

            // set cookie so can edit review
            _initUserReview(productParams.productId, t.userReference, true);
        }

        triggerEventStamped('stamped:reviews:submitted');
    }

    function submitQuestionForm(objForm) {
        // validate form
        // submits
        var $formQuestion = !!objForm ? jQueryStamped(objForm) : jQueryStamped('#new-question-form');
        var mainWidget = jQueryStamped(ID_MAIN_WIDGET);

        if ($formQuestion.length && mainWidget.length) {
            // get the form info via .json of the product page
            var name = mainWidget.data('name');
            var description = mainWidget.data('description');
            var sku = mainWidget.data('product-sku');
            var url = mainWidget.data('url');
            var imageUrl = mainWidget.data('image-url');
            var data = $formQuestion.serializeArray(); // convert form to array

            data.push({
                name: 'productName',
                value: name
            });
            data.push({
                name: 'productDescription',
                value: description
            });
            data.push({
                name: 'productSKU',
                value: sku
            });
            data.push({
                name: 'productUrl',
                value: url
            });
            data.push({
                name: 'productImageUrl',
                value: imageUrl
            });
            data.push({
                name: 'apiKey',
                value: window.StampedGlobalOptions.apiKey
            });
            data.push({
                name: 'sId',
                value: window.StampedGlobalOptions.sId
            });
            data.push({
                name: 'storeUrl',
                value: window.StampedGlobalOptions.storeUrl
            });

            // disable submit
            jQueryStamped('input[type="submit"]', $formQuestion).attr('disabled', 'disabled');

            jQueryStamped.ajax({
                type: 'POST',
                url: 'https://stamped.io/api/questions',
                data: jQueryStamped.param(data),
                crossDomain: true,
                success: function (data) {
                    // hide form
                    $formQuestion.hide();
                    // show thank you message
                    jQueryStamped('.question-form-wrapper .stamped-form-message-success').show();
                    jQueryStamped('.stamped-form-message-success').attr('aria-live', 'polite');
                    // clear form inputs
                    $formQuestion[0].reset();

                    jQueryStamped('input[type="submit"]', $formQuestion).removeAttr('disabled');
                }
            });
        }
    }

    function pageQuestions(obj) {
        var page = 1;

        if (obj) {
            page = jQueryStamped(obj).data('page');
        }

        _loadQuestionsAndAnswers(page);
    }

    function pageReviews(page, rating, obj) {

        if (!jQueryStamped) {
            if (jQuery) {
                jQueryStamped = jQuery;
            }
        }

        // set the eleStampedMainWidget variable to the closest object incase there's multiple main widget on one page
        if (obj && jQueryStamped(obj).closest(ID_MAIN_WIDGET).length) {
            eleStampedMainWidget = jQueryStamped(obj).closest(ID_MAIN_WIDGET);
        }

        var productId = eleStampedMainWidget.attr('data-product-id');
        var _rating = jQueryStamped('.stamped-summary-ratings.selected .summary-rating-bar.selected', eleStampedMainWidget).attr('data-rating');

        if (_rating) {
            rating = _rating;
        }

        // get sort value
        var sort;
        if (jQueryStamped('.stamped-sort-select', eleStampedMainWidget).length) {
            sort = jQueryStamped('.stamped-sort-select', eleStampedMainWidget).val();
        }

        _loadWidget(page, sort, rating);
    }

    function sortReviews(obj) {
        var productId = eleStampedMainWidget.attr('data-product-id');
        if (obj.value) {
            _loadWidget(1, obj.value, null, true);
        }
    }

    function sortQuestions(obj) {
        if (obj.value) {
            _loadQuestionsAndAnswers(1, obj.value);
        }
    }

    function filterReviews(input) {
        var qTitle1 = jQueryStamped('option:first-child', input).text();
        var qValue1 = (input.value);

        objFilterMainWidget = {};

        var _count = 1;
        // build a list of qt and qv object
        jQueryStamped("select.stamped-filter-select").each(function () {
            var qTitle = jQueryStamped('option:first-child', this).text();
            var qValue = (this.value);

            objFilterMainWidget["qt" + _count] = qTitle;
            objFilterMainWidget["qv" + _count] = qValue;
            _count++;
        });

        jQueryStamped('.stamped-reviews-filter .stamped-summary-actions-clear').show();

        jQueryStamped('.stamped-reviews', eleStampedMainWidget).attr('data-filtered', 'true');

        var sort;
        if (jQueryStamped('.stamped-sort-select').length) {
            sort = jQueryStamped('.stamped-sort-select').val();
        }

        _loadWidget(1, sort, null, true);

        if (qTitle1 && qValue1) {
            _apiTrackSearch({
                customOptionTitle: qTitle1,
                customOptionValue: qValue1
            }, eleStampedMainWidget.attr('data-product-id'));
        }
    }

    function filterClear(type) {
        if (type == "qna") {
            jQueryStamped('.stamped-questions-filter .stamped-summary-actions-clear').hide();
            jQueryStamped('.stamped-questions-search-input').val('');
            jQueryStamped('.stamped-questions-search-clear').hide();

            jQueryStamped(eleStampedMainWidget).removeAttr('data-search-qna');

            pageQuestions();

        } else {
            jQueryStamped("select.stamped-filter-select").each(function () {
                jQueryStamped(this).val('');
            });

            jQueryStamped('.stamped-summary-keywords-list li').removeClass("selected");
            jQueryStamped(eleStampedMainWidget).removeAttr('data-keyword');

            jQueryStamped('.stamped-reviews-filter .stamped-summary-actions-clear').hide();

            jQueryStamped('.stamped-reviews', eleStampedMainWidget).removeAttr('data-filtered');

            var sort;
            if (jQueryStamped('.stamped-sort-select').length) {
                sort = jQueryStamped('.stamped-sort-select').val();
            }

            objFilterMainWidget = {};

            jQueryStamped('.stamped-reviews-search-input').val('');
            jQueryStamped('.stamped-reviews-search-clear').hide();
            jQueryStamped(eleStampedMainWidget).removeAttr('data-search');

            _clearRatingFilter();

            _loadWidget(1, sort, null, true);
        }
    }

    function pageWidget(obj, opt) {
        var page = jQueryStamped(obj).data('page');
        var widget = jQueryStamped(obj).closest('#stamped-reviews-widget');
        widget.attr('data-page', page);

        loadDataDisplayWidget(widget, page, opt);
    }

    function voteReview(obj, reviewId, rating) {
        var $eleRating = jQueryStamped(obj);
        var $eleParent = $eleRating.parent();
        $eleParent.fadeTo("slow", 0.3);
        $eleRating.addClass('disable-link');

        jQueryStamped.ajax({
            type: 'POST',
            url: _objStampedOptions.SECURE_ENDPOINT + '/reviews/vote',
            data: {
                reviewId: reviewId,
                vote: rating,
                apiKey: window.StampedGlobalOptions.apiKey,
                sId: window.StampedGlobalOptions.sId,
                storeUrl: window.StampedGlobalOptions.storeUrl
            },
            success: function (data) {
                jQueryStamped('.stamped-thumbs-up', $eleParent).attr('data-count', data.voteUp);
                jQueryStamped('.stamped-thumbs-down', $eleParent).attr('data-count', data.voteDown);

                jQueryStamped('.stamped-ugc-modal-vote-up', $eleParent).attr('data-count', data.voteUp);
                jQueryStamped('.stamped-ugc-modal-vote-down', $eleParent).attr('data-count', data.voteDown);

                jQueryStamped('.stamped-thumbs-up i', $eleParent).html('&nbsp; ' + (data.voteUp));
                jQueryStamped('.stamped-thumbs-down i', $eleParent).html('&nbsp; ' + (data.voteDown));

                $eleParent.fadeTo("slow", 1);
                $eleRating.removeClass('disable-link');
            }
        });
    }

    var loadingPhotosArr = false;
    var loadPhotoProductId = null;
    var lastLang = null;

    function openUGCPhoto(reviewId, productId, photoIdx, isMainWidget) {
        // check if loaded carousel photos for the product
        if (
            !loadingPhotosArr
        ) {
            loadingPhotosArr = true;
            var review_url = _objStampedOptions.SECURE_ENDPOINT + '/widget/reviews';

            var productSKU = jQueryStamped(eleStampedMainWidget).attr('data-product-sku') || '';
            var productTitle = '';
            var productType = '';
            var reviewIds = [];

            if (isMainWidget === true) {
                productId = jQueryStamped(eleStampedMainWidget).attr('data-product-id') || '';
                productTitle = jQueryStamped(eleStampedMainWidget).attr('data-name') || '';
                productType = jQueryStamped(eleStampedMainWidget).attr('data-product-type') || '';
            } else {
                // loop through and get all review Ids
                jQueryStamped('.stamped-reviews .stamped-review', eleStampedMainWidget).each(function () {
                    var $this = jQueryStamped(this);
                    var _id = $this.attr('id');

                    _id = _id.replace('stamped-review-', '');

                    if (_id) {
                        reviewIds.push(_id);
                    }
                });
            }

            jQueryStamped.ajax({
                type: 'GET',
                url: review_url + '?' + jQueryStamped.param(stripNull({
                    type: 'widget-carousel-photos',
                    reviewId: reviewId,
                    reviewIds: reviewIds,
                    productId: productId,
                    productSKU: productSKU,
                    productType: productType,
                    productTitle: productTitle,
                    random: false,
                    isFillEmpty: false,
                    page: 1,
                    skip: 100,
                    minRating: 1,
                    isWithPhotos: true,
                    apiKey: window.StampedGlobalOptions.apiKey,
                    sId: window.StampedGlobalOptions.sId,
                    storeUrl: window.StampedGlobalOptions.storeUrl
                })),
                dataType: 'json',
                success: function (data, status, xhr) {
                    arrPhotosLoadedData = data.data;

                    var idx = null;
                    for (var i = 0; i < arrPhotosLoadedData.length; i++) {
                        if (arrPhotosLoadedData[i]['id'] == reviewId) {
                            idx = i;
                        }
                    }

                    if (idx != null) {
                        if (photoIdx) {
                            //idx = idx + photoIdx;
                        }

                        lastLang = data.lang;
                        StampedFn.openUGCModal(arrPhotosLoadedData, idx, jQueryStamped(ID_MAIN_WIDGET), null, null, photoIdx, lastLang, data.translations);
                    }

                    loadingPhotosArr = false;
                    loadPhotoProductId = productId;
                }
            });
        } else {
            var idx = null;
            for (var i = 0; i < arrPhotosLoadedData.length; i++) {
                if (arrPhotosLoadedData[i]['id'] == reviewId) {
                    idx = i;
                }
            }

            if (idx != null) {
                if (photoIdx) {
                    //idx = idx + photoIdx;
                }

                StampedFn.openUGCModal(arrPhotosLoadedData, idx, jQueryStamped(ID_MAIN_WIDGET), null, null, photoIdx, lastLang);
            }

            loadingPhotosArr = false;
        }

        return false;
    }

    function loadSurveyOptin(opts) {
        var countLoop;
        var existCondition = setInterval(function () {
            if (typeof window.StampedGlobalOptions !== "undefined") {
                if (opts !== null) {
                    if (opts.orderId) {
                        jQueryStamped.ajax({
                            type: 'GET',
                            url: 'https://stamped.io/api/plugin/facebookmessenger?' + jQueryStamped.param(stripNull({
                                apiKey: window.StampedGlobalOptions.apiKey,
                                sId: window.StampedGlobalOptions.sId,
                                storeUrl: window.StampedGlobalOptions.storeUrl,
                                orderId: opts.orderId,
                                customerEmail: opts.customerEmail
                            })),
                            success: function (data) {
                                jQueryStamped('body').append(data.html);

                                var htmlFBButton = jQueryStamped('#stamped-facebook-optin .fb-send-to-messenger')[0].outerHTML;

                                var iframe = document.createElement('iframe');
                                iframe.height = "100";
                                iframe.width = "100%";
                                var html = "<!DOCTYPE html> <html> <head> <meta charset='utf-8' /> <title></title> </head> <script> var fbPageId, fbUserRef; window.fbAsyncInit = function() { FB.init({ appId : '941057476855139', xfbml : true, version : 'v6.0' }); FB.Event.subscribe('send_to_messenger', function(e) { var modal = window.top.document.getElementById('stamped-facebook-optin'); if (e.event == 'rendered'){ modal.style.display = 'block'; } if (e.event == 'opt_in'){ console.log('hide'); modal.style.display = 'none'; } }); }; (function(d, s, id){ var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = '//connect.facebook.net/en_US/sdk.js'; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-jssdk') ); </script> <body>" + htmlFBButton + "</body> </html>";
                                document.body.appendChild(iframe);
                                jQueryStamped(iframe).appendTo("#stamped-facebook-optin .fb-send-to-messenger");
                                iframe.contentWindow.document.open();
                                iframe.contentWindow.document.write(html);
                                iframe.contentWindow.document.close();
                            }
                        });
                    }
                }

                clearInterval(existCondition);
            }

            countLoop++;
            if (countLoop >= 5) {
                clearInterval(existCondition);
            }
        }, 2000);
    }

    function closeSurveyOptin() {
        jQueryStamped('#stamped-facebook-optin').remove();
    }

    function getParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function stampedLog(message, level) {
        var isDebug = getParameterByName('stamped_debug') == 'true' || window.stamped_debug == true;

        var debugLevel = window.stamped_debug_level || getParameterByName('stamped_debug_level');

        if (isDebug) {
            if (!level) {
                console.log('[Stamped.io]', message);
            }

            if (level && debugLevel) {
                console.log('[Stamped.io level' + debugLevel + ']', message);
            }
        }
    }

    function loadJS(url, callback) {
        //console.log('loading JS:' + url);
        script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'UTF-8';
        script.src = url;
        var t = document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(script, t);

        script.onload = script.onreadystatechange = callback;
    };

    function loadStyle(href) {
        // avoid duplicates
        var ss = document.styleSheets;
        for (var i = 0, max = ss.length; i < max; i++) {
            if (ss[i] && ss[i].href) {
                if (ss[i].href.indexOf(href) > -1) {
                    return;
                }
            }
        }

        var giftofspeed = document.createElement('link');
        giftofspeed.rel = 'stylesheet';
        giftofspeed.href = href;
        giftofspeed.type = 'text/css';
        var godefer = document.getElementsByTagName('link')[0];

        if (godefer) {
            godefer.parentNode.insertBefore(giftofspeed, godefer);
        } else {
            var head = document.getElementsByTagName('head')[0];
            giftofspeed.setAttribute("async", "");

            head.appendChild(giftofspeed);
        }
    }

    function _localStorageAdd(key, data) {
        try {
            if (typeof Storage !== "undefined") {
                localStorage.setItem(key, JSON.stringify(data));

                return true;
            }
            else {
                return false;
            }
        } catch (ex) {

        }
    }

    function _localStorageGet(key, checkExpire) {
        try {
            if (typeof Storage !== "undefined") {
                var data;
                try {
                    data = JSON.parse(localStorage.getItem(key)) || null;
                } catch (e) {
                    data = localStorage.getItem(key);
                }

                return data;
            }
            else {
                return false;
            }
        } catch (ex) {
        }
    }

    function _setOptions(opts) {
        Object.assign(_objStampedOptions, opts);
    }

    function _getOptions() {
        return _objStampedOptions;
    }

    function getAppKey(shopType, identifier) {
        var _appKey = 'stamped_app_key';
        var _appKeyData = _localStorageGet(_appKey);
        var expiry = Date.now() + 60*60*48*1000 // 2day!

        if (_appKeyData && _appKeyData.apiKey && (_appKeyData.expiry || 0) > Date.now()) {
            stampedLog(_appKeyData);
            triggerEventStamped('stamped:init:getAppKey', { detail: _appKeyData });
            init(_appKeyData);
        }
        else {
            var xmlhttp;
            xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
                    var data = JSON.parse(xmlhttp.responseText);

                    if (data && data.apiKey) {
                        data.expiry = expiry;
                        _localStorageAdd(_appKey, data);
                        triggerEventStamped('stamped:init:getAppKey', { detail: data });

                        if (data.skip === true) {

                        } else {
                            var appKey = data.apiKey;

                            var _initOpts = {
                                apiKey: appKey
                            };

                            if (typeof Shopify !== 'undefined') {
                                _initOpts.storeUrl = Shopify.shop;
                            } else {
                                _initOpts.sId = data.sId;
                            }

                            // init widgets

                            init(_initOpts);
                        }
                    }
                }
            };

            var param = '';
            if (shopType == 'shopify') {
                param = 'shopShopifyDomain=' + identifier;
            }
            else if (shopType == 'bigcommerce') {
                param = 'storeHash=' + identifier;
            }

            xmlhttp.open("GET", 'https://stamped.io/api/getappkey?' + param, true);

            xmlhttp.send();
        }
    }

    function init(opts) {
        if (window.isInitializedStamped == true) {
            stampedLog('Already initalized');
            StampedFn.loadWidget(true);
            StampedFn.loadDisplayWidgets();

            return;
        } else {
            window.isInitializedStamped = true;
        }

        if (opts) {
            globalStoreUrl = opts.storeUrl;
            //stampedLog(opts);
            window.StampedGlobalOptions = opts;

            // Exclude Google Fonts from load
            if(opts.exclude_font) {
                window.StampedGlobalOptions.exclude_font = opts.exclude_font;
            }
        }

        if (!window.StampedGlobalOptions || !window.StampedGlobalOptions.apiKey) {
            return;
        }

        var isForceLoadJQuery = getParameterByName('stamped_force_jquery') == 'true' || _objStampedOptions.is_force_jquery;

        // initalize jQuery
        if (typeof jQuery === 'undefined' || isForceLoadJQuery == true) {
            loadJS('https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js', function () {
                jQueryStamped = jQuery.noConflict(true);

                _init();

                window.isInitializedStamped = true;
            });
        } else {
            _init(null, jQuery);

            window.isInitializedStamped = true;
        }
    }

    // check script tag param skip CSS
    var scriptTag = document.getElementById('stamped-script-widget');

    if (!scriptTag) {
        scriptTag = document.getElementById('stamped-script-init');
    }

    var url = '';
    if (scriptTag) {
        url = scriptTag.src;
    }

    var isExcludeMainCSS = false;
    if ((url.indexOf('skipCss=true') > 0) || _objStampedOptions.exclude_main_css == true) {
        isExcludeMainCSS = true;
    }

    if (!isExcludeMainCSS) {
        loadStyle('//cdn1.stamped.io/files/widget.min.css');
    }

    // check if shopify store
    if (typeof Shopify !== 'undefined') {
        var skip = false;
        if (Shopify.shop) {
            if (scriptTag != null) {

                if (url.indexOf('skip=true') > -1) {
                    skip = true;
                }

                var apiKey = scriptTag.getAttribute('data-api-key');

                if (!apiKey && url.indexOf('apiKey') > -1) {
                    apiKey = getParameterByName('apiKey', url);
                }

                if (apiKey) {
                    skip = true;

                    // init
                    init({
                        apiKey: apiKey,
                        storeUrl: Shopify.shop
                    });
                }
            }

            if (!skip) {
                getAppKey('shopify', Shopify.shop);
            }
        }

        // check if Shopify checkout, if yes, add JS codes

        if (Shopify.Checkout && typeof StampedShopifyCheckout == "undefined") {
            if (typeof window.StampedShopifyCheckout === "function") {
                return false;
            }

            loadJS('//cdn1.stamped.io/files/shopify-checkout.min.js', function () {
                triggerEventStamped('stamped:script-shopify-checkout:loaded');
            });
        }
    }

    if (scriptTag != null) {
        // check if bigcommerce store
        var storeHash = scriptTag.getAttribute('data-store-hash');

        if (storeHash) {
            getAppKey('bigcommerce', storeHash);
        }

        // check if custom store
        var scriptStoreId = scriptTag.getAttribute('data-store-id');
        var scriptApiKey = scriptTag.getAttribute('data-api-key');
        var scriptAutoInit = scriptTag.getAttribute('data-auto-init');

        if (scriptStoreId && scriptApiKey && scriptAutoInit != 'false') {
            // init
            init({
                apiKey: scriptApiKey,
                sId: scriptStoreId
            });
        }
    }

    function addEventListenerStamped(eventName, handler) {
        if (document.addEventListener) { document.addEventListener(eventName, handler); }
        else { document.attachEvent('on' + eventName, function () { handler.call(document); }); }
    }

    function triggerEventStamped(eventName, options) {
        var event;
        if (window.CustomEvent) {
            event = new CustomEvent(eventName, options);
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, options);
        }

        try {
            document.dispatchEvent(event);
        } catch (e) {

        }
    }

    function triggerAccessibilityMain() {
        //tablist
        jQueryStamped('.stamped-tabs > li').click(function () {
            var children = Array.prototype.slice.call(this.parentNode.children);
            children.forEach(function (tab) {
                tab.setAttribute('aria-selected', false);
            });

            var isSelected = this.getAttribute('aria-selected');
            this.setAttribute('aria-selected', !(JSON.parse(isSelected)));
        });

        //share icon
        jQueryStamped('.stamped-share-icon').click(function () {
            // set aria-expanded attribute of link span controlled by this Share button for accessibility
            var shareLinksSpan = jQueryStamped(this).siblings('.stamped-share-links');
            var attrExpanded = shareLinksSpan.attr('aria-expanded');
            var isExpanded = (typeof attrExpanded !== 'undefined' && attrExpanded !== false) ? attrExpanded : "false";
            shareLinksSpan.attr('aria-expanded', (isExpanded == "true" ? "false" : "true"));

            jQueryStamped(this).toggleClass('stamped-active');
        });

        //rate review helpful
        jQueryStamped('.stamped-rating-holder > a').click(function () {
            var children = Array.prototype.slice.call(this.parentNode.children);
            children.forEach(function (tab) {
                tab.setAttribute('aria-pressed', false);
            });

            var isSelected = this.getAttribute('aria-pressed');
            this.setAttribute('aria-pressed', !(JSON.parse(isSelected)));
        });
    }

    function triggerAccessibilityPaginationFullPage() {
        //review pagination
        var paginationItems = Array.prototype.slice.call(jQueryStamped('.stamped-pagination > li'));
        paginationItems.forEach(function (item) {
            if (item.classList.contains('active')) {
                item.children[0].setAttribute('aria-current', 'page');
            } else {
                item.removeAttribute('aria-current');
            }
        });
    }

    function triggerAccessibilityModal() {
        //like & dislike button for carousel
        jQueryStamped('.stamped-ugc-modal-votes > span').click(function () {
            var children = Array.prototype.slice.call(this.parentNode.children);
            children.forEach(function (tab) {
                tab.setAttribute('aria-pressed', false);
            });

            var isSelected = this.getAttribute('aria-pressed');
            this.setAttribute('aria-pressed', !(JSON.parse(isSelected)));
        });
    }

    function triggerAccessibilityRating(ctrl) {
        //rating + stars
        var children = Array.prototype.slice.call(ctrl.parentNode.children);
        children.forEach(function (tab) {
            tab.setAttribute('aria-pressed', false);
        });

        var isSelected = ctrl.getAttribute('aria-pressed');
        ctrl.setAttribute('aria-pressed', !(JSON.parse(isSelected)));
    }

    function showSnackbar(_wrapper, _message, _type = 'success') {
        var className = 'stamped-snackbar';
        var hideAfter = 5000;

        // Remove any existing snackbars
        var existingSnackbars = _wrapper.getElementsByClassName(className);
        for (var i = 0; i < existingSnackbars.length; i++) {
            existingSnackbars[i].remove();
        }

        var snackbar = document.createElement('div');
        var textWrapper = document.createElement('div');
        textWrapper.classList.add(`${className}__text-wrapper`);
        var text = document.createElement('span');
        text.innerHTML = _message;

        var icon = document.createElement('i');
        var closeButtonIcon = document.createElement('i');
        closeButtonIcon.classList.add('fa-light', 'fa-xmark');
        var closeButton = document.createElement('button');
        closeButton.appendChild(closeButtonIcon);

        // Make sure we handle the close button click
        closeButton.addEventListener('click', function () {
            snackbar.remove();
        });

        switch (_type) {
            case 'success':
                icon.classList.add('fa-solid', 'fa-circle-check');
                break;
            case 'error':
                icon.classList.add('fa-solid', 'fa-circle-exclamation');
                break;
        }

        textWrapper.appendChild(icon);
        textWrapper.appendChild(text);
        snackbar.appendChild(textWrapper);
        snackbar.appendChild(closeButton);

        snackbar.classList.add(className, `${className}--${_type}`);

        // Add the snackbar to the wrapper div
        _wrapper.appendChild(snackbar);

        // Per spec, the snackbar will only be shown for 5 seconds
        setTimeout(function () {
            snackbar.remove();
        }, hideAfter);
    }

    return {
        init: init,
        initRewards: _startRewards,
        reloadUGC: _startUGC,
        toggleForm: toggleForm,
        setRating: setRating,
        submitForm: submitForm,
        submitQuestionForm: submitQuestionForm,
        toggleFormEdit: toggleFormEdit,
        pageQuestions: pageQuestions,
        sortQuestions: sortQuestions,
        pageReviews: pageReviews,
        sortReviews: sortReviews,
        filterReviews: filterReviews,
        filterClear: filterClear,
        pageWidget: pageWidget,
        loadBadges: _createBadges,
        loadWidget: _createWidgetForm,
        loadDisplayWidgets: _createDisplayWidgetsUGC,
        loadDisplayWidgetsRewards: _createDisplayWidgetsRewards,
        voteReview: voteReview,
        openUGCModal: _openUGCModal,
        openUGCPhoto: openUGCPhoto,
        initOptions: window.StampedGlobalOptions,
        loadSurveyOptin: loadSurveyOptin,
        closeSurveyOptin: closeSurveyOptin,
        triggerEvent: triggerEventStamped,
        on: addEventListenerStamped,
        jQuery: jQueryStamped,
        stampedLog: stampedLog,
        getOptions: _getOptions,
        setOptions: _setOptions,
        getLoggedInCustomer: _getLoggedInCustomer,
        getDataRewards: _getDataRewards,
        loadLauncherView: _launcherViewLoad,
        scrollLauncherView: _launcherScrollToView,
        toggleLauncher: _toggleRewardsModal,
        toggleRewardsModal: _toggleRewardsModal,
        rewardsApplyCode: _rewardsApplyCode,
        rewardsReferralClaimCode: _rewardsReferralClaimCode,
        rewardsReferralSendEmail: _rewardsReferralSendEmail,
        rewardsLink: _rewardsLink,
        rewardsRedeem: _apiRewardRedeemOld,
        rewardsPointsRefresh: _apiRewardRefreshPoints,
        rewardsReferralCopy: _rewardsCopyReferralCode,
        rewardsCreateActivity: _apiRewardEarn,
        rewardsTriggerEarn: _rewardsTriggerEarn,
        rewardsTriggerSpend: _rewardsTriggerSpend,
        triggerEarnActivity: triggerEarnActivity, // loyalty2023 only
        triggerRedeemActivity: triggerRedeemActivity, // loyalty2023 only
        applyCouponToSubscription: applyCouponToSubscription, // loyalty2023 only
        claimAffiliateProgramReward: claimAffiliateProgramReward, // loyalty2023
        sendAffiliateInvite: sendAffiliateInvite, // loyalty2023
        resetSendAffiliateInvite: resetSendAffiliateInvite, // loyalty2023
        getReviewRequests: getReviewRequests,
        showCardError: showCardError,
        showSnackbar: showSnackbar,
        getLauncherWindow: function () { return $frameWindowDoc; }
    };
}(window, document));